import React, { useState, useEffect, useRef, useCallback } from "react";
import * as sdk from "matrix-js-sdk";
import { logger } from "matrix-js-sdk/lib/logger";



logger.setLevel("silent");

// ── Register Page ─────────────────────────────────────────────
function RegisterPage({ token }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const HOMESERVER = window.location.origin;

  const doRegister = async () => {
    if (!username.trim()) { setError("Введите имя пользователя"); return; }
    if (password.length < 6) { setError("Минимум 6 символов в пароле"); return; }
    if (password !== password2) { setError("Пароли не совпадают"); return; }
    if (!/^[a-z0-9._\-]+$/.test(username)) { setError("Только латинские буквы, цифры, . _ -"); return; }

    setLoading(true); setError("");
    try {
      // Step 1: get flows
      // Step 1: initiate registration to get session
      const r1 = await fetch(`${HOMESERVER}/_matrix/client/v3/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, inhibit_login: false }),
      });
      const d1 = await r1.json();

      // Expect 401 with session token for UIA
      if (r1.status !== 401 || !d1.session) {
        setError(d1.error || `Ошибка [${r1.status}]: ${JSON.stringify(d1)}`);
        return;
      }

      // Step 2: complete with registration token
      const r2 = await fetch(`${HOMESERVER}/_matrix/client/v3/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username, password,
          inhibit_login: false,
          auth: { type: "m.login.registration_token", token, session: d1.session },
        }),
      });
      const d2 = await r2.json();
      const joinRooms = async (accessToken, userId) => {
        try {
          const stored = JSON.parse(localStorage.getItem("nexus_token_rooms") || "{}");
          const rooms = stored[token] || [];
          for (const roomId of rooms) {
            await fetch(`${HOMESERVER}/_matrix/client/v3/join/${encodeURIComponent(roomId)}`, {
              method: "POST", headers: { "Authorization": `Bearer ${accessToken}`, "Content-Type": "application/json" },
              body: JSON.stringify({})
            });
          }
          // cleanup
          delete stored[token];
          localStorage.setItem("nexus_token_rooms", JSON.stringify(stored));
        } catch(e) { console.warn("Auto-join failed:", e); }
      };

      if (r2.ok) {
        if (d2.access_token) await joinRooms(d2.access_token, d2.user_id);
        setDone(true); return;
      }

      // Step 3: some servers also require m.login.dummy after token
      if (r2.status === 401 && d2.session) {
        const r3 = await fetch(`${HOMESERVER}/_matrix/client/v3/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username, password,
            inhibit_login: false,
            auth: { type: "m.login.dummy", session: d2.session },
          }),
        });
        const d3 = await r3.json();
        if (r3.ok) {
          if (d3.access_token) await joinRooms(d3.access_token, d3.user_id);
          setDone(true); return;
        }
        setError(d3.error || `Ошибка [${r3.status}]: ${JSON.stringify(d3)}`);
      } else {
        setError(d2.error || `Ошибка [${r2.status}]: ${JSON.stringify(d2)}`);
      }
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <><style>{`
      @import url('https://fonts.googleapis.com/css2?family=Share+Tech+Mono&family=Orbitron:wght@700&display=swap');
      *{box-sizing:border-box;margin:0;padding:0}
      body{background:#000;font-family:'Share Tech Mono',monospace}
      .rg-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;background:#000;position:relative;overflow:hidden}
      .rg-wrap::before{content:'';position:fixed;inset:0;background:repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(0,255,65,0.015) 2px,rgba(0,255,65,0.015) 4px);pointer-events:none;z-index:0}
      .rg-card{position:relative;z-index:1;width:380px;background:#0a0a0a;border:1px solid #00ff4133;padding:32px;clip-path:polygon(10px 0%,100% 0%,calc(100% - 10px) 100%,0% 100%);box-shadow:0 0 40px rgba(0,255,65,0.08)}
      .rg-logo{font-family:'Orbitron',monospace;font-size:22px;font-weight:700;color:#00ff41;text-shadow:0 0 20px #00ff41;letter-spacing:.2em;margin-bottom:4px}
      .rg-sub{font-size:10px;color:#008a20;letter-spacing:.15em;margin-bottom:24px}
      .rg-label{font-size:10px;color:#008a20;letter-spacing:.1em;margin-bottom:5px;margin-top:14px}
      .rg-input{width:100%;background:#111;border:1px solid #00ff4122;padding:9px 11px;color:#00ff41;font-family:'Share Tech Mono',monospace;font-size:13px;outline:none;transition:border .15s}
      .rg-input:focus{border-color:#00ff4166;box-shadow:0 0 8px rgba(0,255,65,0.1)}
      .rg-btn{width:100%;margin-top:20px;padding:11px;background:#001a00;border:1px solid #00ff41;color:#00ff41;font-family:'Orbitron',monospace;font-size:12px;font-weight:700;cursor:pointer;letter-spacing:.15em;clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);transition:all .15s;text-shadow:0 0 8px #00ff41;box-shadow:0 0 12px rgba(0,255,65,0.15)}
      .rg-btn:hover:not(:disabled){background:#003300;box-shadow:0 0 20px rgba(0,255,65,0.25)}
      .rg-btn:disabled{opacity:.5;cursor:not-allowed}
      .rg-err{margin-top:12px;padding:8px 10px;background:rgba(255,49,49,.07);border:1px solid rgba(255,49,49,.3);color:#ff3131;font-size:11px}
      .rg-done{text-align:center;padding:20px 0}
      .rg-done-icon{font-size:36px;color:#00ff41;text-shadow:0 0 20px #00ff41;margin-bottom:12px}
      .rg-done-text{font-size:13px;color:#00ff41;margin-bottom:8px}
      .rg-done-sub{font-size:11px;color:#008a20;margin-bottom:20px}
      .rg-link{display:inline-block;padding:9px 20px;border:1px solid #00ff41;color:#00ff41;font-family:'Orbitron',monospace;font-size:11px;cursor:pointer;letter-spacing:.1em;text-decoration:none;clip-path:polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)}
      .rg-token{font-size:10px;color:#008a20;margin-top:16px;padding:6px 8px;border:1px solid #00ff4122;background:#050505}
    `}</style>
    <div className="rg-wrap">
      <div className="rg-card">
        <div className="rg-logo">NEXUS<span style={{color:'#008a20'}}>_</span></div>
        <div className="rg-sub">SECURE MATRIX CLIENT // РЕГИСТРАЦИЯ</div>
        {done ? (
          <div className="rg-done">
            <div className="rg-done-icon">✓</div>
            <div className="rg-done-text">Аккаунт создан!</div>
            <div className="rg-done-sub">Вы можете войти в систему</div>
            <a href="/" className="rg-link">[ ВОЙТИ ]</a>
          </div>
        ) : (
          <>
            <div className="rg-label">ИМЯ ПОЛЬЗОВАТЕЛЯ</div>
            <input className="rg-input" placeholder="username" value={username}
              onChange={e => setUsername(e.target.value.toLowerCase())}
              onKeyDown={e => e.key === "Enter" && doRegister()} autoFocus />
            <div className="rg-label">ПАРОЛЬ</div>
            <input className="rg-input" type="password" placeholder="••••••••" value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === "Enter" && doRegister()} />
            <div className="rg-label">ПОВТОРИТЕ ПАРОЛЬ</div>
            <input className="rg-input" type="password" placeholder="••••••••" value={password2}
              onChange={e => setPassword2(e.target.value)}
              onKeyDown={e => e.key === "Enter" && doRegister()} />
            {error && <div className="rg-err">⚠ {error}</div>}
            <button className="rg-btn" onClick={doRegister} disabled={loading}>
              {loading ? "[ СОЗДАНИЕ... ]" : "[ ЗАРЕГИСТРИРОВАТЬСЯ ]"}
            </button>
            <div className="rg-token">🔑 Токен приглашения: {token || "не указан"}</div>
          </>
        )}
      </div>
    </div></>
  );
}


const HOMESERVER = "https://chat.hipogas.org";

const FONTS = `@import url('https://fonts.googleapis.com/css2?family=Share+Tech+Mono&family=Orbitron:wght@400;700;900&family=Courier+Prime:ital,wght@0,400;1,400&family=Fira+Code:wght@400;500&family=JetBrains+Mono:wght@400;500&family=Space+Mono:ital,wght@0,400;1,400&family=Ubuntu+Mono&display=swap');`;

const css = `
${FONTS}
*,*::before,*::after{margin:0;padding:0;box-sizing:border-box}
:root{
  --g:#00ff41;--gd:#00c832;--dk:#003d10;--glow:rgba(0,255,65,0.15);
  --am:#ffb000;--rd:#ff3131;--cy:#00ffff;
  --bg:#020c02;--pan:#040f04;--inp:#010801;
  --bor:rgba(0,255,65,0.2);--borb:rgba(0,255,65,0.5);
  --mono:'Share Tech Mono',monospace;--disp:'Orbitron',monospace;

}
/* Chat font/size applied via inline style on .msgs */
.msgs .msg-bubble { font-family:var(--chat-font,'Share Tech Mono',monospace); font-size:var(--chat-size,14px); }
.msgs .msg-who { font-size:11px; font-family:var(--chat-font,'Share Tech Mono',monospace); }
.msgs .msg-time { font-size:10px; }
html,body{height:100%;background:var(--bg);color:var(--g);font-family:var(--mono);overflow:hidden}
::-webkit-scrollbar{width:2px}::-webkit-scrollbar-thumb{background:var(--dk)}
.crt::before{content:'';position:fixed;inset:0;pointer-events:none;z-index:1000;
  background:repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(0,255,65,0.03) 2px,rgba(0,255,65,0.03) 4px);
  animation:scanRoll 8s linear infinite}
.crt::after{content:'';position:fixed;inset:0;background:radial-gradient(ellipse at center,transparent 60%,rgba(0,0,0,0.4) 100%);pointer-events:none;z-index:999}
@keyframes scanRoll{0%{background-position:0 0}100%{background-position:0 100px}}
@keyframes blink{0%,49%{opacity:1}50%,100%{opacity:0}}
@keyframes fadeIn{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}
@keyframes glitch{0%,90%,100%{transform:translate(0)}91%{transform:translate(-2px,1px)}93%{transform:translate(2px,-1px)}95%{transform:translate(0)}}
@keyframes pulse{0%,100%{box-shadow:0 0 4px var(--g)}50%{box-shadow:0 0 16px var(--g),0 0 32px var(--glow)}}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes bootLine{from{opacity:0;transform:translateX(-8px)}to{opacity:1;transform:none}}
@keyframes slideIn{from{opacity:0;transform:translateX(20px)}to{opacity:1;transform:none}}

.boot{position:fixed;inset:0;background:var(--bg);display:flex;flex-direction:column;justify-content:center;align-items:center;padding:60px;z-index:500}
.boot-line{font-size:14px;color:var(--g);margin-bottom:6px;opacity:0;animation:bootLine 0.3s forwards;text-shadow:0 0 8px var(--g)}
.boot-line.amber{color:var(--am);text-shadow:0 0 8px var(--am)}.boot-line.cyan{color:var(--cy);text-shadow:0 0 8px var(--cy)}
.boot-line.big{font-family:var(--disp);font-size:28px;font-weight:900;margin:20px 0;letter-spacing:0.2em}
.boot-cursor{display:inline-block;width:10px;height:16px;background:var(--g);animation:blink 0.7s infinite;vertical-align:middle;margin-left:4px}
.boot-bar{width:300px;height:2px;background:var(--dk);margin:16px 0;border:1px solid var(--bor)}
.boot-bar-fill{height:100%;background:var(--g);box-shadow:0 0 8px var(--g);transition:width 0.1s}
.rain-canvas{position:fixed;inset:0;z-index:0;opacity:0.04;pointer-events:none}

.app{display:flex;height:100vh;position:relative;z-index:1}

.sidebar{width:56px;background:var(--pan);border-right:1px solid var(--bor);display:flex;flex-direction:column;align-items:center;padding:12px 0;gap:4px;flex-shrink:0}
.sb-logo{font-family:var(--disp);font-size:11px;font-weight:900;color:var(--g);text-shadow:0 0 12px var(--g);letter-spacing:0.1em;writing-mode:vertical-rl;margin-bottom:16px;margin-top:4px}
.sb-icon{width:36px;height:36px;border:1px solid var(--bor);display:flex;align-items:center;justify-content:center;font-size:18px;cursor:pointer;color:var(--gd);transition:all 0.15s;clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%)}
.sb-icon:hover,.sb-icon.active{background:var(--glow);border-color:var(--borb);color:var(--g);text-shadow:0 0 8px var(--g);box-shadow:0 0 12px var(--glow)}
.sb-div{width:28px;height:1px;background:var(--bor);margin:6px 0}
.sb-user{margin-top:auto;width:34px;height:34px;border:1px solid var(--borb);display:flex;align-items:center;justify-content:center;font-size:11px;cursor:pointer;color:var(--g);font-family:var(--disp);font-weight:700;clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);background:var(--glow);animation:pulse 3s infinite}

.rooms{width:240px;background:var(--pan);border-right:1px solid var(--bor);display:flex;flex-direction:column;flex-shrink:0}
.rooms-header{padding:16px 12px 10px;border-bottom:1px solid var(--bor)}
.rooms-title{font-family:var(--disp);font-size:10px;font-weight:700;color:var(--g);letter-spacing:0.15em;text-shadow:0 0 8px var(--g);margin-bottom:10px}
.rooms-title span{color:var(--am)}
.search-box{background:var(--inp);border:1px solid var(--bor);padding:6px 8px;display:flex;align-items:center;gap:6px;clip-path:polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)}
.search-box input{background:none;border:none;outline:none;color:var(--g);font-family:var(--mono);font-size:12px;width:100%}
.search-box input::placeholder{color:var(--dk)}
.rooms-list{flex:1;overflow-y:auto;padding:4px 0}
.sec-label{font-size:10px;color:#008a20;padding:10px 12px 4px;letter-spacing:0.12em;display:flex;align-items:center;gap:6px}
.sec-label::after{content:'';flex:1;height:1px;background:var(--bor)}
.sec-add{cursor:pointer;color:var(--gd);font-size:18px;transition:color 0.1s;line-height:1;flex-shrink:0;padding:0 2px}
.sec-add:hover{color:var(--g);text-shadow:0 0 6px var(--g)}
.room-item{padding:7px 12px;cursor:pointer;display:flex;align-items:center;gap:8px;transition:all 0.1s;border-left:2px solid transparent;position:relative}
.room-item:hover{background:var(--glow);border-left-color:#005510}
.room-item:hover .room-gear{opacity:1 !important}
.room-item.active{background:var(--glow);border-left-color:var(--g);box-shadow:inset 0 0 20px var(--glow)}
.room-sigil{font-size:11px;color:#005510;width:12px;text-align:center;flex-shrink:0}
.room-item.active .room-sigil{color:var(--g);text-shadow:0 0 6px var(--g)}
.room-body{flex:1;min-width:0}
.room-name{font-size:12px;color:#007a20;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.room-item.active .room-name{color:var(--g);text-shadow:0 0 6px var(--g)}
.room-preview{font-size:10px;color:#007020;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:1px}
.room-meta{display:flex;flex-direction:column;align-items:flex-end;gap:3px}
.room-time{font-size:9px;color:#007a20}
.room-unread{font-size:9px;color:var(--bg);background:var(--g);padding:1px 4px;clip-path:polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%);font-weight:bold;box-shadow:0 0 6px var(--g)}
.room-status{width:6px;height:6px;border-radius:50%;flex-shrink:0}

.chat{flex:1;display:flex;flex-direction:column;min-width:0;position:relative;background:var(--bg)}
.chat-header{height:48px;padding:0 16px;border-bottom:1px solid var(--bor);background:var(--pan);display:flex;align-items:center;gap:10px;flex-shrink:0}
.chat-header-row1,.chat-header-row2{display:contents}
.ch-prefix{color:var(--gd);font-size:13px}
.ch-name{font-family:var(--disp);font-size:12px;font-weight:700;color:var(--g);text-shadow:0 0 10px var(--g);letter-spacing:0.1em;animation:glitch 15s infinite}
.ch-sep{color:var(--bor)}
.ch-sub{font-size:10px;color:#008a20;flex:1}
.ch-sub span{color:var(--gd)}
.hbtn{width:28px;height:28px;border:1px solid var(--bor);background:rgba(0,255,65,0.05);color:var(--gd);cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;clip-path:polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%);transition:all 0.12s}
.hbtn:hover,.hbtn.on{background:var(--glow);border-color:var(--g);color:var(--g);box-shadow:0 0 8px var(--glow)}
.e2ee-badge{display:flex;align-items:center;gap:4px;font-size:9px;color:var(--g);border:1px solid var(--bor);padding:3px 6px;clip-path:polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%);text-shadow:0 0 6px var(--g)}

.msgs{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:1px;background:transparent}
.day-sep{display:flex;align-items:center;gap:8px;margin:12px 0;font-size:10px;color:var(--dk);letter-spacing:0.1em}
.day-sep::before,.day-sep::after{content:'';flex:1;height:1px;background:var(--bor)}
.sys-msg{text-align:center;font-size:10px;color:#009020;padding:4px;letter-spacing:0.05em}
.poll-widget{background:var(--inp);border:1px solid var(--borb);padding:14px 16px;min-width:260px;max-width:340px;box-shadow:0 0 12px var(--glow)}
.poll-question{font-size:13px;color:var(--g);font-family:var(--disp);letter-spacing:0.06em;margin-bottom:3px;font-weight:700}
.poll-meta{font-size:9px;color:var(--gd);letter-spacing:0.08em;margin-bottom:11px;opacity:0.7}
.poll-option{margin-bottom:6px;cursor:pointer;border:2px solid var(--bor);padding:8px 12px;position:relative;overflow:hidden;transition:all 0.15s;user-select:none;display:flex;align-items:center;gap:10px}
.poll-option:hover{border-color:var(--g);background:rgba(0,255,65,0.05)}
.poll-option:active{transform:scale(0.98)}
.poll-option.voted{border-color:var(--g);background:rgba(0,255,65,0.07)}
.poll-bar{position:absolute;top:0;left:0;height:100%;background:rgba(0,255,65,0.07);transition:width 0.5s ease;z-index:0;pointer-events:none}
.poll-option.voted .poll-bar{background:rgba(0,255,65,0.13)}
.poll-radio{width:16px;height:16px;border-radius:50%;border:2px solid var(--gd);flex-shrink:0;display:flex;align-items:center;justify-content:center;transition:all 0.15s;position:relative;z-index:1}
.poll-option.voted .poll-radio{border-color:var(--g);background:var(--g)}
.poll-radio-dot{width:6px;height:6px;border-radius:50%;background:var(--dk);opacity:0;transition:opacity 0.15s}
.poll-option.voted .poll-radio-dot{opacity:1}
.poll-option-label{position:relative;z-index:1;font-size:12px;color:var(--g);flex:1}
.poll-option-right{position:relative;z-index:1;margin-left:auto;display:flex;align-items:center;gap:6px;flex-shrink:0}
.poll-option-pct{font-size:10px;color:var(--g);font-family:var(--mono);min-width:32px;text-align:right;font-weight:700}
.poll-option-count{font-size:10px;color:var(--gd);font-family:var(--mono)}
.poll-footer{margin-top:10px;font-size:9px;color:var(--gd);letter-spacing:0.1em;display:flex;justify-content:space-between;padding-top:8px;border-top:1px solid var(--bor);opacity:0.7}
.call-overlay{position:fixed;inset:0;z-index:200;background:rgba(0,0,0,0.92);display:flex;flex-direction:column;align-items:center;justify-content:center;backdrop-filter:blur(8px)}
.lk-overlay{position:fixed;inset:0;z-index:10001;background:#000;display:flex;flex-direction:column;overflow:hidden}
.call-box{background:var(--pan);border:1px solid var(--borb);padding:32px 40px;min-width:340px;max-width:480px;width:100%;box-shadow:0 0 60px var(--glow);clip-path:polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%);display:flex;flex-direction:column;align-items:center;gap:16px;position:relative}
.call-avatar{width:72px;height:72px;border:2px solid var(--g);display:flex;align-items:center;justify-content:center;font-family:var(--disp);font-size:24px;font-weight:700;color:var(--g);text-shadow:0 0 12px var(--g);clip-path:polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%);background:var(--dk)}
.call-name{font-family:var(--disp);font-size:16px;font-weight:700;color:var(--g);letter-spacing:0.15em;text-shadow:0 0 10px var(--g)}
.call-status{font-size:10px;color:var(--gd);letter-spacing:0.15em;animation:pulse 1.5s infinite}
.call-timer{font-family:var(--mono);font-size:14px;color:var(--g);letter-spacing:0.1em}
.call-btns{display:flex;gap:12px;margin-top:8px;justify-content:center;flex-shrink:0;padding-bottom:env(safe-area-inset-bottom,0px)}
.call-btn{width:52px;height:52px;border:none;border-radius:50%;cursor:pointer;font-size:20px;display:flex;align-items:center;justify-content:center;transition:all 0.15s;flex-shrink:0}
.call-btn.end{background:#cc2222;color:#fff}.call-btn.end:hover{background:#ff3333}
.call-btn.mute{background:var(--inp);color:var(--g);border:1px solid var(--bor)}.call-btn.mute:hover{border-color:var(--g)}
.call-btn.mute.active{background:var(--am);color:var(--dk);border-color:var(--am)}
.call-btn.cam{background:var(--inp);color:var(--g);border:1px solid var(--bor)}.call-btn.cam:hover{border-color:var(--g)}
.call-btn.cam.active{background:#444;color:#888;border-color:#444}
.call-btn.answer{background:#1a8c1a;color:#fff}.call-btn.answer:hover{background:#22bb22}
.call-videos{display:flex;gap:8px;width:100%;position:relative}
.call-video-main{flex:1;background:#000;border:1px solid var(--bor);min-height:200px;position:relative;overflow:hidden}
.call-video-main video{width:100%;height:100%;object-fit:cover;display:block}
.call-video-self{width:120px;height:90px;background:#111;border:1px solid var(--borb);position:absolute;bottom:8px;right:8px;overflow:hidden;z-index:2}
.call-video-self video{width:100%;height:100%;object-fit:cover;display:block}
.call-jitsi{width:100%;height:70vh;border:none;display:block}
.incoming-call{position:fixed;bottom:80px;left:50%;transform:translateX(-50%);z-index:300;background:var(--pan);border:1px solid var(--g);padding:16px 20px;box-shadow:0 0 30px var(--glow);min-width:280px;max-width:400px;width:90%;animation:slideUp 0.3s;border-radius:4px}
.incoming-call-name{font-family:var(--disp);font-size:13px;color:var(--g);margin-bottom:4px}
.incoming-call-sub{font-size:10px;color:var(--gd);margin-bottom:12px;letter-spacing:0.1em}
.incoming-call-btns{display:flex;gap:8px}
.sys-msg span{color:#006520}
.msg-row{display:flex;gap:8px;padding:3px 0;animation:fadeIn 0.2s ease}
.msg-row.own{flex-direction:row-reverse}
.msg-av{width:28px;height:28px;flex-shrink:0;border:1px solid var(--bor);display:flex;align-items:center;justify-content:center;font-size:10px;clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);background:var(--pan);color:var(--gd);font-family:var(--disp);font-weight:700}
.msg-av.ghost{opacity:0;pointer-events:none}
.msg-wrap{display:flex;flex-direction:column;max-width:65%}
.msg-row.own .msg-wrap{align-items:flex-end}
.msg-who{font-size:10px;color:#006520;margin-bottom:2px;padding:0 2px;letter-spacing:0.05em}
.msg-who::before{content:'[';color:var(--bor)}.msg-who::after{content:']';color:var(--bor)}
.msg-bubble{padding:8px 12px;font-size:13px;line-height:1.5;word-break:break-word}
.msg-bubble.other{background:var(--pan);border:1px solid var(--bor);border-left:2px solid #005510;clip-path:polygon(0 0,100% 0,100% calc(100% - 4px),calc(100% - 4px) 100%,0 100%)}
.msg-bubble.own{background:var(--dk);border:1px solid var(--gd);border-right:2px solid var(--g);clip-path:polygon(4px 0,100% 0,100% 100%,0 calc(100% - 4px),0 4px);color:var(--g);box-shadow:0 0 12px var(--glow)}
.msg-time{font-size:9px;color:#00a040;margin-top:3px;display:block;opacity:1;}
.msg-row.own .msg-time{text-align:right;color:#00cc50;}

.typing{display:flex;align-items:center;gap:8px;padding:4px 0 8px;font-size:11px;color:#005510}
.typing-dots{display:flex;gap:3px}
.typing-dot{width:5px;height:5px;background:#005510;clip-path:polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%);animation:blink 0.8s infinite}
.typing-dot:nth-child(2){animation-delay:0.2s}.typing-dot:nth-child(3){animation-delay:0.4s}

.input-area{padding:10px 16px 14px;background:var(--pan);border-top:1px solid var(--bor);flex-shrink:0}
.input-row{display:flex;align-items:flex-end;gap:8px;background:var(--inp);border:1px solid var(--bor);padding:8px 10px;clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);transition:all 0.15s}
.input-row:focus-within{border-color:var(--gd);box-shadow:0 0 16px var(--glow),inset 0 0 8px var(--glow)}
.input-prefix{color:var(--g);font-size:12px;padding-bottom:3px;flex-shrink:0;white-space:nowrap;max-width:180px;overflow:hidden;text-overflow:ellipsis}
.input-field{flex:1;background:none;border:none;outline:none;color:var(--g);font-family:var(--mono);font-size:13px;resize:none;max-height:100px;line-height:1.5;caret-color:var(--g)}
.input-field::placeholder{color:var(--dk)}
.send-btn{width:32px;height:32px;background:var(--dk);border:1px solid var(--g);color:var(--g);cursor:pointer;font-size:14px;clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);transition:all 0.12s;flex-shrink:0;display:flex;align-items:center;justify-content:center;box-shadow:0 0 8px var(--glow)}
.send-btn:hover{background:var(--glow);box-shadow:0 0 16px var(--glow)}
.send-btn:disabled{opacity:0.2;cursor:default;box-shadow:none}
.input-hint{font-size:9px;color:#008a20;margin-top:5px;letter-spacing:0.05em}

.members{width:200px;background:var(--pan);border-left:1px solid var(--bor);overflow-y:auto;padding:12px 0;flex-shrink:0}
.members-title{font-size:10px;color:#008a20;padding:0 12px 8px;letter-spacing:0.12em;border-bottom:1px solid var(--bor);margin-bottom:6px}
.members-title span{color:var(--g)}
.m-sec{font-size:9px;color:#008a20;padding:8px 12px 4px;letter-spacing:0.1em}
.m-item{display:flex;align-items:center;gap:6px;padding:5px 12px;cursor:pointer;transition:background 0.1s}
.m-item:hover{background:var(--glow)}
.m-dot{width:5px;height:5px;border-radius:50%;flex-shrink:0}
.m-name{font-size:11px;color:var(--gd);flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.m-item:hover .m-name{color:var(--g)}
.m-role{font-size:8px;color:var(--am);letter-spacing:0.1em}

.login{position:fixed;inset:0;background:var(--bg);display:flex;align-items:center;justify-content:center;z-index:100;flex-direction:column}
.login-card{border:1px solid var(--borb);padding:40px;width:420px;background:var(--pan);clip-path:polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%);box-shadow:0 0 40px var(--glow)}
.login-logo{font-family:var(--disp);font-size:26px;font-weight:900;color:var(--g);text-shadow:0 0 20px var(--g);letter-spacing:0.2em;margin-bottom:4px;animation:glitch 6s infinite}
.login-sub{font-size:11px;color:#005510;margin-bottom:32px;letter-spacing:0.05em}
.login-sub span{color:var(--am)}
.lf{margin-bottom:16px}
.lf-label{font-size:10px;color:#005510;margin-bottom:5px;letter-spacing:0.1em}
.lf-label::before{content:'> ';color:var(--g)}
.lf-input{width:100%;background:var(--inp);border:1px solid var(--bor);padding:10px 12px;color:var(--g);font-family:var(--mono);font-size:13px;outline:none;clip-path:polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%);transition:all 0.15s;caret-color:var(--g)}
.lf-input:focus{border-color:var(--g);box-shadow:0 0 12px var(--glow)}
.lf-input::placeholder{color:var(--dk)}
.lf-input:-webkit-autofill,.lf-input:-webkit-autofill:hover,.lf-input:-webkit-autofill:focus{-webkit-text-fill-color:var(--g);-webkit-box-shadow:0 0 0px 1000px var(--inp) inset;transition:background-color 5000s ease-in-out 0s;caret-color:var(--g)}
.modal-input:-webkit-autofill,.modal-input:-webkit-autofill:hover,.modal-input:-webkit-autofill:focus{-webkit-text-fill-color:var(--g);-webkit-box-shadow:0 0 0px 1000px var(--inp) inset;transition:background-color 5000s ease-in-out 0s}
.login-btn{width:100%;margin-top:8px;background:var(--dk);border:1px solid var(--g);padding:12px;color:var(--g);font-family:var(--disp);font-size:13px;font-weight:700;cursor:pointer;letter-spacing:0.2em;clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);transition:all 0.15s;box-shadow:0 0 16px var(--glow);text-shadow:0 0 8px var(--g)}
.login-btn:hover{background:var(--glow);box-shadow:0 0 30px var(--glow)}
.login-btn:disabled{opacity:0.4;cursor:default}
.login-error{margin-top:12px;font-size:11px;color:var(--rd);text-align:center;letter-spacing:0.05em;text-shadow:0 0 6px var(--rd)}

.modal-bg{position:fixed;inset:0;background:rgba(0,0,0,0.75);z-index:200;display:flex;align-items:center;justify-content:center;animation:fadeIn 0.15s}
.modal{background:var(--pan);border:1px solid var(--borb);padding:28px;width:360px;clip-path:polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%);box-shadow:0 0 30px var(--glow);animation:slideIn 0.2s}
.modal-title{font-family:var(--disp);font-size:12px;font-weight:700;color:var(--g);text-shadow:0 0 8px var(--g);letter-spacing:0.15em;margin-bottom:20px}
.modal-field{margin-bottom:14px}
.modal-label{font-size:10px;color:#005510;margin-bottom:5px;letter-spacing:0.1em}
.modal-label::before{content:'> ';color:var(--g)}
.modal-input{width:100%;background:var(--inp);border:1px solid var(--bor);padding:8px 10px;color:var(--g);font-family:var(--mono);font-size:12px;outline:none;clip-path:polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%);transition:all 0.15s;caret-color:var(--g)}
.modal-input:focus{border-color:var(--g);box-shadow:0 0 8px var(--glow)}
.modal-input::placeholder{color:var(--dk)}
.modal-check{display:flex;align-items:center;gap:8px;cursor:pointer;font-size:11px;color:#005510;margin-bottom:14px;user-select:none}
.modal-check input{accent-color:var(--g);width:14px;height:14px;cursor:pointer}
.modal-check:hover{color:var(--g)}
.modal-btns{display:flex;gap:8px;margin-top:20px}
.modal-btn{flex:1;padding:10px;border:1px solid var(--bor);background:none;color:#005510;font-family:var(--mono);font-size:12px;cursor:pointer;clip-path:polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%);transition:all 0.15s;letter-spacing:0.05em}
.modal-btn:hover{background:var(--glow);border-color:var(--g);color:var(--g)}
.modal-btn.primary{background:var(--dk);border-color:var(--g);color:var(--g);box-shadow:0 0 8px var(--glow)}
.modal-btn.primary:hover{background:var(--glow);box-shadow:0 0 16px var(--glow)}
.modal-btn:disabled{opacity:0.3;cursor:default}

.settings-panel{width:220px;background:var(--pan);border-left:1px solid var(--bor);display:flex;flex-direction:column;flex-shrink:0;animation:slideIn 0.2s;overflow-y:auto}
.sp-header{padding:16px 14px;border-bottom:1px solid var(--bor)}
.sp-title{font-family:var(--disp);font-size:11px;font-weight:700;color:var(--g);letter-spacing:0.15em;text-shadow:0 0 8px var(--g)}
.sp-section{padding:12px 14px;border-bottom:1px solid var(--bor)}
.sp-sec-title{font-size:9px;color:#008a20;letter-spacing:0.15em;margin-bottom:10px}
.sp-profile{display:flex;align-items:center;gap:10px;padding:4px 0 8px}
.sp-av{width:36px;height:36px;background:var(--dk);border:1px solid var(--borb);display:flex;align-items:center;justify-content:center;font-family:var(--disp);font-size:12px;font-weight:700;color:var(--g);clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);flex-shrink:0}
.sp-username{font-size:12px;color:var(--g);text-shadow:0 0 6px var(--g)}
.sp-userid{font-size:9px;color:#005510;margin-top:2px;word-break:break-all}
.sp-item{display:flex;align-items:center;gap:8px;padding:8px 6px;cursor:pointer;border:1px solid transparent;clip-path:polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%);transition:all 0.12s;margin-bottom:3px}
.sp-item:hover{background:var(--glow);border-color:var(--bor)}
.sp-item-icon{font-size:13px;width:20px;text-align:center;color:var(--gd)}
.sp-item:hover .sp-item-icon{color:var(--g)}
.sp-item-label{font-size:12px;color:var(--gd)}
.sp-item:hover .sp-item-label{color:var(--g)}
.sp-item.danger:hover{background:rgba(255,49,49,0.1);border-color:var(--rd)}
.sp-item.danger:hover .sp-item-icon,.sp-item.danger:hover .sp-item-label{color:var(--rd)}

.notif{position:fixed;top:16px;right:16px;border:1px solid var(--borb);background:var(--pan);padding:12px 16px;z-index:300;clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);box-shadow:0 0 20px var(--glow);animation:fadeIn 0.2s ease;max-width:300px;display:flex;gap:10px;align-items:flex-start}
.notif-tag{font-size:10px;color:var(--am);flex-shrink:0;letter-spacing:0.05em}
.notif-title{font-size:11px;color:var(--g);letter-spacing:0.05em}
.notif-text{font-size:10px;color:#005510;margin-top:2px}

.loading,.empty{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px}
.spinner{width:32px;height:32px;border:2px solid var(--dk);border-top-color:var(--g);border-radius:50%;animation:spin 0.8s linear infinite;box-shadow:0 0 12px var(--glow)}
.status-text{font-family:var(--disp);font-size:12px;color:#005510;letter-spacing:0.15em}
.blink{animation:blink 1s infinite}

/* ── FONT SIZE IMPROVEMENTS ── */

.room-name { font-size: 13px !important; }
.room-preview { font-size: 11px !important; }
.m-name { font-size: 12px !important; }
.sec-label { font-size: 11px !important; }

.room-time { font-size: 10px !important; }

.input-field { font-size: 14px !important; }

/* ── AVATAR STYLES ── */
.av-img { width:100%; height:100%; object-fit:cover; }
.av-upload { cursor:pointer; position:relative; }
.av-upload:hover::after { content:"📷"; position:absolute; inset:0; background:rgba(0,0,0,0.6); display:flex; align-items:center; justify-content:center; font-size:14px; }

/* ── FILE MESSAGE ── */
.msg-file { display:flex; align-items:center; gap:10px; padding:10px 14px; border:1px solid var(--bor); background:var(--inp); cursor:pointer; transition:all 0.12s; }
.msg-file:hover { border-color:var(--g); background:var(--glow); }
.msg-file-icon { font-size:20px; flex-shrink:0; }
.msg-file-info { flex:1; min-width:0; }
.msg-file-name { font-size:12px; color:var(--g); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.msg-file-size { font-size:10px; color:var(--gd); margin-top:2px; }
.msg-img { max-width:280px; max-height:200px; object-fit:cover; border:1px solid var(--bor); cursor:pointer; transition:all 0.12s; display:block; }
.msg-img:hover { border-color:var(--g); box-shadow:0 0 12px var(--glow); }

/* ── FILE INPUT BUTTON ── */
.file-btn { width:32px; height:32px; background:none; border:1px solid var(--bor); color:var(--gd); cursor:pointer; font-size:15px; clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%); transition:all 0.12s; flex-shrink:0; display:flex; align-items:center; justify-content:center; }
.file-btn:hover { background:var(--glow); border-color:var(--g); color:var(--g); }
/* EMOJI PICKER */
.emoji-popup { position:absolute; bottom:60px; right:16px; background:var(--pan); border:1px solid var(--borb); width:340px; z-index:50; box-shadow:0 0 30px var(--glow); clip-path:polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%); animation:fadeIn 0.15s; }
.emoji-tabs { display:flex; border-bottom:1px solid var(--bor); overflow-x:auto; scrollbar-width:none; }
.emoji-tabs::-webkit-scrollbar { display:none; }
.emoji-tab { padding:8px 12px; font-size:16px; cursor:pointer; opacity:0.5; border-bottom:2px solid transparent; flex-shrink:0; transition:all 0.1s; }
.emoji-tab:hover,.emoji-tab.active { opacity:1; border-bottom-color:var(--g); background:var(--glow); }
.emoji-search { padding:6px 10px; border-bottom:1px solid var(--bor); }
.emoji-search input { width:100%; background:var(--inp); border:1px solid var(--bor); padding:5px 8px; color:var(--g); font-family:var(--mono); font-size:11px; outline:none; }
.emoji-grid { display:grid; grid-template-columns:repeat(8,1fr); gap:2px; padding:8px; max-height:200px; overflow-y:auto; }
.emoji-btn { font-size:20px; padding:4px; cursor:pointer; border-radius:4px; text-align:center; border:none; background:none; transition:background 0.1s; line-height:1.3; }
.emoji-btn:hover { background:var(--glow); }
.sticker-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:6px; padding:10px; max-height:220px; overflow-y:auto; }
.sticker-btn { font-size:36px; padding:8px; cursor:pointer; border:1px solid var(--bor); background:var(--inp); text-align:center; transition:all 0.1s; border-radius:0; clip-path:polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%); }
.sticker-btn:hover { background:var(--glow); border-color:var(--g); transform:scale(1.05); }
.msg-sticker { font-size:48px; line-height:1.2; display:block; padding:4px 0; cursor:default; }
/* MSG CONTEXT MENU */
.msg-ctx { position:fixed; background:var(--pan); border:1px solid var(--borb); min-width:190px; z-index:400; box-shadow:0 0 24px var(--glow); clip-path:polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%); animation:fadeIn 0.1s; }
.msg-ctx-item { display:flex; align-items:center; gap:9px; padding:9px 14px; cursor:pointer; font-size:12px; color:var(--gd); transition:all 0.1s; border-left:2px solid transparent; white-space:nowrap; }
.msg-ctx-item:hover { background:var(--glow); border-left-color:var(--g); color:var(--g); }
.msg-ctx-item.danger:hover { background:rgba(255,49,49,0.08); border-left-color:var(--rd); color:var(--rd); }
.msg-ctx-sep { height:1px; background:var(--bor); margin:3px 0; }
/* REACTIONS */
.msg-reactions { display:flex; flex-wrap:wrap; gap:3px; margin-top:4px; }
.msg-reaction { display:inline-flex; align-items:center; gap:3px; padding:2px 7px; border:1px solid var(--bor); background:var(--inp); font-size:14px; cursor:pointer; transition:all 0.12s; clip-path:polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%); }
.msg-reaction:hover,.msg-reaction.own { border-color:var(--g); background:var(--glow); }
.msg-reaction-count { font-size:10px; color:var(--gd); font-family:var(--mono); }
/* QUOTE */
.msg-quote { border-left:2px solid var(--gd); padding:3px 8px; margin-bottom:5px; opacity:0.65; font-size:11px; color:var(--gd); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:300px; background:rgba(0,0,0,0.2); }
.quote-bar { display:flex; align-items:center; gap:8px; padding:6px 10px; background:var(--inp); border:1px solid var(--bor); border-left:3px solid var(--g); margin-bottom:6px; font-size:11px; }
.msg-reaction { display:inline-flex; align-items:center; gap:3px; padding:2px 7px; border:1px solid var(--bor); background:var(--inp); font-size:13px; cursor:pointer; margin:2px 2px 0 0; transition:all 0.1s; clip-path:polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%); }
.msg-reaction:hover,.msg-reaction.own { border-color:var(--g); background:var(--glow); }
.msg-reaction-count { font-size:10px; color:var(--gd); font-family:var(--mono); }

/* ── LIGHT THEME ── */
.light-theme { --g:#006400; --gd:#007a00; --dk:#c8e6c9; --glow:rgba(0,100,0,0.08);
  --am:#b45309; --bg:#f0f4f0; --pan:#e8f0e8; --inp:#ffffff;
  --bor:rgba(0,100,0,0.2); --borb:rgba(0,100,0,0.5); color:#1a3a1a; }
.light-theme .msgs { background:#f8faf8; }
.light-theme .room-name { color:#2d5a2d; }
.light-theme .room-item.active .room-name { color:var(--g); }
.light-theme .msg-bubble.other { background:#e8f0e8; border-color:rgba(0,100,0,0.25); }
.light-theme .msg-bubble.own { background:#c8e6c9; border-color:var(--gd); color:#1a3a1a; box-shadow:none; }
.light-theme .msg-who { color:#4a7a4a; }
.light-theme .ch-name { color:var(--g); text-shadow:none; }
.light-theme .e2ee-badge { color:var(--g); }
.light-theme .sb-icon:hover,.light-theme .sb-icon.active { box-shadow:none; }
.light-theme .crt::before { display:none; }
.light-theme .crt::after { display:none; }
.light-theme .rain-canvas { display:none; }
.light-theme .hbtn { border-color:rgba(0,100,0,0.3); color:#4a7a4a; }
.light-theme .hbtn:hover,.light-theme .hbtn.on { background:rgba(0,100,0,0.1); color:var(--g); box-shadow:none; }
.light-theme .send-btn { box-shadow:none; }
.light-theme .input-row:focus-within { box-shadow:0 0 8px rgba(0,100,0,0.15); }

/* ── CYBERPUNK THEME ── */
.cyberpunk-theme { --g:#ff00ff; --gd:#cc00cc; --dk:#1a001a; --glow:rgba(255,0,255,0.12);
  --am:#ff6600; --rd:#ff0033; --cy:#00ffff;
  --bg:#0a0010; --pan:#0f0018; --inp:#07000e;
  --bor:rgba(255,0,255,0.2); --borb:rgba(255,0,255,0.6); }
.cyberpunk-theme .crt::before { background:repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(255,0,255,0.02) 2px,rgba(255,0,255,0.02) 4px); }
.cyberpunk-theme .msg-bubble.own { background:var(--dk); border-color:var(--g); color:var(--g); }
.cyberpunk-theme .ch-name { color:var(--cy); text-shadow:0 0 10px var(--cy); }
.cyberpunk-theme .login-logo { color:var(--g); text-shadow:0 0 20px var(--g), 0 0 40px var(--am); }
.cyberpunk-theme .sb-logo { color:var(--cy); text-shadow:0 0 12px var(--cy); }

/* ── MIDNIGHT THEME ── */
.midnight-theme { --g:#7b8cde; --gd:#5a6abf; --dk:#0d1117; --glow:rgba(123,140,222,0.1);
  --am:#e8a020; --rd:#e05555; --cy:#56d1dc;
  --bg:#090d14; --pan:#0d1117; --inp:#060a10;
  --bor:rgba(123,140,222,0.2); --borb:rgba(123,140,222,0.5); }
.midnight-theme .crt::before { display:none; }
.midnight-theme .crt::after { display:none; }
.midnight-theme .rain-canvas { display:none; }
.midnight-theme .msg-bubble.own { background:#161d2e; border-color:var(--g); color:#c9d1f5; box-shadow:0 0 8px rgba(123,140,222,0.2); }
.midnight-theme .msg-bubble.other { background:#0d1117; border-color:var(--bor); color:#a0aab8; }
.midnight-theme .ch-name { text-shadow:none; color:#c9d1f5; }
.midnight-theme .rooms-title { text-shadow:none; }
.midnight-theme .login-logo { text-shadow:0 0 20px var(--g); }

/* ── AMBER THEME ── */
.amber-theme { --g:#ffb000; --gd:#cc8800; --dk:#1a0f00; --glow:rgba(255,176,0,0.12);
  --am:#ff6600; --rd:#ff3131; --cy:#ffd700;
  --bg:#0a0800; --pan:#0f0c00; --inp:#080600;
  --bor:rgba(255,176,0,0.2); --borb:rgba(255,176,0,0.5); }
.amber-theme .crt::before { background:repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(255,176,0,0.03) 2px,rgba(255,176,0,0.03) 4px); }
.amber-theme .msg-bubble.own { border-color:var(--g); color:var(--g); }
.amber-theme .login-logo { color:var(--g); text-shadow:0 0 20px var(--g); }

/* ── RED MATRIX THEME ── */
.red-theme { --g:#ff2020; --gd:#cc1010; --dk:#1a0000; --glow:rgba(255,32,32,0.12);
  --am:#ff8800; --cy:#ff6060;
  --bg:#080000; --pan:#0f0000; --inp:#060000;
  --bor:rgba(255,32,32,0.2); --borb:rgba(255,32,32,0.5); }
.red-theme .crt::before { background:repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(255,0,0,0.03) 2px,rgba(255,0,0,0.03) 4px); }
.red-theme .msg-bubble.own { border-color:var(--g); color:var(--g); }

/* ── PAPER THEME (warm cream) ── */
.paper-theme { --g:#2d4a1e; --gd:#4a6741; --dk:#dce8d4; --glow:rgba(45,74,30,0.07);
  --am:#8b4513; --rd:#c0392b; --cy:#2e7d6e;
  --bg:#f5f0e8; --pan:#ede8df; --inp:#faf7f2;
  --bor:rgba(45,74,30,0.18); --borb:rgba(45,74,30,0.45); color:#1a2e14; }
.paper-theme .msgs { background:#f8f4ed; }
.paper-theme .room-name { color:#2d4a1e; }
.paper-theme .room-preview { color:#6a7c64; }
.paper-theme .msg-bubble.other { background:#ede8df; border-color:rgba(45,74,30,0.2); border-left:2px solid #8a9e80; color:#1a2e14; }
.paper-theme .msg-bubble.own { background:#d6e8cc; border-color:#4a6741; border-right:2px solid #2d4a1e; color:#1a2e14; box-shadow:none; }
.paper-theme .msg-who { color:#4a6741; }
.paper-theme .msg-time { color:#7a9070; opacity:1; }
.paper-theme .ch-name { color:var(--g); text-shadow:none; }
.paper-theme .rooms-title { text-shadow:none; }
.paper-theme .crt::before,.paper-theme .crt::after { display:none; }
.paper-theme .rain-canvas { display:none; }
.paper-theme .send-btn { box-shadow:none; }
.paper-theme .input-row:focus-within { box-shadow:0 0 8px rgba(45,74,30,0.12); }
.paper-theme .hbtn { border-color:rgba(45,74,30,0.25); color:#4a6741; }
.paper-theme .hbtn:hover,.paper-theme .hbtn.on { background:rgba(45,74,30,0.08); color:var(--g); box-shadow:none; }
.paper-theme .day-sep { color:#7a9070; }
.paper-theme .day-sep::before,.paper-theme .day-sep::after { background:rgba(45,74,30,0.15); }
.paper-theme .msg-reaction { background:#e8f0e0; border-color:rgba(45,74,30,0.2); }
.paper-theme .msg-reaction.own,.paper-theme .msg-reaction:hover { border-color:#4a6741; background:#d0e4c4; }
.paper-theme .sec-label { color:#4a6741; }
.paper-theme .sb-icon { color:#4a6741; }
.paper-theme .sb-icon:hover,.paper-theme .sb-icon.active { box-shadow:none; }

/* ── OCEAN THEME (light blue) ── */
.ocean-theme { --g:#0a4a7a; --gd:#1a6aaa; --dk:#cce4f5; --glow:rgba(10,74,122,0.07);
  --am:#c67c00; --rd:#c0392b; --cy:#0a7a6a;
  --bg:#eef6fd; --pan:#e3f0fa; --inp:#f5faff;
  --bor:rgba(10,74,122,0.15); --borb:rgba(10,74,122,0.4); color:#0a2a4a; }
.ocean-theme .msgs { background:#f0f7fd; }
.ocean-theme .room-name { color:#0a3a6a; }
.ocean-theme .room-preview { color:#3a6a8a; }
.ocean-theme .msg-bubble.other { background:#e3f0fa; border-color:rgba(10,74,122,0.18); border-left:2px solid #5a9aca; color:#0a2a4a; }
.ocean-theme .msg-bubble.own { background:#c8dff5; border-color:#1a6aaa; border-right:2px solid #0a4a7a; color:#0a2a4a; box-shadow:none; }
.ocean-theme .msg-who { color:#1a5a8a; }
.ocean-theme .msg-time { color:#4a8aaa; opacity:1; }
.ocean-theme .ch-name { color:var(--g); text-shadow:none; }
.ocean-theme .rooms-title { text-shadow:none; }
.ocean-theme .crt::before,.ocean-theme .crt::after { display:none; }
.ocean-theme .rain-canvas { display:none; }
.ocean-theme .send-btn { box-shadow:none; }
.ocean-theme .input-row:focus-within { box-shadow:0 0 8px rgba(10,74,122,0.12); }
.ocean-theme .hbtn { border-color:rgba(10,74,122,0.22); color:#1a6aaa; }
.ocean-theme .hbtn:hover,.ocean-theme .hbtn.on { background:rgba(10,74,122,0.07); color:var(--g); box-shadow:none; }
.ocean-theme .day-sep { color:#4a8aaa; }
.ocean-theme .day-sep::before,.ocean-theme .day-sep::after { background:rgba(10,74,122,0.15); }
.ocean-theme .msg-reaction { background:#daeefa; border-color:rgba(10,74,122,0.18); }
.ocean-theme .msg-reaction.own,.ocean-theme .msg-reaction:hover { border-color:#1a6aaa; background:#c0daf0; }
.ocean-theme .sec-label { color:#1a6aaa; }
.ocean-theme .sb-icon { color:#1a6aaa; }
.ocean-theme .sb-icon:hover,.ocean-theme .sb-icon.active { box-shadow:none; }

/* ── ROSE THEME (warm pink/beige) ── */
.rose-theme { --g:#7a2a4a; --gd:#a03a60; --dk:#f0d8e0; --glow:rgba(122,42,74,0.07);
  --am:#9a5a00; --rd:#c0392b; --cy:#3a6a7a;
  --bg:#fdf4f6; --pan:#f8ecf0; --inp:#fdf8fa;
  --bor:rgba(122,42,74,0.15); --borb:rgba(122,42,74,0.4); color:#3a0a1a; }
.rose-theme .msgs { background:#fdf6f8; }
.rose-theme .room-name { color:#7a2a4a; }
.rose-theme .room-preview { color:#9a6a78; }
.rose-theme .msg-bubble.other { background:#f8ecf0; border-color:rgba(122,42,74,0.18); border-left:2px solid #c08090; color:#3a0a1a; }
.rose-theme .msg-bubble.own { background:#edd8e2; border-color:#a03a60; border-right:2px solid #7a2a4a; color:#3a0a1a; box-shadow:none; }
.rose-theme .msg-who { color:#a03a60; }
.rose-theme .msg-time { color:#b07080; opacity:1; }
.rose-theme .ch-name { color:var(--g); text-shadow:none; }
.rose-theme .rooms-title { text-shadow:none; }
.rose-theme .crt::before,.rose-theme .crt::after { display:none; }
.rose-theme .rain-canvas { display:none; }
.rose-theme .send-btn { box-shadow:none; }
.rose-theme .input-row:focus-within { box-shadow:0 0 8px rgba(122,42,74,0.12); }
.rose-theme .hbtn { border-color:rgba(122,42,74,0.22); color:#a03a60; }
.rose-theme .hbtn:hover,.rose-theme .hbtn.on { background:rgba(122,42,74,0.07); color:var(--g); box-shadow:none; }
.rose-theme .day-sep { color:#b07080; }
.rose-theme .day-sep::before,.rose-theme .day-sep::after { background:rgba(122,42,74,0.15); }
.rose-theme .msg-reaction { background:#f4e0e8; border-color:rgba(122,42,74,0.18); }
.rose-theme .msg-reaction.own,.rose-theme .msg-reaction:hover { border-color:#a03a60; background:#e8ccd8; }
.rose-theme .sec-label { color:#a03a60; }
.rose-theme .sb-icon { color:#a03a60; }
.rose-theme .sb-icon:hover,.rose-theme .sb-icon.active { box-shadow:none; }

/* time/edited visibility fixes per dark theme */
.cyberpunk-theme .msg-time { color:#ee00ee; }
.cyberpunk-theme .msg-row.own .msg-time { color:#ff44ff; }
.midnight-theme .msg-time { color:#7b8cde; }
.midnight-theme .msg-row.own .msg-time { color:#9aabf5; }
.amber-theme .msg-time { color:#cc8800; }
.amber-theme .msg-row.own .msg-time { color:#ffaa00; }
.red-theme .msg-time { color:#cc2020; }
.red-theme .msg-row.own .msg-time { color:#ff4040; }

/* ── MOBILE RESPONSIVE ──────────────────────────────────────── */
@media (max-width: 768px) {
  /* Bottom nav bar */
  .mobile-nav { display:flex !important; }
  .mobile-back { display:flex !important; }

  /* App layout — stack vertically */
  .app { flex-direction:column; height:100dvh; }

  /* Sidebar — hidden on mobile (replaced by bottom nav) */
  .sidebar { display:none !important; }

  /* Rooms panel — full screen overlay when open */
  .rooms {
    position:fixed; inset:0; z-index:50; width:100% !important;
    transform:translateX(-100%); transition:transform 0.25s cubic-bezier(0.4,0,0.2,1);
  }
  .rooms.mobile-open { transform:translateX(0); }

  .members-backdrop { display:none; }
  /* Members panel — slide-in overlay from right on mobile */
  .members {
    position:fixed !important; top:92px !important; right:0 !important;
    bottom:56px !important; width:200px !important;
    z-index:40 !important; transform:translateX(100%);
    transition:transform 0.25s cubic-bezier(0.4,0,0.2,1);
    display:flex !important; flex-direction:column;
    box-shadow:-4px 0 20px rgba(0,0,0,0.5) !important;
  }
  .members.mobile-open { transform:translateX(0) !important; }

  /* Chat fills remaining space */
  .chat { flex:1; min-height:0; }
  .msgs { padding-bottom: 120px !important; }

  /* Chat header — 2 rows on mobile */
  .chat-header {
    height:auto !important; flex-wrap:wrap !important;
    padding:6px 8px 0 8px !important; gap:4px !important;
    align-items:center !important;
  }
  /* Row 1: back + name + topic — full width */
  .chat-header-row1 { display:flex; align-items:center; gap:6px; width:100%; min-height:28px; }
  /* Row 2: buttons — full width, bottom */
  .chat-header-row2 { display:flex; align-items:center; gap:6px; width:100%; padding-bottom:6px; }
  .ch-name { font-size:13px !important; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; flex-shrink:0; max-width:130px; }
  .ch-sub { display:none !important; }
  .ch-sep { display:none !important; }
  .hbtn { width:36px !important; height:36px !important; font-size:16px !important; flex-shrink:0; }
  .e2ee-badge { display:flex !important; padding:2px 5px !important; font-size:8px !important; }
  .ch-topic { font-size:10px; color:var(--gd); opacity:0.75; font-style:italic;
    overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
    flex:1; min-width:0; }

  /* Messages */
  .msgs { padding:8px; }
  .msg-bubble { max-width:82vw !important; }
  .msg-bubble p { font-size:13px !important; }

  /* Input area */
  .input-area { padding:6px 8px 8px; position:fixed; bottom:56px; left:0; right:0; z-index:10; background:var(--pan); }
  .input-prefix { display:none; }
  .input-hint { display:none; }
  .input-field { font-size:16px !important; } /* prevent iOS zoom */

  /* Login card */
  .login-card { width:calc(100vw - 32px); padding:24px 20px; }

  /* Rooms list items */
  .room-item { padding:10px 12px; }
  .room-name { font-size:12px; }
  .room-last { font-size:10px; }

  /* Call overlay */
  .call-box { padding:24px 20px; width:calc(100vw - 32px); }
  .lk-fullscreen { padding:0 !important; width:100% !important; height:100dvh !important; }
  .incoming-call { bottom:72px; left:8px; right:8px; transform:none; min-width:unset; width:auto; }

  /* Modals */
  .modal { padding:16px !important; width:calc(100vw - 24px) !important; max-height:85dvh; overflow-y:auto; }
  .settings-panel { position:fixed !important; top:0 !important; left:0 !important; right:0 !important; bottom:0 !important; width:100% !important; max-width:100% !important; z-index:9999 !important; overflow:hidden !important; border-left:none !important; }
  /* Inner scrollable content area */
  .settings-panel > div:last-child { overflow-y:auto !important; -webkit-overflow-scrolling:touch !important; padding-bottom:80px !important; }
  /* Push settings panel content above bottom nav */
  .settings-panel { padding-bottom:56px !important; }
  /* Hide fixed chat elements that overlap settings */
  .app.settings-open .input-area { display:none !important; }
  .app.settings-open .chat-header { pointer-events:none !important; }
  .app.settings-open .msgs { pointer-events:none !important; }
}

/* Bottom navigation bar */
.mobile-nav {
  display:none;
  position:fixed; bottom:0; left:0; right:0; height:56px;
  background:var(--pan); border-top:1px solid var(--borb);
  z-index:10000; align-items:stretch; justify-content:space-around;
}
.mobile-nav-btn {
  flex:1; display:flex; flex-direction:column; align-items:center; justify-content:center;
  gap:3px; background:none; border:none; color:var(--gd); cursor:pointer;
  font-family:var(--mono); font-size:9px; letter-spacing:0.08em;
  transition:color 0.15s;
}
.mobile-nav-btn.active { color:var(--g); text-shadow:0 0 6px var(--g); }
.mobile-nav-btn svg { width:20px; height:20px; }

/* Back button in chat header on mobile */
.mobile-back {
  display:none; align-items:center; justify-content:center;
  width:44px; height:44px; background:none; border:none;
  color:var(--g); cursor:pointer; font-size:22px; flex-shrink:0;
  margin-right:4px;
}
`;

function LoginRain() {
  const ref = useRef();
  useEffect(() => {
    const c = ref.current; const ctx = c.getContext("2d");
    const resize = () => { c.width = window.innerWidth; c.height = window.innerHeight; };
    resize();
    window.addEventListener("resize", resize);
    const cols = Math.floor(c.width / 18);
    const drops = Array.from({length: cols}, () => Math.random() * -50);
    const chars = "アイウエオカキクケコサシスセソタチツテトナニヌネノ0123456789ABCDEF@#$%&".split("");
    const id = setInterval(() => {
      ctx.fillStyle = "rgba(0,0,0,0.05)";
      ctx.fillRect(0, 0, c.width, c.height);
      drops.forEach((y, i) => {
        const bright = Math.random() > 0.95;
        ctx.fillStyle = bright ? "#ffffff" : (Math.random() > 0.7 ? "#00ff41" : "#00c832");
        ctx.font = `${14 + Math.floor(Math.random()*4)}px Share Tech Mono`;
        ctx.fillText(chars[Math.floor(Math.random() * chars.length)], i * 18, y * 18);
        if (y * 18 > c.height && Math.random() > 0.97) drops[i] = 0;
        drops[i] += 0.5 + Math.random() * 0.5;
      });
    }, 40);
    return () => { clearInterval(id); window.removeEventListener("resize", resize); };
  }, []);
  return <canvas ref={ref} style={{position:"fixed",inset:0,zIndex:1,opacity:0.55,pointerEvents:"none"}} />;
}

function MatrixRain() {
  const ref = useRef();
  useEffect(() => {
    const c = ref.current; const ctx = c.getContext("2d");
    c.width = window.innerWidth; c.height = window.innerHeight;
    const cols = Math.floor(c.width / 16); const drops = Array(cols).fill(1);
    const chars = "アイウエオ01ABCDEF#@!%<>[]{}".split("");
    const id = setInterval(() => {
      ctx.fillStyle = "rgba(2,12,2,0.05)"; ctx.fillRect(0, 0, c.width, c.height);
      ctx.fillStyle = "#00ff41"; ctx.font = "14px Share Tech Mono";
      drops.forEach((y, i) => {
        ctx.fillText(chars[Math.floor(Math.random() * chars.length)], i * 16, y * 16);
        if (y * 16 > c.height && Math.random() > 0.975) drops[i] = 0; drops[i]++;
      });
    }, 50);
    return () => clearInterval(id);
  }, []);
  return <canvas ref={ref} className="rain-canvas" />;
}

function ChatRain({ mode, themeColor }) {
  const ref = useRef();
  useEffect(() => {
    if (mode === "off") return;
    const c = ref.current; if (!c) return;
    const ctx = c.getContext("2d");
    const cfgMap = {
      subtle:  { alpha: 0.015, speed: 0.4, size: 18, interval: 60 },
      intense: { alpha: 0.04,  speed: 0.8, size: 16, interval: 35 },
      chaos:   { alpha: 0.09,  speed: 1.5, size: 14, interval: 20 },
    };
    const cfg = cfgMap[mode] || cfgMap.subtle;
    const colMap = { cyan: "#00e5ff", amber: "#ffb700", red: "#ff3131", default: "#00ff41" };
    const color = colMap[themeColor] || colMap.default;
    const chars = "アイウエオ01ABCDEF#@!%<>{}NEXUS".split("");
    const drops = [];
    let active = true;

    const resize = () => {
      const p = c.parentElement;
      if (!p) return;
      const w = p.clientWidth, h = p.clientHeight;
      if (w > 0 && h > 0 && (c.width !== w || c.height !== h)) {
        c.width = w; c.height = h;
        drops.length = 0;
        for (let i = 0; i < Math.floor(w / cfg.size); i++) drops.push(Math.random() * -50);
      }
    };

    const ro = new ResizeObserver(resize);
    ro.observe(c.parentElement || document.body);

    // Small timeout ensures CSS inset:0 has resolved before we read dimensions
    const timer = setTimeout(() => {
      resize();
      let last = 0;
      const tick = (ts) => {
        if (!active) return;
        requestAnimationFrame(tick);
        if (ts - last < cfg.interval) return;
        last = ts;
        if (c.width <= 0 || c.height <= 0) { resize(); return; }
        ctx.fillStyle = "rgba(2,8,2," + cfg.alpha + ")";
        ctx.fillRect(0, 0, c.width, c.height);
        const cols = Math.floor(c.width / cfg.size);
        while (drops.length < cols) drops.push(Math.random() * -50);
        drops.forEach((y, i) => {
          const ch = chars[Math.floor(Math.random() * chars.length)];
          const bright = Math.random() > 0.92;
          ctx.font = (cfg.size - 2) + "px 'Share Tech Mono',monospace";
          ctx.fillStyle = bright ? "#ffffff" : color;
          ctx.globalAlpha = bright ? 0.45 : 0.25;
          ctx.shadowColor = color;
          ctx.shadowBlur = bright ? 8 : 0;
          ctx.fillText(ch, i * cfg.size, y * cfg.size);
          ctx.globalAlpha = 1;
          ctx.shadowBlur = 0;
          drops[i] += cfg.speed * (0.7 + Math.random() * 0.6);
          if (drops[i] * cfg.size > c.height && Math.random() > 0.97) drops[i] = Math.random() * -20;
        });
      };
      requestAnimationFrame(tick);
    }, 50);

    return () => { active = false; clearTimeout(timer); ro.disconnect(); };
  }, [mode, themeColor]);

  if (mode === "off") return null;
  return <canvas ref={ref} style={{
    position: "absolute", top: 0, left: 0,
    width: "100%", height: "100%",
    pointerEvents: "none", zIndex: 0
  }} />;
}

const BOOT_LINES = [
  { text: "BIOS v2.31 ... OK", delay: 0 },
  { text: "MATRIX PROTOCOL v1.12 INITIALIZED", delay: 400, cls: "cyan" },
  { text: "E2EE CRYPTO WASM: LOADING ...", delay: 700 },
  { text: "OLM ENCRYPTION: READY", delay: 1000 },
  { text: `HOMESERVER: ${HOMESERVER}`, delay: 1200 },
  { text: "▶ NEXUS", delay: 1500, cls: "big" },
  { text: "SECURE MATRIX CLIENT v0.2.0", delay: 1600, cls: "cyan" },
];

// ─── WebRTC Call Engine via Matrix events ───────────────────────────────────
const CALL_MSG = {
  INVITE: "m.call.invite",
  ANSWER: "m.call.answer",
  CANDIDATES: "m.call.candidates",
  HANGUP: "m.call.hangup",
  MUTE: "m.call.mute",
  GROUP_CALL: "nexus.group_call",
};

// ── MatrixRTC (Element X compatible calls via LiveKit + lk-jwt-service) ────
const MATRIXRTC_MEMBER = "org.matrix.msc3401.call.member";
const MATRIXRTC_JWT_URL = "https://chat.hipogas.org/livekit/jwt/sfu/get";
const MATRIXRTC_SERVICE_URL = "https://chat.hipogas.org/livekit/jwt";

async function getMatrixRTCToken(client, roomId) {
  // Step 1: Get OpenID token from homeserver
  const hsUrl = client.getHomeserverUrl();
  const userId = client.getUserId();
  const accessToken = client.getAccessToken();
  const oidResp = await fetch(
    hsUrl + "/_matrix/client/v3/user/" + encodeURIComponent(userId) + "/openid/request_token",
    { method: "POST", headers: { "Authorization": "Bearer " + accessToken, "Content-Type": "application/json" }, body: "{}" }
  );
  if (!oidResp.ok) throw new Error("OpenID token request failed: " + oidResp.status);
  const openIdToken = await oidResp.json();
  console.log("[MatrixRTC] Got OpenID token for", userId);

  // Step 2: Exchange for LiveKit JWT via lk-jwt-service
  const jwtResp = await fetch(MATRIXRTC_JWT_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ room: roomId, openid_token: openIdToken, device_id: client.getDeviceId() })
  });
  if (!jwtResp.ok) {
    const errText = await jwtResp.text().catch(() => "");
    throw new Error("MatrixRTC JWT request failed: " + jwtResp.status + " " + errText);
  }
  const result = await jwtResp.json();
  console.log("[MatrixRTC] Got LiveKit JWT, SFU URL:", result.url);
  return result; // { url: "wss://...", jwt: "eyJ..." }
}

async function sendCallMemberEvent(client, roomId, joining) {
  const deviceId = client.getDeviceId();
  const userId = client.getUserId();
  const stateKey = "_" + userId + "_" + deviceId;
  if (joining) {
    await client.sendStateEvent(roomId, MATRIXRTC_MEMBER, {
      application: "m.call",
      call_id: "",
      device_id: deviceId,
      focus_active: { type: "livekit", focus_selection: "oldest_membership" },
      foci_preferred: [{ type: "livekit", livekit_service_url: MATRIXRTC_SERVICE_URL }],
      scope: "m.room",
      expires: Date.now() + 3600000
    }, stateKey);
    console.log("[MatrixRTC] Sent call.member JOIN for", roomId);
  } else {
    await client.sendStateEvent(roomId, MATRIXRTC_MEMBER, {}, stateKey);
    console.log("[MatrixRTC] Sent call.member LEAVE for", roomId);
  }
}

async function sendCallNotify(client, roomId) {
  // MSC4075: m.call.notify — triggers ringing in Element X
  const room = client.getRoom(roomId);
  if (!room) return;
  const members = room.getJoinedMembers().filter(m => m.userId !== client.getUserId());
  const userIds = members.map(m => m.userId);
  try {
    await client.sendEvent(roomId, "m.call.notify", {
      application: "m.call",
      call_id: "",
      "m.mentions": { user_ids: userIds },
      notify_type: "ring"
    });
    console.log("[MatrixRTC] Sent m.call.notify to", userIds);
  } catch(e) {
    console.warn("[MatrixRTC] call.notify failed:", e.message);
  }
}

function makeRingtone() {
  // Use oscillator only after user gesture — browsers block AudioContext autoplay
  let stopped = false;
  let ctx = null;
  const start = () => {
    if (stopped || ctx) return;
    try {
      ctx = new (window.AudioContext || window.webkitAudioContext)();
      const ring = () => {
        if (stopped) return;
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain); gain.connect(ctx.destination);
        osc.frequency.value = 440;
        gain.gain.setValueAtTime(0.25, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
        osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.5);
        if (!stopped) setTimeout(ring, 1400);
      };
      ring();
    } catch(e) {}
  };
  // Start immediately — IncomingCallNotif is only shown after user interaction (page was loaded)
  setTimeout(start, 100);
  return { stop: () => { stopped = true; ctx?.close(); } };
}

function CallTimer() {
  const [secs, setSecs] = useState(0);
  useEffect(() => { const id = setInterval(() => setSecs(s => s+1), 1000); return () => clearInterval(id); }, []);
  const m = String(Math.floor(secs/60)).padStart(2,'0'), s = String(secs%60).padStart(2,'0');
  return <span className="call-timer">{m}:{s}</span>;
}

function NexusCall({ callState, onHangup, lang, client, myUserId, pcRef, onMuteChange, peerMuted }) {
  const { peerName, peerId, isVideo, isConnected, isCaller, localStream, remoteStream } = callState;
  const getCallAvatarUrl = (userId) => {
    try {
      if (!userId || !client) return null;
      const mxc = client.getUser(userId)?.avatarUrl;
      if (!mxc?.startsWith("mxc://")) return null;
      const parts = mxc.slice(6).split("/");
      return `${client.getHomeserverUrl()}/_matrix/client/v1/media/download/${parts[0]}/${parts[1]}?access_token=${client.getAccessToken()}`;
    } catch(e) { return null; }
  };
  const peerAvatarUrl = getCallAvatarUrl(peerId);
  const myAvatarUrl = getCallAvatarUrl(myUserId);
  const [muted, setMuted] = useState(false);
  const [camOff, setCamOff] = useState(false);
  const remoteVideoEl = useRef(null);
  const remoteAudioEl = useRef(null);
  const localVideoEl = useRef(null);
  const callRainRef = useRef(null);

  // Matrix rain on call background
  useEffect(() => {
    const el = callRainRef.current;
    if (!el) return;
    el.width = window.innerWidth; el.height = window.innerHeight;
    const ctx = el.getContext("2d");
    const chars = "アイウエオ01NEXUS#@!{}[]".split("");
    const cols = Math.floor(el.width / 16);
    const drops = Array.from({length: cols}, () => Math.random() * -50);
    let active = true;
    const draw = () => {
      if (!active) return;
      ctx.fillStyle = "rgba(0,0,0,0.05)";
      ctx.fillRect(0, 0, el.width, el.height);
      ctx.font = "14px 'Share Tech Mono',monospace";
      drops.forEach((y, i) => {
        ctx.fillStyle = Math.random() > 0.95 ? "rgba(255,255,255,0.6)" : "rgba(0,255,65,0.2)";
        ctx.fillText(chars[Math.floor(Math.random() * chars.length)], i * 16, y * 16);
        if (y * 16 > el.height && Math.random() > 0.975) drops[i] = Math.random() * -20;
        drops[i] += 0.5;
      });
    };
    const id = setInterval(draw, 50);
    return () => { active = false; clearInterval(id); };
  }, []);

  const rainCanvasEl = <canvas ref={callRainRef} style={{position:"absolute",inset:0,zIndex:0,pointerEvents:"none",opacity:0.6,width:"100%",height:"100%"}} />;

  const hasRemoteVideo = remoteStream?.getVideoTracks?.()?.length > 0;
  const showVideo = isVideo || hasRemoteVideo;

  // Attach remote stream — always reassign srcObject (snapshots = new objects each time)
  useEffect(() => {
    if (!remoteStream) return;
    const tracks = remoteStream.getTracks();
    console.log("📞 Attaching remoteStream, tracks:", tracks.map(t=>t.kind+"/"+t.readyState).join(","));
    const hasVideo = tracks.some(t => t.kind === "video");
    const hasAudio = tracks.some(t => t.kind === "audio");

    // Always route audio through <audio> element
    if (hasAudio && remoteAudioEl.current) {
      const el = remoteAudioEl.current;
      el.srcObject = remoteStream;
      el.muted = false;
      el.volume = 1.0;
      const tryPlay = (attempt) => {
        el.play()
          .then(() => console.log("📞 audio playing (attempt " + attempt + ")"))
          .catch(e => {
            console.warn("📞 audio play failed (attempt " + attempt + "):", e.name);
            if (attempt < 5) setTimeout(() => tryPlay(attempt + 1), 300 * attempt);
          });
      };
      tryPlay(1);
    }
    // Video via <video> element — muted to avoid double audio
    if (hasVideo && remoteVideoEl.current) {
      remoteVideoEl.current.srcObject = remoteStream;
      remoteVideoEl.current.muted = true;
      remoteVideoEl.current.play()
        .then(() => console.log("📞 video playing"))
        .catch(e => console.warn("📞 video play failed:", e.name, e.message));
    }
  }, [remoteStream]);

  // Unmute audio element imperatively on mount — React muted={false} prop is broken
  // Also run a periodic health check to ensure audio stays playing
  useEffect(() => {
    const el = remoteAudioEl.current;
    if (!el) return;
    el.muted = false;
    el.volume = 1.0;
    el.play().catch(() => {});
    // Health check every 2s — if audio element is paused but has a stream, restart it
    const hc = setInterval(() => {
      if (el.paused && el.srcObject && el.srcObject.getAudioTracks().some(t => t.readyState === "live")) {
        console.log("📞 Audio health check: restarting paused audio");
        el.muted = false;
        el.volume = 1.0;
        el.play().catch(() => {});
      }
    }, 2000);
    return () => clearInterval(hc);
  }, []);

  useEffect(() => {
    if (!localStream || !localVideoEl.current) return;
    localVideoEl.current.srcObject = localStream;
    localVideoEl.current.play().catch(()=>{});
  }, [localStream]);

  const toggleMute = () => {
    setMuted(m => {
      const newMuted = !m;
      localStream?.getAudioTracks().forEach(t => { t.enabled = !newMuted; });
      onMuteChange?.({ audio: newMuted, video: camOff });
      return newMuted;
    });
  };
  const toggleCam = () => {
    setCamOff(c => {
      const newCamOff = !c;
      localStream?.getVideoTracks().forEach(t => { t.enabled = !newCamOff; });
      onMuteChange?.({ audio: muted, video: newCamOff });
      return newCamOff;
    });
  };

  const [facing, setFacing] = useState("user");
  const [hasMultipleCams, setHasMultipleCams] = useState(false);
  useEffect(() => {
    navigator.mediaDevices?.enumerateDevices().then(devices => {
      const cams = devices.filter(d => d.kind === "videoinput");
      setHasMultipleCams(cams.length > 1);
    }).catch(() => {});
  }, []);

  const switchCamera = async () => {
    if (!localStream || camOff) return;
    const newFacing = facing === "user" ? "environment" : "user";
    try {
      localStream.getVideoTracks().forEach(t => t.stop());
      const ns = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { exact: newFacing }, width: { ideal: 640 }, height: { ideal: 480 } },
        audio: false
      });
      const newTrack = ns.getVideoTracks()[0];
      const old = localStream.getVideoTracks()[0];
      if (old) localStream.removeTrack(old);
      localStream.addTrack(newTrack);
      if (pcRef?.current) {
        const sender = pcRef.current.getSenders().find(s => s.track?.kind === "video");
        if (sender) await sender.replaceTrack(newTrack);
      }
      if (localVideoEl.current) localVideoEl.current.srcObject = localStream;
      setFacing(newFacing);
    } catch(e) {
      // exact constraint failed — try without exact (some devices need this)
      try {
        const ns2 = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: newFacing }, audio: false
        });
        const newTrack2 = ns2.getVideoTracks()[0];
        const old2 = localStream.getVideoTracks()[0];
        if (old2) localStream.removeTrack(old2);
        localStream.addTrack(newTrack2);
        if (pcRef?.current) {
          const sender = pcRef.current.getSenders().find(s => s.track?.kind === "video");
          if (sender) await sender.replaceTrack(newTrack2);
        }
        if (localVideoEl.current) localVideoEl.current.srcObject = localStream;
        setFacing(newFacing);
      } catch(e2) { console.warn("switchCamera failed:", e2.message); }
    }
  };

  return (
    <div className="call-overlay">
{rainCanvasEl}
      {/* Audio always present */}
      <audio ref={remoteAudioEl} autoPlay playsInline style={{position:"fixed",top:-9999,left:-9999,width:1,height:1}} />
      <div className="call-box" style={{maxWidth: showVideo ? 600 : 380, position:"relative", zIndex:1}}>
        <div style={{position:"absolute",top:12,right:12,fontSize:10,color:"var(--gd)",letterSpacing:"0.1em"}}>
          {isVideo?"📹":"🎤"} {lang==="ru"?"ЗВОНОК":"CALL"}
        </div>
        {/* Video area */}
        <div className="call-videos" style={{width:"100%",minHeight:220,display:showVideo?"flex":"none",position:"relative"}}>
          {/* Remote — main */}
          <div className="call-video-main">
            <video ref={remoteVideoEl} autoPlay playsInline style={{width:"100%",height:"100%",objectFit:"cover",background:"#000",display:hasRemoteVideo&&!peerMuted?.video?"block":"none"}} />
            {(!hasRemoteVideo || peerMuted?.video) && (
              <div style={{position:"absolute",inset:0,background:"linear-gradient(160deg,#020c02,#041a04)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:10}}>
                <div style={{width:72,height:72,border:"2px solid var(--bor)",clipPath:"polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%)",overflow:"hidden",background:"rgba(0,255,65,0.07)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,boxShadow:"0 0 16px var(--glow)"}}>
                  {peerAvatarUrl
                    ? <img src={peerAvatarUrl} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}} onError={e=>{e.target.style.display="none"; e.target.nextSibling.style.display="flex";}} />
                    : null}
                  <div style={{display:peerAvatarUrl?"none":"flex",alignItems:"center",justifyContent:"center",width:"100%",height:"100%",fontFamily:"var(--disp)",fontSize:24,fontWeight:700,color:"var(--g)",textShadow:"0 0 12px var(--g)"}}>
                    {(peerName||"?").slice(0,2).toUpperCase()}
                  </div>
                </div>
                <div style={{fontFamily:"var(--disp)",fontSize:13,fontWeight:700,color:"var(--g)",letterSpacing:"0.12em",textShadow:"0 0 10px var(--g)"}}>{peerName}</div>
                <div style={{display:"flex",gap:10,alignItems:"center",marginTop:2}}>
                  <span style={{fontSize:12,opacity: peerMuted?.video ? 1 : 0.35, color: peerMuted?.video ? "#ff4444" : "var(--gd)"}}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      {peerMuted?.video
                        ? <><line x1="2" y1="2" x2="22" y2="22"/><path d="M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 1.76-1.05"/><polygon points="16 11 23 7 23 17 16 13 16 11"/></>
                        : <><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></>}
                    </svg>
                  </span>
                  <span style={{fontSize:12,opacity: peerMuted?.audio ? 1 : 0.35, color: peerMuted?.audio ? "#ff4444" : "var(--gd)"}}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      {peerMuted?.audio
                        ? <><line x1="2" y1="2" x2="22" y2="22"/><path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"/><path d="M5 10v2a7 7 0 0 0 12 4.93"/><path d="M15 9.34V5a3 3 0 0 0-5.68-1.33"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></>
                        : <><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></>}
                    </svg>
                  </span>
                </div>
                <div style={{fontSize:9,color:isConnected?"var(--g)":"var(--gd)",fontFamily:"var(--mono)",letterSpacing:"0.12em",marginTop:2,textShadow:isConnected?"0 0 6px var(--g)":"none"}}>
                  {isConnected ? (lang==="ru"?"● АКТИВНО":"● ACTIVE") : (isCaller ? (lang==="ru"?"○ ВЫЗОВ...":"○ CALLING...") : (lang==="ru"?"○ СОЕДИНЕНИЕ...":"○ CONNECTING..."))}
                </div>
              </div>
            )}
            {/* Mic status overlay — always visible when video is on */}
            {hasRemoteVideo && !peerMuted?.video && (
              <div style={{position:"absolute",top:8,left:8,zIndex:3,display:"flex",alignItems:"center",gap:4,background:"rgba(0,0,0,0.45)",borderRadius:3,padding:"3px 7px",backdropFilter:"blur(4px)"}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={peerMuted?.audio ? "#ff4444" : "#00ff41"} strokeWidth="2">
                  {peerMuted?.audio
                    ? <><line x1="2" y1="2" x2="22" y2="22"/><path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"/><path d="M5 10v2a7 7 0 0 0 12 4.93"/><path d="M15 9.34V5a3 3 0 0 0-5.68-1.33"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></>
                    : <><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></>}
                </svg>
                <span style={{fontSize:9,color:peerMuted?.audio?"#ff4444":"#00ff41",fontFamily:"var(--mono)",letterSpacing:"0.05em"}}>
                  {peerMuted?.audio ? (lang==="ru"?"МИК ВЫКЛ":"MIC OFF") : (lang==="ru"?"МИК ВКЛ":"MIC ON")}
                </span>
              </div>
            )}
          </div>
          {/* Local — PiP bottom-left */}
          <div className="call-video-self" style={{left:8,right:"auto"}}>
            <video ref={localVideoEl} autoPlay playsInline muted style={{width:"100%",height:"100%",objectFit:"cover",display:(!camOff&&localStream?.getVideoTracks()?.length>0)?"block":"none"}} />
            {(camOff || !localStream?.getVideoTracks()?.length) && (
              <div style={{position:"absolute",inset:0,background:"#0a0f0a",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:3}}>
                {myAvatarUrl
                  ? <img src={myAvatarUrl} alt="" style={{width:"100%",height:"100%",objectFit:"cover",position:"absolute",inset:0}} />
                  : <div style={{fontFamily:"var(--disp)",fontSize:16,fontWeight:700,color:"var(--g)",textShadow:"0 0 8px var(--g)"}}>{myUserId?(myUserId.replace(/^@/,"").split(":")[0]).slice(0,2).toUpperCase():"ME"}</div>
                }
                <div style={{position:"absolute",bottom:3,left:0,right:0,textAlign:"center",fontSize:8,color:"rgba(255,255,255,0.6)",fontFamily:"var(--mono)",background:"rgba(0,0,0,0.5)",padding:"1px 0"}}>{lang==="ru"?"вы":"you"}</div>
              </div>
            )}
          </div>
        </div>
        {/* Audio-only view */}
        {!showVideo && (
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:8,padding:"8px 0"}}>
            <div style={{width:80,height:80,border:"2px solid var(--bor)",clipPath:"polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%)",overflow:"hidden",background:"rgba(0,255,65,0.07)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:4,boxShadow:"0 0 20px var(--glow)",flexShrink:0}}>
              {peerAvatarUrl
                ? <img src={peerAvatarUrl} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}} onError={e=>{e.target.style.display="none"; e.target.nextSibling.style.display="flex";}} />
                : null}
              <div style={{display:peerAvatarUrl?"none":"flex",alignItems:"center",justifyContent:"center",width:"100%",height:"100%",fontFamily:"var(--disp)",fontSize:28,fontWeight:700,color:"var(--g)",textShadow:"0 0 12px var(--g)"}}>
                {(peerName||"?").slice(0,2).toUpperCase()}
              </div>
            </div>
            <div className="call-name">{peerName}</div>
            {/* Peer mic/cam status icons */}
            <div style={{display:"flex",gap:12,margin:"4px 0"}}>
              <span style={{opacity:peerMuted?.audio?1:0.3,color:peerMuted?.audio?"#ff4444":"var(--gd)",fontSize:18}} title={peerMuted?.audio?(lang==="ru"?"Микрофон выкл":"Mic off"):(lang==="ru"?"Микрофон вкл":"Mic on")}>
                {peerMuted?.audio ? "🔇" : "🎤"}
              </span>
            </div>
            <div className="call-status">{isConnected ? <CallTimer /> : (isCaller ? (lang==="ru"?"ВЫЗОВ...":"CALLING...") : (lang==="ru"?"СОЕДИНЕНИЕ...":"CONNECTING..."))}</div>
          </div>
        )}
        <div className="call-btns" style={{padding:"10px 0",paddingBottom:"calc(env(safe-area-inset-bottom,0px) + 10px)",background:"rgba(0,0,0,0.8)",flexShrink:0}}>
          <button className={`call-btn mute${muted?" active":""}`} onClick={toggleMute}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {muted ? <><line x1="2" y1="2" x2="22" y2="22"/><path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"/><path d="M5 10v2a7 7 0 0 0 12 4.93"/><path d="M15 9.34V5a3 3 0 0 0-5.68-1.33"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></> : <><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></>}
            </svg>
          </button>
          {showVideo && (
            <button className={`call-btn cam${camOff?" active":""}`} onClick={toggleCam}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {camOff ? <><line x1="2" y1="2" x2="22" y2="22"/><path d="M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 1.76-1.05"/><polygon points="16 11 23 7 23 17 16 13 16 11"/></> : <><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></>}
              </svg>
            </button>
          )}
          {showVideo && !camOff && hasMultipleCams && (
            <button className="call-btn" onClick={switchCamera}
              style={{background:"var(--inp)",color:"var(--g)",border:"1px solid var(--bor)"}}
              title={lang==="ru"?(facing==="user"?"Включить основную камеру":"Включить фронтальную камеру"):(facing==="user"?"Switch to back camera":"Switch to front camera")}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 7h-3.5l-1.5-2h-6L7.5 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                <circle cx="12" cy="13" r="4"/>
                <path d="M18 9h.01" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </button>
          )}
          <button className="call-btn end" onClick={onHangup}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
          </button>
        </div>
      </div>
    </div>
  );
}

function IncomingCallNotif({ info, lang, onAnswer, onReject }) {
  useEffect(() => { const rt = makeRingtone(); return () => rt.stop(); }, []);
  return (
    <div className="incoming-call">
      <div className="incoming-call-name">📞 {info.peerName}</div>
      <div className="incoming-call-sub">{info.isVideo?(lang==="ru"?"ВИДЕОЗВОНОК":"VIDEO CALL"):(lang==="ru"?"АУДИОЗВОНОК":"AUDIO CALL")}</div>
      <div className="incoming-call-btns">
        <button className="call-btn answer" onClick={() => onAnswer(false)}>🎤</button>
        {info.isVideo && <button className="call-btn answer" onClick={() => onAnswer(true)}>📹</button>}
        <button className="call-btn end" onClick={onReject}>📵</button>
      </div>
    </div>
  );
}

// ── LiveKit token generator (Web Crypto API) ──────────────────────────────
async function generateLiveKitToken(roomName, userId, displayName) {
  const apiKey = "nexus_key";
  const secret = "a5e490242081b87d885ae94840df26551a5f1cdda559b0e9570fb84c88317658";
  const now = Math.floor(Date.now() / 1000);
  const payload = {
    iss: apiKey, sub: userId,
    jti: Math.random().toString(36).slice(2),
    exp: now + 21600, nbf: now,
    name: displayName,
    video: { room: roomName, roomJoin: true, canPublish: true, canSubscribe: true, canPublishData: true }
  };
  const enc = (s) => btoa(s).replace(/=/g,"").replace(/\+/g,"-").replace(/\//g,"_");
  const header = enc(JSON.stringify({alg:"HS256",typ:"JWT"}));
  const body = enc(unescape(encodeURIComponent(JSON.stringify(payload))));
  const sigInput = `${header}.${body}`;
  const key = await crypto.subtle.importKey("raw", new TextEncoder().encode(secret),
    {name:"HMAC",hash:"SHA-256"}, false, ["sign"]);
  const sig = await crypto.subtle.sign("HMAC", key, new TextEncoder().encode(sigInput));
  const sigB64 = enc(String.fromCharCode(...new Uint8Array(sig)));
  return `${sigInput}.${sigB64}`;
}



// ── Error boundary wraps LiveKit to prevent white screen ─────────────────
class LKErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error) { console.error("LiveKit crash caught:", error.message); }
  render() {
    if (this.state.hasError) {
      return (
        <div className="call-overlay">
          <div className="call-box" style={{textAlign:"center",gap:16,maxWidth:360}}>
            <div style={{fontFamily:"var(--disp)",color:"var(--g)",fontSize:13,letterSpacing:"0.12em"}}>
              // NEXUS CALL ERROR
            </div>
            <div style={{color:"#ff4444",fontFamily:"var(--mono)",fontSize:10,wordBreak:"break-all"}}>
              {this.state.error?.message || "Unknown error"}
            </div>
            <button onClick={this.props.onClose}
              style={{background:"rgba(255,49,49,0.1)",border:"1px solid rgba(255,49,49,0.5)",
                color:"#ff4444",fontFamily:"var(--mono)",fontSize:11,cursor:"pointer",
                padding:"8px 20px",marginTop:8}}>
              [ {this.props.lang==="ru"?"ЗАКРЫТЬ":"CLOSE"} ]
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

// ── LiveKit Group Call Modal ─────────────────────────────────────────────
function LiveKitCallModal({ roomId, roomName, userId, client, video, onClose, lang, lkToken, lkUrl }) {
  const LK_URL = "wss://chat.hipogas.org/livekit/";
  const me = userId.replace(/^@/,"").split(":")[0];
  const lvRoomName = "nexus_" + roomId.replace(/[^a-zA-Z0-9]/g,"").slice(-20);

  const [LK, setLK] = useState(null); // livekit-client module
  const [room, setRoom] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [status, setStatus] = useState("connecting");
  const [errMsg, setErrMsg] = useState("");
  const [muted, setMuted] = useState(false);
  const [camOff, setCamOff] = useState(!video);
  const [, forceUpdate] = useState(0);
  const rainRef = useRef(null);
  const roomRef = useRef(null);

  // Re-render on orientation change
  useEffect(() => {
    const onResize = () => forceUpdate(n => n + 1);
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => { window.removeEventListener("resize", onResize); window.removeEventListener("orientationchange", onResize); };
  }, []);

  // Matrix rain
  useEffect(() => {
    const el = rainRef.current; if (!el) return;
    el.width = window.innerWidth; el.height = window.innerHeight;
    const ctx = el.getContext("2d");
    const chars = "アNEXUS01#@{}[]".split("");
    const cols = Math.floor(el.width/18);
    const drops = Array.from({length:cols}, ()=>Math.random()*-50);
    let alive = true;
    const tick = () => {
      if (!alive) return;
      ctx.fillStyle="rgba(0,0,0,0.05)"; ctx.fillRect(0,0,el.width,el.height);
      ctx.font="14px 'Share Tech Mono',monospace";
      drops.forEach((y,i)=>{
        ctx.fillStyle=Math.random()>0.95?"rgba(255,255,255,0.5)":"rgba(0,255,65,0.18)";
        ctx.fillText(chars[Math.floor(Math.random()*chars.length)],i*18,y*16);
        if(y*16>el.height&&Math.random()>0.975) drops[i]=Math.random()*-20;
        drops[i]+=0.5;
      });
    };
    const id = setInterval(tick,50);
    return ()=>{ alive=false; clearInterval(id); };
  }, []);

  // Dynamic import + connect
  useEffect(() => {
    let cancelled = false;
    const go = async () => {
      try {
        // Dynamic import avoids mobile crash from static top-level import
        const lk = await import("livekit-client");
        if (cancelled) return;
        setLK(lk);

        const r = new lk.Room({
          adaptiveStream: true, dynacast: true,
          videoCaptureDefaults: { resolution: { width:640, height:480, frameRate:24 } },
        });
        roomRef.current = r;

        const refresh = () => {
          if (!roomRef.current) return;
          const parts = [
            roomRef.current.localParticipant,
            ...Array.from(roomRef.current.remoteParticipants.values())
          ].filter(Boolean);
          setParticipants([...parts]);
        };

        r.on(lk.RoomEvent.ParticipantConnected, refresh);
        r.on(lk.RoomEvent.ParticipantDisconnected, refresh);
        r.on(lk.RoomEvent.TrackSubscribed, refresh);
        r.on(lk.RoomEvent.TrackUnsubscribed, refresh);
        r.on(lk.RoomEvent.TrackMuted, refresh);
        r.on(lk.RoomEvent.TrackUnmuted, refresh);
        r.on(lk.RoomEvent.LocalTrackPublished, refresh);
        r.on(lk.RoomEvent.LocalTrackUnpublished, refresh);
        r.on(lk.RoomEvent.Disconnected, () => { if (!cancelled) onClose(); });

        const token = lkToken || await generateLiveKitToken(lvRoomName, userId, me);
        console.log("[LiveKit] Connecting to", LK_URL, lkToken ? "(MatrixRTC token)" : "(local token)");
        await r.connect(LK_URL, token);
        if (cancelled) { r.disconnect(); return; }

        try { await r.localParticipant.setMicrophoneEnabled(true); } catch(e) { console.warn("mic error:", e.message); }
        if (video) { try { await r.localParticipant.setCameraEnabled(true); } catch(e) { console.warn("cam error:", e.message); } }
        if (cancelled) { r.disconnect(); return; }

        setRoom(r);
        setStatus("live");
        refresh();
      } catch(e) {
        if (!cancelled) { setStatus("error"); setErrMsg(e.message); console.error("LK error:", e); }
      }
    };
    go();
    return () => {
      cancelled = true;
      if (roomRef.current) {
        try {
          roomRef.current.localParticipant?.trackPublications?.forEach(pub => {
            pub.track?.mediaStreamTrack?.stop();
          });
        } catch(e) {}
        roomRef.current.disconnect();
        roomRef.current = null;
      }
    };
  }, []); // eslint-disable-line

  const toggleMute = async () => {
    if (!room) return;
    const next = !muted;
    await room.localParticipant.setMicrophoneEnabled(!next);
    setMuted(next);
  };
  const toggleCam = async () => {
    if (!room) return;
    const next = !camOff;
    await room.localParticipant.setCameraEnabled(!next);
    setCamOff(next);
  };

  const [facing, setFacing] = useState("user");
  const [hasMultipleCams, setHasMultipleCams] = useState(false);
  useEffect(() => {
    navigator.mediaDevices?.enumerateDevices().then(devices => {
      const cams = devices.filter(d => d.kind === "videoinput");
      setHasMultipleCams(cams.length > 1);
    }).catch(() => {});
  }, []);

  const switchCamera = async () => {
    if (!room || camOff || !LK) return;
    try {
      const newFacing = facing === "user" ? "environment" : "user";

      // Log all available cameras for debugging
      const devices = await navigator.mediaDevices.enumerateDevices();
      const cams = devices.filter(d => d.kind === "videoinput");
      console.log("📷 All cameras:", cams.map(c => `${c.label} [${c.deviceId.slice(0,8)}]`).join(", "));
      if (cams.length < 2) { console.warn("📷 Only 1 camera found"); return; }

      // Get current track settings
      const camSource = LK.Track?.Source?.Camera || "camera";
      let currentDeviceId = null;
      const pubs = roomRef.current?.localParticipant?.trackPublications;
      if (pubs) {
        for (const [, pub] of pubs) {
          if (pub.source === camSource) {
            const settings = pub.track?.mediaStreamTrack?.getSettings?.() || {};
            currentDeviceId = settings.deviceId || null;
            console.log("📷 Current track settings:", JSON.stringify(settings));
          }
        }
      }
      console.log("📷 currentDeviceId:", currentDeviceId);

      // Find next camera: pick by deviceId or fallback to facingMode
      let nextDeviceId = null;
      if (currentDeviceId) {
        const next = cams.find(d => d.deviceId !== currentDeviceId && d.deviceId !== "");
        nextDeviceId = next?.deviceId || null;
        console.log("📷 nextDeviceId:", nextDeviceId, "label:", next?.label);
      }

      // Approach: getUserMedia with facingMode or deviceId, then republish
      let newStream;
      if (nextDeviceId) {
        newStream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: { exact: nextDeviceId } }, audio: false
        });
      } else {
        // Fallback: use facingMode
        newStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { exact: newFacing } }, audio: false
        });
      }
      const newTrack = newStream.getVideoTracks()[0];
      console.log("📷 New track:", newTrack?.label, newTrack?.getSettings?.());

      // Unpublish old, publish new
      if (pubs) {
        for (const [, pub] of pubs) {
          if (pub.source === camSource) {
            pub.track?.mediaStreamTrack?.stop();
            await roomRef.current?.localParticipant?.unpublishTrack(pub.track);
            break;
          }
        }
      }
      await new Promise(r => setTimeout(r, 150));
      await roomRef.current?.localParticipant?.publishTrack(newTrack, {
        source: camSource,
        simulcast: false
      });

      setFacing(newFacing);
      console.log("📷 Switched to:", newFacing);
    } catch(e) { console.error("LK switchCamera error:", e.message, e); }
  };

  const hangup = () => {
    if (roomRef.current) {
      // Stop all local tracks so mic/camera indicators turn off
      try {
        roomRef.current.localParticipant?.audioTrackPublications?.forEach(pub => {
          pub.track?.mediaStreamTrack?.stop();
        });
        roomRef.current.localParticipant?.videoTrackPublications?.forEach(pub => {
          pub.track?.mediaStreamTrack?.stop();
        });
        // Fallback: also unpublish all tracks
        roomRef.current.localParticipant?.trackPublications?.forEach(pub => {
          pub.track?.mediaStreamTrack?.stop();
        });
      } catch(e) { console.warn("track stop error:", e.message); }
      roomRef.current.disconnect();
      roomRef.current = null;
    }
    onClose();
  };

  // Responsive grid: portrait (mobile) = single column stack, landscape = multi-column
  const isPortrait = typeof window !== "undefined" && window.innerHeight > window.innerWidth;
  const n = participants.length;
  const cols = isPortrait
    ? "1fr"                                          // mobile portrait: always 1 column
    : n <= 1 ? "1fr"
    : n <= 4 ? "1fr 1fr"
    : n <= 9 ? "1fr 1fr 1fr"
    : "1fr 1fr 1fr 1fr";

  // On portrait with 4 participants — 2 columns still makes sense
  const colsFinal = (isPortrait && n > 2) ? "1fr 1fr" : cols;

  return (
    <div className="lk-overlay">
      <canvas ref={rainRef} style={{position:"fixed",inset:0,zIndex:0,pointerEvents:"none",opacity:0.5,width:"100%",height:"100%"}} />
      <div style={{position:"relative",zIndex:1,width:"100%",height:"100dvh",display:"flex",flexDirection:"column",gap:0,overflow:"hidden"}}>
        {/* Header */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid var(--bor)",padding:"8px 12px",flexShrink:0,background:"rgba(0,0,0,0.7)"}}>  
          <span style={{fontFamily:"var(--disp)",fontSize:13,color:"var(--g)",letterSpacing:"0.12em",textShadow:"0 0 8px var(--g)"}}>
            {video?"📹":"🎤"} {roomName}
            {status==="live" && <span style={{marginLeft:10,fontSize:9,color:"var(--gd)"}}>
              {participants.length} {lang==="ru"?"участн.":"parts"}
            </span>}
          </span>
          <span style={{fontSize:10,fontFamily:"var(--mono)",
            color:status==="connecting"?"var(--gd)":status==="error"?"#ff4444":"var(--g)"}}>
            {status==="connecting"?"○ ПОДКЛЮЧЕНИЕ..."
              :status==="error"?`✗ ${errMsg.slice(0,40)}`
              :"● АКТИВНО"}
          </span>
        </div>
        {/* Grid */}
        <div style={{display:"grid",gridTemplateColumns:colsFinal,gridAutoRows:"1fr",gap:4,width:"100%",flex:1,minHeight:0,padding:"4px 4px 0"}}>
          {participants.map(p => (
            <LKTile key={p.identity} participant={p} lk={LK}
              client={client} isLocal={room && p===room.localParticipant} lang={lang} />
          ))}
          {status==="connecting" && (
            <div style={{aspectRatio:"16/9",background:"#020c02",border:"1px solid var(--bor)",
              display:"flex",alignItems:"center",justifyContent:"center",
              color:"var(--gd)",fontFamily:"var(--mono)",fontSize:11}}>
              ● {lang==="ru"?"ПОДКЛЮЧЕНИЕ...":"CONNECTING..."}
            </div>
          )}
        </div>
        {/* Controls */}
        <div className="call-btns">
          <button className={`call-btn mute${muted?" active":""}`} onClick={toggleMute}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {muted?<><line x1="2" y1="2" x2="22" y2="22"/><path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"/><path d="M5 10v2a7 7 0 0 0 12 4.93"/><path d="M15 9.34V5a3 3 0 0 0-5.68-1.33"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></>:<><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></>}
            </svg>
          </button>
          {video && <button className={`call-btn cam${camOff?" active":""}`} onClick={toggleCam}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {camOff?<><line x1="2" y1="2" x2="22" y2="22"/><path d="M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 1.76-1.05"/><polygon points="16 11 23 7 23 17 16 13 16 11"/></>:<><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></>}
            </svg>
          </button>}
          {video && !camOff && hasMultipleCams && (
            <button className="call-btn" onClick={switchCamera}
              style={{background:"var(--inp)",color:"var(--g)",border:"1px solid var(--bor)"}}
              title={lang==="ru"?(facing==="user"?"Включить основную камеру":"Включить фронтальную камеру"):(facing==="user"?"Switch to back camera":"Switch to front camera")}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 7h-3.5l-1.5-2h-6L7.5 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                <circle cx="12" cy="13" r="4"/>
                <path d="M18 9h.01" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </button>
          )}
          <button className="call-btn end" onClick={hangup}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Participant tile ──────────────────────────────────────────────────────
function LKTile({ participant, lk, client, isLocal, lang }) {
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const [hasVideo, setHasVideo] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const name = (participant?.identity||"?").replace(/^@/,"").split(":")[0];
  const avatarUrl = (() => {
    try {
      if (!client||!participant?.identity) return null;
      const mxc = client.getUser(participant.identity)?.avatarUrl;
      if (!mxc?.startsWith("mxc://")) return null;
      const p = mxc.slice(6).split("/");
      return `${client.getHomeserverUrl()}/_matrix/client/v1/media/download/${p[0]}/${p[1]}?access_token=${client.getAccessToken()}`;
    } catch(e){return null;}
  })();

  useEffect(() => {
    if (!participant || !lk) return;

    // Helper: get publication by source — works with livekit-client v1 and v2
    const getPub = (source) => {
      try {
        // v2: trackPublications is a Map
        if (participant.trackPublications instanceof Map) {
          for (const pub of participant.trackPublications.values()) {
            if (pub.source === source) return pub;
          }
        }
        // v1: getTrack method
        if (typeof participant.getTrack === 'function') {
          return participant.getTrack(source);
        }
        // Fallback: iterate tracks
        const pubs = participant.tracks || participant.trackPublications;
        if (pubs) {
          for (const [, pub] of pubs) {
            if (pub.source === source) return pub;
          }
        }
      } catch(e) { console.warn("getPub error:", e.message); }
      return null;
    };

    const update = () => {
      try {
        const camSrc = lk.Track?.Source?.Camera || 'camera';
        const micSrc = lk.Track?.Source?.Microphone || 'microphone';
        // Video
        const vPub = getPub(camSrc);
        const showVideo = !!(vPub && vPub.track && !vPub.isMuted);
        setHasVideo(showVideo);
        if (videoRef.current) {
          if (showVideo && vPub.track) {
            try { vPub.track.attach(videoRef.current); } catch(e) {}
          } else {
            videoRef.current.srcObject = null;
          }
        }
        // Audio (remote only)
        const aPub = getPub(micSrc);
        setIsMuted(!aPub || aPub.isMuted);
        if (!isLocal && audioRef.current && aPub?.track && !aPub.isMuted) {
          try { aPub.track.attach(audioRef.current); } catch(e) {}
        }
      } catch(e) { console.warn("LKTile update:", e.message); }
    };

    const evts = [
      lk.RoomEvent?.TrackMuted, lk.RoomEvent?.TrackUnmuted,
      lk.RoomEvent?.TrackSubscribed, lk.RoomEvent?.TrackUnsubscribed,
      lk.RoomEvent?.LocalTrackPublished, lk.RoomEvent?.LocalTrackUnpublished,
    ].filter(Boolean);
    evts.forEach(ev => participant.on(ev, update));
    update();
    return () => evts.forEach(ev => participant.off(ev, update));
  }, [participant, lk, isLocal]);

  return (
    <div style={{position:"relative",background:"#020c02",
      border:`1px solid ${isLocal?"var(--g)":"var(--bor)"}`,
      overflow:"hidden",width:"100%",height:"100%",
      boxShadow:isLocal?"0 0 10px var(--glow)":"none"}}>
      <video ref={videoRef} autoPlay playsInline muted
        style={{width:"100%",height:"100%",objectFit:"cover",display:hasVideo?"block":"none"}} />
      {!isLocal && <audio ref={audioRef} autoPlay style={{position:"absolute",width:0,height:0}} />}
      {!hasVideo && (
        <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",
          alignItems:"center",justifyContent:"center",gap:8,
          background:"linear-gradient(160deg,#020c02,#041a04)"}}>
          <div style={{width:48,height:48,border:"1px solid var(--bor)",overflow:"hidden",
            clipPath:"polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%)",
            background:"rgba(0,255,65,0.06)",display:"flex",alignItems:"center",justifyContent:"center"}}>
            {avatarUrl
              ? <img src={avatarUrl} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}} />
              : <span style={{fontFamily:"var(--disp)",fontSize:18,fontWeight:700,color:"var(--g)",textShadow:"0 0 8px var(--g)"}}>{name.slice(0,2).toUpperCase()}</span>}
          </div>
          <span style={{fontSize:10,color:"var(--gd)",fontFamily:"var(--mono)"}}>{name}</span>
        </div>
      )}
      {/* Bottom bar */}
      <div style={{position:"absolute",bottom:0,left:0,right:0,
        background:"linear-gradient(transparent,rgba(0,0,0,0.75))",
        padding:"12px 6px 4px",display:"flex",alignItems:"center",gap:4}}>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
          stroke={isMuted?"#ff4444":"#00ff41"} strokeWidth="2.5">
          {isMuted
            ?<><line x1="2" y1="2" x2="22" y2="22"/><path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"/><path d="M5 10v2a7 7 0 0 0 12 4.93"/><path d="M15 9.34V5a3 3 0 0 0-5.68-1.33"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></>
            :<><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></>}
        </svg>
        <span style={{fontSize:9,color:"#ccc",fontFamily:"var(--mono)",letterSpacing:"0.05em"}}>
          {name}{isLocal?(lang==="ru"?" (вы)":" (you)"):""}
        </span>
        {isLocal && <span style={{marginLeft:"auto",fontSize:8,color:"var(--g)",
          fontFamily:"var(--mono)",border:"1px solid var(--bor)",padding:"1px 4px"}}>LIVE</span>}
      </div>
    </div>
  );
}


function BootScreen({ onDone }) {
  const [lines, setLines] = useState([]); const [prog, setProg] = useState(0);
  const onDoneRef = useRef(onDone);
  useEffect(() => {
    let p = 0;
    const pid = setInterval(() => { p += 4; setProg(Math.min(p, 100)); if (p >= 100) clearInterval(pid); }, 40);
    BOOT_LINES.forEach((l, i) => setTimeout(() => {
      setLines(prev => [...prev, { ...l, i }]);
      if (i === BOOT_LINES.length - 1) setTimeout(() => onDoneRef.current?.(), 500);
    }, l.delay));
    return () => clearInterval(pid);
  }, []); // eslint-disable-line
  return (
    <div className="boot crt">
      {lines.map((l, i) => <div key={i} className={`boot-line ${l.cls || ""}`}>{l.text}{i === lines.length - 1 && <span className="boot-cursor" />}</div>)}
      <div className="boot-bar"><div className="boot-bar-fill" style={{ width: `${prog}%` }} /></div>
      <div style={{ fontSize: 10, color: "var(--gd)", letterSpacing: "0.1em" }}>LOADING {prog}%</div>
    </div>
  );
}

const initials = s => (s || "").replace(/^@/, "").slice(0, 2).toUpperCase() || "??";
const fmtTime = (ts, showDate = false) => {
  if (!ts) return "";
  const d = new Date(ts);
  const now = new Date();
  const isToday = d.toDateString() === now.toDateString();
  const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1);
  const isYesterday = d.toDateString() === yesterday.toDateString();
  const time = d.toLocaleTimeString("ru", { hour: "2-digit", minute: "2-digit" });
  if (isToday) return time;
  if (isYesterday) return (showDate ? "вчера, " : "вчера ") + time;
  const sameYear = d.getFullYear() === now.getFullYear();
  const dateStr = d.toLocaleDateString("ru", { day: "numeric", month: "short", ...(sameYear ? {} : { year: "numeric" }) });
  return dateStr + ", " + time;
};
const fmtDate = ts => ts ? new Date(ts).toLocaleDateString("ru") : "";
const shortName = s => (s || "").replace(/^@/, "").split(":")[0];
const mxcToHttp = (client, mxcUrl) => {
  try {
    if (!mxcUrl || !mxcUrl.startsWith("mxc://")) return null;
    const parts = mxcUrl.slice(6).split("/");
    const base = client.getHomeserverUrl();
    const token = client.getAccessToken();
    return `${base}/_matrix/client/v1/media/download/${parts[0]}/${parts[1]}?access_token=${token}`;
  } catch(e) { return null; }
};
const getAvatarUrl = (client, userId) => {
  try {
    const mxcUrl = client?.getUser(userId)?.avatarUrl;
    return mxcToHttp(client, mxcUrl);
  } catch(e) { return null; }
};

function getRoomName(room, myId) {
  if (room.name && room.name !== myId && !room.name.startsWith("Empty") && !room.name.startsWith("!")) return room.name;
  // Use all members (including left) for DM name — handles case when other user left
  const allMembers = (room.getMembers?.() || room.getJoinedMembers()).filter(m => m.userId !== myId);
  const joined = allMembers.filter(m => m.membership === "join" || m.membership === "invite");
  const others = joined.length ? joined : allMembers;
  return others.length ? (others[0].name || shortName(others[0].userId)) : room.roomId;
}
function isDM(room) {
  // Count all members (joined + left) to properly detect DM rooms
  const allMembers = room.getMembers?.() || room.getJoinedMembers();
  return allMembers.length <= 2 && !room.name?.startsWith("#");
}
function getLastMsg(room) {
  const evs = room.getLiveTimeline().getEvents();
  for (let i = evs.length - 1; i >= 0; i--) {
    const e = evs[i];
    if (e.getType() !== "m.room.message") continue;
    const c = e.getContent();
    // skip edit replacements
    if (c?.["m.relates_to"]?.rel_type === "m.replace") continue;
    const body = c?.["m.new_content"]?.body || c?.body || "";
    // strip quoted lines, take only actual message text
    if (body.includes("\n\n")) return body.split("\n\n").pop()?.trim() || body;
    const clean = body.split("\n").filter(l => !l.startsWith(">") && l.trim()).join(" ").trim();
    return clean || body;
  }
  return "";
}

function CreateRoomModal({ onClose, onSubmit, loading, lang }) {
  const [name, setName] = useState(""); const [topic, setTopic] = useState(""); const [priv, setPriv] = useState(true); const [enc, setEnc] = useState(true);
  const t = T[lang] || T.ru;
  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-title">// {t.createChannel}</div>
        <div className="modal-field">
          <div className="modal-label">{t.channelName}</div>
          <input className="modal-input" placeholder="my-channel" value={name} onChange={e => setName(e.target.value)} autoFocus />
        </div>
        <div className="modal-field">
          <div className="modal-label">{t.topic}</div>
          <input className="modal-input" placeholder="..." value={topic} onChange={e => setTopic(e.target.value)} />
        </div>
        <label className="modal-check">
          <input type="checkbox" checked={priv} onChange={e => setPriv(e.target.checked)} />
          {t.privateChannel}
        </label>
        <label className="modal-check">
          <input type="checkbox" checked={enc} onChange={e => setEnc(e.target.checked)} />
          🔒 {lang === "ru" ? "Шифрование E2EE" : "E2EE Encryption"}
        </label>
        <div className="modal-btns">
          <button className="modal-btn" onClick={onClose}>[ {t.cancel} ]</button>
          <button className="modal-btn primary" disabled={!name.trim() || loading} onClick={() => onSubmit({ name, topic, priv, enc })}>
            {loading ? `[ ${t.creating} ]` : `[ ${t.create} ]`}
          </button>
        </div>
      </div>
    </div>
  );
}

function NewDMModal({ onClose, onSubmit, loading, lang }) {
  const [userId, setUserId] = useState("");
  const t = T[lang] || T.ru;
  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-title">// {t.newDM}</div>
        <div className="modal-field">
          <div className="modal-label">{t.matrixId}</div>
          <input className="modal-input" placeholder="@username:chat.hipogas.org" value={userId}
            onChange={e => setUserId(e.target.value)} autoFocus
            onKeyDown={e => e.key === "Enter" && userId.trim() && onSubmit(userId.trim())} />
        </div>
        <div className="modal-btns">
          <button className="modal-btn" onClick={onClose}>[ {t.cancel} ]</button>
          <button className="modal-btn primary" disabled={!userId.trim() || loading} onClick={() => onSubmit(userId.trim())}>
            {loading ? `[ ${t.connecting} ]` : `[ ${t.connect} ]`}
          </button>
        </div>
      </div>
    </div>
  );
}

const T = {
  en: {
    settings:"SETTINGS", profile:"PROFILE", appearance:"APPEARANCE",
    language:"LANGUAGE", theme:"THEME", notifications:"NOTIFICATIONS",
    room:"CURRENT ROOM", session:"SESSION", close:"CLOSE",
    leaveRoom:"LEAVE ROOM", leaving:"LEAVING...", disconnect:"DISCONNECT",
    darkTheme:"DARK", lightTheme:"LIGHT", cyberpunkTheme:"CYBERPUNK", midnightTheme:"MIDNIGHT", amberTheme:"AMBER", redTheme:"RED",
    paperTheme:"PAPER", oceanTheme:"OCEAN", roseTheme:"ROSE",
    notifOn:"ENABLED", notifOff:"DISABLED",
    server:"SERVER", deviceId:"DEVICE ID",
    sessionStart:"SESSION_START", e2eeMsg:"E2EE ACTIVE — ONLY PARTICIPANTS CAN READ",
    syncing:"SYNCING", selectChannel:"SELECT CHANNEL",
    channels:"CHANNELS", direct:"DIRECT",
    typeMsg:"type message...", enterSend:"ENTER to send // SHIFT+ENTER newline",
    matrix:"MATRIX",
    createChannel:"CREATE_CHANNEL", channelName:"CHANNEL NAME", topic:"TOPIC (optional)",
    privateChannel:"PRIVATE CHANNEL", cancel:"CANCEL", create:"CREATE", creating:"CREATING...",
    newDM:"NEW_DIRECT_MESSAGE", matrixId:"MATRIX ID", connect:"CONNECT", connecting:"CONNECTING...",
  },
  ru: {
    settings:"НАСТРОЙКИ", profile:"ПРОФИЛЬ", appearance:"ВНЕШНИЙ ВИД",
    language:"ЯЗЫК", theme:"ТЕМА", notifications:"УВЕДОМЛЕНИЯ",
    room:"ТЕКУЩАЯ КОМНАТА", session:"СЕССИЯ", close:"ЗАКРЫТЬ",
    leaveRoom:"ВЫЙТИ ИЗ КОМНАТЫ", leaving:"ВЫХОДИМ...", disconnect:"ОТКЛЮЧИТЬСЯ",
    darkTheme:"ТЁМНАЯ (терминал)", lightTheme:"СВЕТЛАЯ", cyberpunkTheme:"КИБЕРПАНК", midnightTheme:"ПОЛНОЧЬ", amberTheme:"ЯНТАРНАЯ", redTheme:"КРАСНАЯ",
    paperTheme:"БУМАГА", oceanTheme:"ОКЕАН", roseTheme:"РОЗА",
    notifOn:"ВКЛЮЧЕНЫ", notifOff:"ВЫКЛЮЧЕНЫ",
    server:"СЕРВЕР", deviceId:"ID УСТРОЙСТВА",
    sessionStart:"НАЧАЛО СЕССИИ", e2eeMsg:"E2EE АКТИВНО — ТОЛЬКО УЧАСТНИКИ МОГУТ ЧИТАТЬ",
    syncing:"СИНХРОНИЗАЦИЯ", selectChannel:"ВЫБЕРИТЕ КАНАЛ",
    channels:"КАНАЛЫ", direct:"ЛИЧНЫЕ",
    typeMsg:"введите сообщение...", enterSend:"ENTER отправить // SHIFT+ENTER новая строка",
    matrix:"МАТРИКС",
    createChannel:"СОЗДАТЬ КАНАЛ", channelName:"НАЗВАНИЕ КАНАЛА", topic:"ТЕМА (необязательно)",
    privateChannel:"ПРИВАТНЫЙ КАНАЛ", cancel:"ОТМЕНА", create:"СОЗДАТЬ", creating:"СОЗДАЁМ...",
    newDM:"НОВОЕ ЛИЧНОЕ СООБЩЕНИЕ", matrixId:"MATRIX ID", connect:"ПОДКЛЮЧИТЬ", connecting:"ПОДКЛЮЧАЕМ...",
  }
};

// Helper: create UIA auth callback for cross-signing key upload
function makeAuthUploadDeviceSigningKeys(client) {
  return async (makeRequest) => {
    const userId = client.getUserId();
    const sess = JSON.parse(localStorage.getItem("nexus_session_" + userId) || "{}");
    const pass = sess.pass;
    // First try without auth (in case server doesn't require it)
    try { await makeRequest({}); return; } catch(e) {}
    // Then try with password auth
    if (pass) {
      try {
        await makeRequest({
          type: "m.login.password",
          identifier: { type: "m.id.user", user: userId },
          password: pass,
        });
        return;
      } catch(e) { console.warn("Cross-signing UIA auth failed:", e.message); }
    }
    // Last resort: try empty auth (some homeservers allow it for admin)
    try { await makeRequest({ type: "m.login.dummy" }); } catch(e) { console.warn("Cross-signing dummy auth failed:", e.message); throw e; }
  };
}

// Cross-sign all own devices after bootstrap
async function crossSignAllOwnDevices(client) {
  try {
    const crypto = client.getCrypto?.();
    if (!crypto) return;
    const userId = client.getUserId();
    const deviceMap = await crypto.getUserDeviceInfo?.([userId]).catch(() => null);
    if (!deviceMap) return;
    const devices = deviceMap.get?.(userId);
    if (!devices) return;
    for (const [devId] of devices) {
      try {
        // setDeviceVerified signs device with self-signing key and uploads signature
        await crypto.setDeviceVerified?.(userId, devId, true);
        console.log("E2EE: cross-signed device", devId, "✓");
      } catch(e) { console.log("E2EE: sign device", devId, ":", e.message); }
    }
  } catch(e) { console.log("E2EE: crossSignAllOwnDevices:", e.message); }
}

function E2EEStatus({ client, lang }) {
  const [status, setStatus] = useState(null);
  const [verifying, setVerifying] = useState(false);

  useEffect(() => {
    if (!client) return;
    const check = async () => {
      try {
        const crypto = client.getCrypto?.();
        if (!crypto) { setStatus({ ready: false, msg: lang === "ru" ? "Crypto не инициализирован" : "Crypto not initialized" }); return; }
        const cs = await crypto.getCrossSigningStatus?.();
        setStatus({
          ready: true,
          crossSigning: !!(cs?.publicKeysOnDevice && cs?.privateKeysCachedLocally),
          deviceId: client.getDeviceId?.(),
        });
      } catch(e) { setStatus({ ready: false, msg: e.message }); }
    };
    check();
  }, [client, lang]);

  const requestVerification = async () => {
    try {
      setVerifying(true);
      const crypto = client.getCrypto?.();
      if (!crypto) return;
      await crypto.bootstrapCrossSigning?.({ setupNewCrossSigning: true, authUploadDeviceSigningKeys: makeAuthUploadDeviceSigningKeys(client) });
      // Recovery pass to sign our device
      await crypto.bootstrapCrossSigning?.({ setupNewCrossSigning: false, authUploadDeviceSigningKeys: makeAuthUploadDeviceSigningKeys(client) }).catch(() => {});
      await crossSignAllOwnDevices(client);
      const cs = await crypto.getCrossSigningStatus?.();
      setStatus({ ready: true, crossSigning: !!(cs?.publicKeysOnDevice && cs?.privateKeysCachedLocally), deviceId: client.getDeviceId?.() });
    } catch(e) { console.warn("E2EE setup:", e.message); }
    finally { setVerifying(false); }
  };

  if (!status) return <div style={{fontSize:10,color:"var(--gd)",padding:"6px 8px",background:"var(--inp)",border:"1px solid var(--bor)",marginBottom:10}}>...</div>;
  if (!status.ready) return <div style={{fontSize:10,color:"#ff4444",padding:"6px 8px",background:"var(--inp)",border:"1px solid var(--bor)",marginBottom:10}}>{status.msg}</div>;

  return (
    <div style={{fontSize:10,background:"var(--inp)",border:"1px solid var(--bor)",marginBottom:10,overflow:"hidden"}}>
      <div style={{display:"flex",alignItems:"center",gap:6,padding:"5px 8px",borderBottom:"1px solid var(--bor)"}}>
        <span style={{color:"var(--g)"}}>✓</span>
        <span style={{color:"var(--gd)",letterSpacing:"0.08em"}}>{lang==="ru" ? "Шифрование" : "Encryption"}</span>
        <span style={{marginLeft:"auto",color:"var(--g)"}}>ACTIVE</span>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:6,padding:"5px 8px",borderBottom:"1px solid var(--bor)"}}>
        <span style={{color: status.crossSigning ? "var(--g)" : "#ff8800"}}>{status.crossSigning ? "✓" : "⚠"}</span>
        <span style={{color:"var(--gd)",letterSpacing:"0.08em"}}>{lang==="ru" ? "Кросс-подпись" : "Cross-signing"}</span>
        <span style={{marginLeft:"auto",color: status.crossSigning ? "var(--g)" : "#ff8800"}}>{status.crossSigning ? (lang==="ru"?"АКТИВНА":"ACTIVE") : (lang==="ru"?"НЕ НАСТРОЕНА":"NOT SET UP")}</span>
      </div>
      {!status.crossSigning && (
        <button onClick={requestVerification} disabled={verifying} style={{width:"100%",padding:"7px",background:"none",border:"none",borderTop:"1px solid var(--bor)",color:"var(--am)",fontFamily:"var(--mono)",fontSize:10,cursor:"pointer",letterSpacing:"0.1em"}}>
          {verifying ? "[ ... ]" : (lang==="ru" ? "[ НАСТРОИТЬ КРОСС-ПОДПИСЬ ]" : "[ SETUP CROSS-SIGNING ]")}
        </button>
      )}
    </div>
  );
}

function SettingsPanel({ myUserId, onLogout, onClose, activeRoom, client, lang, setLang, theme, setTheme, notifs, setNotifs, font, setFont, fontSize, setFontSize, rainMode, setRainMode }) {
  const [tab, setTab] = useState("profile");
  const [leaving, setLeaving] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [savingName, setSavingName] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [savingPass, setSavingPass] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });
  const [extProfile, setExtProfile] = useState({});
  const [extVisible, setExtVisible] = useState({});
  const [savingExt, setSavingExt] = useState(false);
  const [recoveryKey, setRecoveryKey] = useState("");
  const [recoveryLoading, setRecoveryLoading] = useState(false);
  const [recoveryKeyCopied, setRecoveryKeyCopied] = useState(false);
  const [rebootingBackup, setRebootingBackup] = useState(false);

  const t = T[lang] || T.ru;

  useEffect(() => {
    if (client) {
      const profile = client.getUser(myUserId);
      setDisplayName(profile?.displayName || shortName(myUserId));
      try {
        const own = client.getAccountData("nexus.profile.ext")?.getContent() || {};
        const vis = client.getAccountData("nexus.profile.visibility")?.getContent() || {};
        setExtProfile(own); setExtVisible(vis);
      } catch(e) {}
    }
  }, [client, myUserId]);

  const saveExtProfile = async () => {
    setSavingExt(true);
    try {
      await client.setAccountData("nexus.profile.ext", extProfile);
      await client.setAccountData("nexus.profile.visibility", extVisible);
      const pubData = {};
      PROFILE_FIELDS.forEach(f => { if (extVisible[f.key] && extProfile[f.key]) pubData[f.key] = extProfile[f.key]; });
      const rooms = client.getRooms().filter(r => r.getMember(myUserId)?.membership === "join");
      for (const r of rooms.slice(0,10)) {
        try { await client.sendStateEvent(r.roomId, "nexus.profile.public", pubData, myUserId); } catch(e) {}
      }
      setMsg({ type:"ok", text: lang==="ru"?"✓ Профиль сохранён":"✓ Profile saved" });
    } catch(e) { setMsg({ type:"err", text: e.message }); }
    finally { setSavingExt(false); }
  };

  const leaveRoom = async () => {
    if (!activeRoom || !client) return;
    setLeaving(true);
    try { await client.leave(activeRoom.roomId); onClose(); }
    catch (e) { setMsg({ type: "err", text: e.message }); }
    finally { setLeaving(false); }
  };

  const saveDisplayName = async () => {
    setSavingName(true); setMsg({ type: "", text: "" });
    try {
      await client.setDisplayName(displayName);
      setMsg({ type: "ok", text: lang === "ru" ? "✓ Имя сохранено" : "✓ Name saved" });
    } catch(e) { setMsg({ type: "err", text: e.message }); }
    finally { setSavingName(false); }
  };

  const savePassword = async () => {
    if (newPassword !== newPassword2) {
      setMsg({ type: "err", text: lang === "ru" ? "Пароли не совпадают" : "Passwords do not match" }); return;
    }
    if (newPassword.length < 6) {
      setMsg({ type: "err", text: lang === "ru" ? "Минимум 6 символов" : "Min 6 characters" }); return;
    }
    setSavingPass(true); setMsg({ type: "", text: "" });
    try {
      await client.setPassword({ type: "m.login.password", user: myUserId, password: oldPassword }, newPassword);
      setMsg({ type: "ok", text: lang === "ru" ? "✓ Пароль изменён" : "✓ Password changed" });
      setOldPassword(""); setNewPassword(""); setNewPassword2("");
    } catch(e) { setMsg({ type: "err", text: e.message }); }
    finally { setSavingPass(false); }
  };

  const tl = {
    profile: lang === "ru" ? "Профиль" : "Profile",
    appearance: lang === "ru" ? "Внешний вид" : "Appearance",
    security: lang === "ru" ? "Безопасность" : "Security",
    room: lang === "ru" ? "Комната" : "Room",
    session: lang === "ru" ? "Сессия" : "Session",
    displayName: lang === "ru" ? "ОТОБРАЖАЕМОЕ ИМЯ" : "DISPLAY NAME",
    userId: lang === "ru" ? "ID ПОЛЬЗОВАТЕЛЯ" : "USER ID",
    deviceId: lang === "ru" ? "ID УСТРОЙСТВА" : "DEVICE ID",
    save: lang === "ru" ? "СОХРАНИТЬ" : "SAVE",
    saving: lang === "ru" ? "СОХРАНЯЕМ..." : "SAVING...",
    changePass: lang === "ru" ? "СМЕНА ПАРОЛЯ" : "CHANGE PASSWORD",
    oldPass: lang === "ru" ? "ТЕКУЩИЙ ПАРОЛЬ" : "CURRENT PASSWORD",
    newPass: lang === "ru" ? "НОВЫЙ ПАРОЛЬ" : "NEW PASSWORD",
    newPass2: lang === "ru" ? "ПОВТОРИТЕ ПАРОЛЬ" : "CONFIRM PASSWORD",
    theme: lang === "ru" ? "ТЕМА" : "THEME",
    language: lang === "ru" ? "ЯЗЫК" : "LANGUAGE",
    notifs: lang === "ru" ? "УВЕДОМЛЕНИЯ" : "NOTIFICATIONS",
    darkTheme: lang === "ru" ? "ТЁМНАЯ" : "DARK",
    lightTheme: lang === "ru" ? "СВЕТЛАЯ" : "LIGHT",
    on: lang === "ru" ? "ВКЛ" : "ON",
    off: lang === "ru" ? "ВЫКЛ" : "OFF",
    leaveRoom: lang === "ru" ? "ПОКИНУТЬ КОМНАТУ" : "LEAVE ROOM",
    disconnect: lang === "ru" ? "ВЫЙТИ" : "DISCONNECT",
    settings: lang === "ru" ? "НАСТРОЙКИ" : "SETTINGS",
    server: lang === "ru" ? "СЕРВЕР" : "SERVER",
  };

  const tabs = [
    { id: "profile", label: tl.profile, icon: "◉" },
    { id: "appearance", label: tl.appearance, icon: "◈" },
    { id: "security", label: tl.security, icon: "🔒" },
    { id: "session", label: tl.session, icon: "⏻" },
  ];

  const btnStyle = (primary) => ({
    padding: "7px 14px", border: `1px solid ${primary ? "var(--g)" : "var(--bor)"}`,
    background: primary ? "var(--dk)" : "none", color: primary ? "var(--g)" : "var(--gd)",
    fontFamily: "var(--mono)", fontSize: 11, cursor: "pointer",
    clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)",
    boxShadow: primary ? "0 0 8px var(--glow)" : "none", transition: "all 0.12s",
  });

  const inputStyle = {
    width: "100%", background: "var(--inp)", border: "1px solid var(--bor)",
    padding: "8px 10px", color: "var(--g)", fontFamily: "var(--mono)", fontSize: 12,
    outline: "none", marginBottom: 10, caret_color: "var(--g)",
  };

  const labelStyle = { fontSize: 10, color: "#008a20", marginBottom: 5, letterSpacing: "0.1em", display: "block" };
  const serverUrl = client?.getHomeserverUrl?.()?.replace(/^https?:\/\//, "") || "";
  const deviceId = client?.getDeviceId?.() || "—";

  return (
    <div className="settings-panel" style={{ width: 320, background: "var(--pan)", borderLeft: "1px solid var(--bor)", display: "flex", flexDirection: "column", flexShrink: 0, animation: "slideIn 0.2s", overflow: "hidden" }}>
      {/* Header */}
      <div style={{ padding: "14px 16px", borderBottom: "1px solid var(--bor)", display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontFamily: "var(--disp)", fontSize: 11, fontWeight: 700, color: "var(--g)", letterSpacing: "0.15em", textShadow: "0 0 8px var(--g)", flex: 1 }}>// {tl.settings}</span>
        <button onClick={onClose} style={{ background: "none", border: "none", color: "var(--gd)", cursor: "pointer", fontSize: 16 }}>✕</button>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", borderBottom: "1px solid var(--bor)", flexShrink: 0 }}>
        {tabs.map(tb => (
          <div key={tb.id} onClick={() => { setTab(tb.id); setMsg({ type:"", text:"" }); }}
            style={{ flex: 1, padding: "8px 4px", textAlign: "center", cursor: "pointer", fontSize: 9, letterSpacing: "0.08em", borderBottom: `2px solid ${tab === tb.id ? "var(--g)" : "transparent"}`, color: tab === tb.id ? "var(--g)" : "var(--gd)", background: tab === tb.id ? "var(--glow)" : "none", transition: "all 0.12s" }}>
            <div style={{ fontSize: 14, marginBottom: 2 }}>{tb.icon}</div>
            {tb.label}
          </div>
        ))}
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflowY: "auto", padding: "16px" }}>
        {msg.text && (
          <div style={{ marginBottom: 12, padding: "7px 10px", fontSize: 11, border: `1px solid ${msg.type === "ok" ? "var(--bor)" : "rgba(255,49,49,0.3)"}`, background: msg.type === "ok" ? "var(--glow)" : "rgba(255,49,49,0.05)", color: msg.type === "ok" ? "var(--g)" : "var(--rd)" }}>
            {msg.text}
          </div>
        )}

        {/* PROFILE */}
        {tab === "profile" && (
          <div>
            {/* Avatar */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20, padding: 12, background: "var(--inp)", border: "1px solid var(--bor)" }}>
              <div style={{ position:"relative", cursor:"pointer" }} onClick={() => document.getElementById("av-upload").click()}>
                <div style={{ width: 52, height: 52, background: "var(--dk)", border: "1px solid var(--borb)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "var(--disp)", fontSize: 16, fontWeight: 700, color: "var(--g)", clipPath: "polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%)", overflow:"hidden" }}>
                  {getAvatarUrl(client, myUserId)
                    ? <img className="av-img" src={getAvatarUrl(client, myUserId)} alt="" />
                    : initials(myUserId)}
                </div>
                <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, opacity:0, transition:"opacity 0.15s" }}
                  onMouseOver={e=>e.currentTarget.style.opacity=1} onMouseOut={e=>e.currentTarget.style.opacity=0}>📷</div>
              </div>
              <input type="file" id="av-upload" accept="image/*" style={{display:"none"}} onChange={async e => {
                const file = e.target.files[0]; if (!file) return;
                e.target.value = "";
                try {
                  const uploaded = await client.uploadContent(file, { type: file.type });
                  const mxcUri = uploaded.content_uri || (typeof uploaded === "string" ? uploaded : null);
                  if (mxcUri) await client.setAvatarUrl(mxcUri);
                  setMsg({ type:"ok", text: lang==="ru"?"✓ Аватар обновлён":"✓ Avatar updated" });
                } catch(err) { setMsg({ type:"err", text: err.message }); }
              }} />
              <div>
                <div style={{ fontSize: 13, color: "var(--g)", textShadow: "0 0 6px var(--g)" }}>{shortName(myUserId)}</div>
                <div style={{ fontSize: 10, color: "#008a20", marginTop: 2 }}>{myUserId}</div>
                <div style={{ fontSize: 9, color:"var(--gd)", marginTop:4 }}>{lang==="ru"?"Нажмите на аватар для загрузки":"Click avatar to upload"}</div>
              </div>
            </div>
            <label style={labelStyle}>{tl.displayName}</label>
            <input value={displayName} onChange={e => setDisplayName(e.target.value)} style={inputStyle} />
            <button onClick={saveDisplayName} disabled={savingName} style={btnStyle(true)}>
              [ {savingName ? tl.saving : tl.save} ]
            </button>
            <div style={{ marginTop: 20, paddingTop: 16, borderTop: "1px solid var(--bor)" }}>
              <label style={labelStyle}>{tl.userId}</label>
              <div style={{ fontSize: 11, color: "var(--gd)", padding: "6px 8px", background: "var(--inp)", border: "1px solid var(--bor)", marginBottom: 10, wordBreak: "break-all" }}>{myUserId}</div>
              <label style={labelStyle}>{tl.server}</label>
              <div style={{ fontSize: 11, color: "var(--gd)", padding: "6px 8px", background: "var(--inp)", border: "1px solid var(--bor)", marginBottom: 10 }}>{serverUrl}</div>
              <label style={labelStyle}>{tl.deviceId}</label>
              <div style={{ fontSize: 11, color: "var(--gd)", padding: "6px 8px", background: "var(--inp)", border: "1px solid var(--bor)", marginBottom: 10 }}>{deviceId}</div>
              <label style={labelStyle}>🔒 {lang === "ru" ? "ШИФРОВАНИЕ E2EE" : "E2EE ENCRYPTION"}</label>
              <E2EEStatus client={client} lang={lang} />
            </div>

            {/* Extended profile fields */}
            <div style={{ marginTop:20, paddingTop:16, borderTop:"1px solid var(--bor)" }}>
              <div style={{ fontSize:10, color:"var(--gd)", letterSpacing:"0.15em", marginBottom:12 }}>
                // {lang==="ru"?"ПРОФИЛЬ":"PROFILE"}
                <span style={{ marginLeft:8, fontSize:9, opacity:0.5 }}>👁 = {lang==="ru"?"видно всем":"visible to all"}</span>
              </div>
              {PROFILE_FIELDS.map(f => (
                <div key={f.key} style={{ marginBottom:10 }}>
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:3 }}>
                    <label style={{ fontSize:9, color:"var(--gd)", letterSpacing:"0.12em" }}>{f.icon} {lang==="ru"?f.label:f.labelEn}</label>
                    <label style={{ display:"flex", alignItems:"center", gap:4, cursor:"pointer", fontSize:10,
                      color:extVisible[f.key]?"var(--g)":"var(--gd)" }}>
                      <input type="checkbox" checked={!!extVisible[f.key]}
                        onChange={e => setExtVisible(v => ({...v,[f.key]:e.target.checked}))}
                        style={{ accentColor:"var(--g)", cursor:"pointer" }} />
                      👁
                    </label>
                  </div>
                  {f.type === "textarea"
                    ? <textarea rows={3} value={extProfile[f.key]||""} placeholder="..."
                        onChange={e => setExtProfile(d => ({...d,[f.key]:e.target.value}))}
                        style={{ width:"100%", background:"var(--inp)", border:"1px solid var(--bor)",
                          color:"var(--g)", fontFamily:"var(--mono)", fontSize:11, padding:"5px 8px",
                          outline:"none", boxSizing:"border-box", resize:"vertical" }} />
                    : <input type="text" value={extProfile[f.key]||""} placeholder={f.type==="date"?"YYYY-MM-DD":""}
                        onChange={e => setExtProfile(d => ({...d,[f.key]:e.target.value}))}
                        style={{ width:"100%", background:"var(--inp)", border:"1px solid var(--bor)",
                          color:"var(--g)", fontFamily:"var(--mono)", fontSize:11, padding:"5px 8px",
                          outline:"none", boxSizing:"border-box" }} />
                  }
                </div>
              ))}
              <button onClick={saveExtProfile} disabled={savingExt} style={btnStyle(true)}>
                [ {savingExt ? tl.saving : (lang==="ru"?"СОХРАНИТЬ ПРОФИЛЬ":"SAVE PROFILE")} ]
              </button>
            </div>
          </div>
        )}

        {/* APPEARANCE */}
        {tab === "appearance" && (
          <div>
            <label style={labelStyle}>{tl.theme}</label>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6, marginBottom: 16 }}>
              {[
                ["dark","🌑",tl.darkTheme],["light","☀️",tl.lightTheme],
                ["cyberpunk","⚡",tl.cyberpunkTheme],["midnight","🌙",tl.midnightTheme],
                ["amber","🟡",tl.amberTheme],["red","🔴",tl.redTheme],
                ["paper","📄",tl.paperTheme],["ocean","🌊",tl.oceanTheme],["rose","🌸",tl.roseTheme]
              ].map(([id,icon,label]) => (
                <div key={id} onClick={() => { setTheme(id); localStorage.setItem("nexus_theme", id); }}
                  style={{ padding: "8px 4px", border: `1px solid ${theme===id?"var(--borb)":"var(--bor)"}`, background: theme===id?"var(--glow)":"none", cursor: "pointer", textAlign: "center", fontSize: 10, color: theme===id?"var(--g)":"var(--gd)", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", transition: "all 0.12s", boxShadow: theme===id?"0 0 8px var(--glow)":"none", letterSpacing:"0.05em" }}>
                  <div style={{fontSize:16,marginBottom:3}}>{icon}</div>
                  {label}
                </div>
              ))}
            </div>

            <label style={{...labelStyle, marginTop:4}}>{lang==="ru"?"ШРИФТ":"FONT"}</label>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:5, marginBottom:14 }}>
              {[
                ["mono","Share Tech","mono"],["courier","Courier","courier"],["fira","Fira Code","fira"],
                ["jetbrains","JetBrains","jetbrains"],["space","Space Mono","space"],["ubuntu","Ubuntu","ubuntu"]
              ].map(([id,label,cls]) => (
                <div key={id} onClick={() => { setFont(id); localStorage.setItem("nexus_font",id); }}
                  style={{padding:"6px 4px",border:`1px solid ${font===id?"var(--borb)":"var(--bor)"}`,
                    background:font===id?"var(--glow)":"none",cursor:"pointer",textAlign:"center",
                    fontSize:9,color:font===id?"var(--g)":"var(--gd)",
                    clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)",
                    transition:"all 0.12s",letterSpacing:"0.03em",lineHeight:1.4,fontFamily:`var(--mono)`}}>
                  {label}
                </div>
              ))}
            </div>

            <label style={{...labelStyle, marginTop:4}}>{lang==="ru"?"РАЗМЕР ТЕКСТА":"TEXT SIZE"}</label>
            <div style={{ display:"flex", gap:5, marginBottom:14 }}>
              {[["sm","A-"],["md","A"],["lg","A+"],["xl","A++"]].map(([id,label]) => (
                <div key={id} onClick={() => { setFontSize(id); localStorage.setItem("nexus_fsize",id); }}
                  style={{flex:1,padding:"7px 4px",border:`1px solid ${fontSize===id?"var(--borb)":"var(--bor)"}`,
                    background:fontSize===id?"var(--glow)":"none",cursor:"pointer",textAlign:"center",
                    fontSize:id==="sm"?10:id==="md"?12:id==="lg"?14:16,
                    color:fontSize===id?"var(--g)":"var(--gd)",
                    clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)",transition:"all 0.12s"}}>
                  {label}
                </div>
              ))}
            </div>

            <label style={labelStyle}>{tl.language}</label>
            <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
              {["ru","en"].map(l => (
                <div key={l} onClick={() => setLang(l)} style={{ flex: 1, padding: "8px 6px", border: `1px solid ${lang===l?"var(--borb)":"var(--bor)"}`, background: lang===l?"var(--glow)":"none", cursor: "pointer", textAlign: "center", fontSize: 12, color: lang===l?"var(--g)":"var(--gd)", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", transition: "all 0.12s" }}>
                  {l === "ru" ? "🇷🇺 RU" : "🇬🇧 EN"}
                </div>
              ))}
            </div>
            <label style={labelStyle}>{tl.notifs}</label>
            <div style={{ display: "flex", gap: 6 }}>
              {[true,false].map(v => (
                <div key={String(v)} onClick={() => setNotifs(v)} style={{ flex: 1, padding: "8px 6px", border: `1px solid ${notifs===v?"var(--borb)":"var(--bor)"}`, background: notifs===v?"var(--glow)":"none", cursor: "pointer", textAlign: "center", fontSize: 11, color: notifs===v?"var(--g)":"var(--gd)", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)" }}>
                  {v ? tl.on : tl.off}
                </div>
              ))}
            </div>

            <label style={{...labelStyle, marginTop:14}}>🌧 {lang==="ru"?"МАТРИЧНЫЙ ДОЖДЬ В ЧАТЕ":"MATRIX RAIN IN CHAT"}</label>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:5 }}>
              {[
                ["off",   "✕", lang==="ru"?"ВЫКЛ":"OFF"],
                ["subtle","·", lang==="ru"?"ТИХИЙ":"SUBTLE"],
                ["intense","▓", lang==="ru"?"ИНТЕНС.":"INTENSE"],
                ["chaos", "█", lang==="ru"?"ХАОС":"CHAOS"],
              ].map(([id, icon, label]) => (
                <div key={id} onClick={() => setRainMode(id)}
                  style={{ padding:"8px 4px", border:`1px solid ${rainMode===id?"var(--borb)":"var(--bor)"}`,
                    background:rainMode===id?"var(--glow)":"none", cursor:"pointer", textAlign:"center",
                    fontSize:9, color:rainMode===id?"var(--g)":"var(--gd)",
                    clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)",
                    transition:"all 0.12s", letterSpacing:"0.05em" }}>
                  <div style={{fontSize:16,marginBottom:3}}>{icon}</div>
                  {label}
                </div>
              ))}
            </div>
            <div style={{fontSize:9,color:"var(--gd)",opacity:0.5,marginTop:4,letterSpacing:"0.05em"}}>
              {lang==="ru"?"Дождь отображается только в тёмных темах":"Rain only visible in dark themes"}
            </div>
          </div>
        )}

        {/* SECURITY */}
        {tab === "security" && (
          <div>
            <div style={{ fontSize: 12, color: "var(--g)", marginBottom: 16, letterSpacing: "0.08em" }}>// {tl.changePass}</div>
            {/* Hidden dummy fields to prevent browser autofill on visible inputs */}
            <input type="text" name="username" autoComplete="username" style={{ display:"none" }} readOnly />
            <label style={labelStyle}>{tl.oldPass}</label>
            <input type="password" name="current-password" autoComplete="current-password" value={oldPassword} onChange={e => setOldPassword(e.target.value)} style={inputStyle} placeholder="••••••••" />
            <label style={labelStyle}>{tl.newPass}</label>
            <input type="password" name="new-password" autoComplete="new-password" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={inputStyle} placeholder="••••••••" />
            <label style={labelStyle}>{tl.newPass2}</label>
            <input type="password" name="confirm-password" autoComplete="new-password" value={newPassword2} onChange={e => setNewPassword2(e.target.value)} style={inputStyle} placeholder="••••••••" onKeyDown={e => e.key === "Enter" && savePassword()} />
            <button onClick={savePassword} disabled={savingPass || !oldPassword || !newPassword} style={btnStyle(true)}>
              [ {savingPass ? tl.saving : tl.save} ]
            </button>

            {/* Recovery Key Section */}
            <div style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid var(--bor)" }}>
              <div style={{ fontSize: 12, color: "var(--g)", marginBottom: 8, letterSpacing: "0.08em" }}>// {lang === "ru" ? "КЛЮЧ ВОССТАНОВЛЕНИЯ" : "RECOVERY KEY"}</div>
              <div style={{ fontSize: 10, color: "var(--gd)", marginBottom: 12, lineHeight: 1.5 }}>
                {lang === "ru"
                  ? "Используйте этот ключ для входа через Element или другие Matrix-клиенты. Сохраните его в надёжном месте."
                  : "Use this key to sign in via Element or other Matrix clients. Keep it somewhere safe."}
              </div>
              {recoveryKey ? (
                <div>
                  <div style={{ padding: "10px 12px", background: "var(--dk)", border: "1px solid var(--g)", fontFamily: "var(--mono)", fontSize: 11, color: "var(--g)", wordBreak: "break-all", letterSpacing: "0.05em", marginBottom: 8, userSelect: "all" }}>
                    {recoveryKey}
                  </div>
                  <button onClick={() => { navigator.clipboard?.writeText(recoveryKey); setRecoveryKeyCopied(true); setTimeout(() => setRecoveryKeyCopied(false), 2000); }} style={btnStyle(true)}>
                    [ {recoveryKeyCopied ? "✓ " + (lang === "ru" ? "СКОПИРОВАНО" : "COPIED") : (lang === "ru" ? "КОПИРОВАТЬ" : "COPY")} ]
                  </button>
                </div>
              ) : (
                <button onClick={async () => {
                  setRecoveryLoading(true);
                  try {
                    const sess = JSON.parse(localStorage.getItem("nexus_session_" + myUserId) || "{}");
                    const pass = sess.pass;
                    if (!pass) { setMsg({ type: "err", text: lang === "ru" ? "Пароль не сохранён в сессии" : "Password not stored in session" }); return; }
                    const baseUrl = client.getHomeserverUrl();
                    const token = client.getAccessToken();
                    // Get default key info to determine which hash was used
                    const defaultKeyData = await client.getAccountDataFromServer?.("m.secret_storage.default_key").catch(() => null);
                    const defaultKeyId = defaultKeyData?.key;
                    const keyInfoData = defaultKeyId ? await client.getAccountDataFromServer?.("m.secret_storage.key." + defaultKeyId).catch(() => null) : null;
                    // Get the encrypted backup key
                    const backupKeySecret = await client.getAccountDataFromServer?.("m.megolm_backup.v1").catch(() => null);
                    const encEntry = backupKeySecret?.encrypted?.[defaultKeyId];
                    if (!encEntry || !defaultKeyId) { setMsg({ type: "err", text: "No backup key found" }); return; }
                    // Try SHA-512 then SHA-256
                    let backupKeyBytes = null;
                    for (const hashAlg of ["SHA-512", "SHA-256"]) {
                      try {
                        const pbkdf2Key = await deriveKeyFromPassword(pass, myUserId, hashAlg);
                        const hkdfKey = await window.crypto.subtle.importKey("raw", pbkdf2Key, "HKDF", false, ["deriveBits"]);
                        const derived = await window.crypto.subtle.deriveBits(
                          { name: "HKDF", hash: "SHA-256", salt: new Uint8Array(32), info: new TextEncoder().encode("m.megolm_backup.v1") },
                          hkdfKey, 512
                        );
                        const aesKeyBytes = new Uint8Array(derived).slice(0, 32);
                        const iv = Uint8Array.from(atob(encEntry.iv), c => c.charCodeAt(0));
                        const ct = Uint8Array.from(atob(encEntry.ciphertext), c => c.charCodeAt(0));
                        const aesKey = await window.crypto.subtle.importKey("raw", aesKeyBytes, { name: "AES-CTR" }, false, ["decrypt"]);
                        const decRaw = await window.crypto.subtle.decrypt({ name: "AES-CTR", counter: iv, length: 64 }, aesKey, ct);
                        const decStr = new TextDecoder().decode(decRaw);
                        const b64 = decStr.replace(/-/g, "+").replace(/_/g, "/");
                        const decoded = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
                        if (decoded.length === 32) { backupKeyBytes = decoded; break; }
                      } catch(e) {}
                    }
                    if (!backupKeyBytes) { setMsg({ type: "err", text: "Could not decrypt backup key" }); return; }
                    setRecoveryKey(encodeRecoveryKey(backupKeyBytes));
                  } catch(e) { setMsg({ type: "err", text: e.message }); }
                  finally { setRecoveryLoading(false); }
                }} disabled={recoveryLoading} style={btnStyle(true)}>
                  [ {recoveryLoading ? "..." : (lang === "ru" ? "ПОКАЗАТЬ КЛЮЧ" : "SHOW KEY")} ]
                </button>
              )}
            </div>

            {/* Re-bootstrap for Element compatibility */}
            <div style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid var(--bor)" }}>
              <div style={{ fontSize: 12, color: "var(--warn, #f0a030)", marginBottom: 8, letterSpacing: "0.08em" }}>// {lang === "ru" ? "СОВМЕСТИМОСТЬ С ELEMENT" : "ELEMENT COMPATIBILITY"}</div>
              <div style={{ fontSize: 10, color: "var(--gd)", marginBottom: 12, lineHeight: 1.5 }}>
                {lang === "ru"
                  ? "Пересоздаёт ключи шифрования в формате, совместимом с Element. После этого в Element можно будет войти, используя ваш пароль как passphrase. Текущие ключи будут сохранены."
                  : "Re-creates encryption keys in Element-compatible format. After this, Element can use your password as passphrase. Current keys will be preserved."}
              </div>
              <button onClick={async () => {
                setRebootingBackup(true);
                try {
                  const sess = JSON.parse(localStorage.getItem("nexus_session_" + myUserId) || "{}");
                  const pass = sess.pass;
                  if (!pass) { setMsg({ type: "err", text: lang === "ru" ? "Пароль не сохранён" : "Password not stored" }); return; }
                  const crypto = client.getCrypto?.();
                  if (!crypto) { setMsg({ type: "err", text: "Crypto not available" }); return; }
                  const privateKey = await deriveKeyFromPassword(pass, myUserId, "SHA-512");
                  await crypto.bootstrapSecretStorage({
                    createSecretStorageKey: async () => ({
                      keyInfo: { passphrase: { algorithm: "m.pbkdf2", iterations: 500000, salt: myUserId, bits: 256 } },
                      privateKey
                    }),
                    setupNewKeyBackup: true,
                    setupNewSecretStorage: true,
                  });
                  // Set up cross-signing so Element can verify this device
                  await crypto.bootstrapCrossSigning?.({ setupNewCrossSigning: true, authUploadDeviceSigningKeys: makeAuthUploadDeviceSigningKeys(client) }).catch(e => console.warn("Cross-signing:", e.message));
                  // Recovery pass: reads back keys → signs device
                  await crypto.bootstrapCrossSigning?.({ setupNewCrossSigning: false, authUploadDeviceSigningKeys: makeAuthUploadDeviceSigningKeys(client) }).catch(e => console.warn("Cross-signing recovery:", e.message));
                  await crossSignAllOwnDevices(client);
                  localStorage.setItem("nexus_e2ee_setup_" + myUserId, "1");
                  setRecoveryKey("");
                  setMsg({ type: "ok", text: lang === "ru" ? "✓ Ключи пересозданы! Теперь Element сможет использовать ваш пароль." : "✓ Keys re-created! Element can now use your password." });
                } catch(e) { setMsg({ type: "err", text: e.message }); }
                finally { setRebootingBackup(false); }
              }} disabled={rebootingBackup} style={{ ...btnStyle(false), borderColor: "rgba(240,160,48,0.4)", color: "var(--warn, #f0a030)" }}>
                [ {rebootingBackup ? "..." : (lang === "ru" ? "ПЕРЕСОЗДАТЬ КЛЮЧИ" : "RE-BOOTSTRAP KEYS")} ]
              </button>
            </div>
          </div>
        )}

        {/* SESSION */}
        {tab === "session" && (
          <div>
            <div style={{ marginBottom: 12, padding: 12, border: "1px solid var(--bor)", background: "var(--glow)" }}>
              <div style={{ fontSize: 10, color: "var(--gd)", marginBottom: 6, letterSpacing: "0.1em" }}>
                {lang === "ru" ? "// ТЕКУЩАЯ СЕССИЯ" : "// CURRENT SESSION"}
              </div>
              <div style={{ fontSize: 11, color: "var(--g)", marginBottom: 2 }}>{myUserId}</div>
              <div style={{ fontSize: 10, color: "var(--gd)" }}>{client?.getDeviceId?.()}</div>
            </div>
            <div style={{ marginBottom: 12, padding: 12, border: "1px solid rgba(255,49,49,0.2)", background: "rgba(255,49,49,0.03)" }}>
              <div style={{ fontSize: 11, color: "var(--rd)", marginBottom: 8 }}>⏻ {tl.disconnect}</div>
              <div style={{ fontSize: 10, color: "var(--gd)", marginBottom: 10 }}>
                {lang === "ru" ? "Выйти только на этом устройстве" : "Logout on this device only"}
              </div>
              <button onClick={() => onLogout(true)} style={{ ...btnStyle(false), borderColor: "rgba(255,49,49,0.4)", color: "var(--rd)" }}>
                [ {tl.disconnect} ]
              </button>
            </div>
            <div style={{ padding: 12, border: "1px solid rgba(255,49,49,0.4)", background: "rgba(255,49,49,0.05)" }}>
              <div style={{ fontSize: 11, color: "var(--rd)", marginBottom: 8 }}>⏻⏻ {lang === "ru" ? "ВЫЙТИ ВЕЗДЕ" : "LOGOUT ALL DEVICES"}</div>
              <div style={{ fontSize: 10, color: "var(--gd)", marginBottom: 10 }}>
                {lang === "ru" ? "Завершить все активные сессии" : "Terminate all active sessions"}
              </div>
              <button onClick={async () => {
                try {
                  const tok = client?.getAccessToken();
                  const base = client?.getHomeserverUrl();
                  await fetch(`${base}/_matrix/client/v3/logout/all`, {
                    method: "POST",
                    headers: { "Authorization": `Bearer ${tok}`, "Content-Type": "application/json" },
                    body: "{}"
                  });
                } catch(e) { console.warn("logout/all error", e); }
                onLogout(true);
              }} style={{ ...btnStyle(false), borderColor: "rgba(255,49,49,0.6)", color: "var(--rd)", fontWeight: 700 }}>
                [ {lang === "ru" ? "ВЫЙТИ ВЕЗДЕ" : "LOGOUT ALL"} ]
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


// ── Room Settings Modal ───────────────────────────────────────
function RoomSettingsModal({ room, client, myUserId, lang, onClose, onLeave, isServerAdmin, homeserver, onDeleteRoom, onTopicChange }) {
  const [tab, setTab] = useState("general");
  const [name, setName] = useState(room.name || "");
  const [topic, setTopic] = useState(room.currentState?.getStateEvents?.("m.room.topic","")?.getContent?.()?.topic || "");
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [members, setMembers] = useState(room.getJoinedMembers() || []);
  const [inviteId, setInviteId] = useState("");
  const [inviting, setInviting] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [inviteLink, setInviteLink] = useState("");

  const canEdit = () => { const me = room.getMember(myUserId); return me && me.powerLevel >= 50; };

  const tl = {
    general: lang==="ru"?"Общие":"General", members: lang==="ru"?"Участники":"Members",
    invite: lang==="ru"?"Приглашения":"Invite", danger: lang==="ru"?"Опасная зона":"Danger",
    roomName: lang==="ru"?"НАЗВАНИЕ":"ROOM NAME", roomTopic: lang==="ru"?"ТЕМА":"TOPIC",
    save: lang==="ru"?"СОХРАНИТЬ":"SAVE", saving: lang==="ru"?"СОХРАНЯЕМ...":"SAVING...",
    cancel: lang==="ru"?"ОТМЕНА":"CANCEL", inviteUser: lang==="ru"?"ПРИГЛАСИТЬ":"INVITE USER",
    inviteBtn: lang==="ru"?"ПРИГЛАСИТЬ":"INVITE", inviteLink: lang==="ru"?"ССЫЛКА":"LINK",
    copyLink: lang==="ru"?"КОПИРОВАТЬ":"COPY", leaveRoom: lang==="ru"?"ПОКИНУТЬ":"LEAVE ROOM",
    leaveWarn: lang==="ru"?"Вы потеряете доступ к истории.":"You will lose access to history.",
    kick: lang==="ru"?"КИК":"KICK", roomId: "ROOM ID",
    encryption: lang==="ru"?"ШИФРОВАНИЕ":"ENCRYPTION", yes: lang==="ru"?"Да":"Yes", no: lang==="ru"?"Нет":"No",
    membersCount: lang==="ru"?"УЧАСТНИКОВ":"MEMBERS", settings: lang==="ru"?"НАСТРОЙКИ КОМНАТЫ":"ROOM SETTINGS",
    noPerms: lang==="ru"?"Нет прав для изменения":"No permission",
    generate: "GENERATE",
  };

  const saveGeneral = async () => {
    setSaving(true); setError(""); setSuccess("");
    try {
      if (name !== room.name) await client.setRoomName(room.roomId, name);
      const curTopic = room.currentState?.getStateEvents?.("m.room.topic","")?.getContent?.()?.topic || "";
      if (topic !== curTopic) { await client.setRoomTopic(room.roomId, topic); if(onTopicChange) onTopicChange(topic); }
      setSuccess("✓ " + (lang==="ru"?"Сохранено":"Saved"));
    } catch(e) { setError(e.message); }
    finally { setSaving(false); }
  };

  const doInvite = async () => {
    if (!inviteId.trim()) return;
    setInviting(true); setError(""); setSuccess("");
    try {
      let uid = inviteId.trim();
      if (!uid.startsWith("@")) uid = "@" + uid;
      if (!uid.includes(":")) uid += ":" + client.getHomeserverUrl().replace(/^https?:\/\//, "");
      await client.invite(room.roomId, uid);
      setSuccess("✓ " + (lang==="ru"?"Приглашение отправлено":"Invited") + ": " + uid);
      setInviteId("");
    } catch(e) { setError(e.message); }
    finally { setInviting(false); }
  };

  const doKick = async (userId) => {
    try { await client.kick(room.roomId, userId); setMembers(room.getJoinedMembers()); setSuccess("kicked: " + userId); }
    catch(e) { setError(e.message); }
  };

  const doLeave = async () => {
    setLeaving(true);
    try { await client.leave(room.roomId); onLeave(); }
    catch(e) { setError(e.message); setLeaving(false); }
  };

  const generateLink = () => {
    const alias = room.getCanonicalAlias() || room.roomId;
    setInviteLink("https://matrix.to/#/" + encodeURIComponent(alias));
  };

  const encrypted = !!room.currentState?.getStateEvents?.("m.room.encryption", "");
  const tabs = [["general",tl.general,"⚙"],["members",tl.members,"◈"],["invite",tl.invite,"⊕"],["danger",tl.danger,"⚠"]];

  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background:"var(--pan)", border:"1px solid var(--borb)", width:540, maxHeight:"80vh", display:"flex", flexDirection:"column", clipPath:"polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%)", boxShadow:"0 0 40px var(--glow)", animation:"slideIn 0.2s" }}>
        <div style={{ padding:"14px 20px", borderBottom:"1px solid var(--bor)", display:"flex", alignItems:"center", gap:10, flexShrink:0 }}>
          <span style={{ fontFamily:"var(--disp)", fontSize:11, fontWeight:700, color:"var(--g)", letterSpacing:"0.15em", flex:1 }}>// {tl.settings}</span>
          <span style={{ fontSize:11, color:"var(--gd)" }}>#{room.name}</span>
          <button onClick={onClose} style={{ background:"none", border:"none", color:"var(--gd)", cursor:"pointer", fontSize:16 }}>✕</button>
        </div>
        <div style={{ display:"flex", flex:1, overflow:"hidden" }}>
          <div style={{ width:130, borderRight:"1px solid var(--bor)", padding:"8px 0", flexShrink:0 }}>
            {tabs.map(([id,label,icon]) => (
              <div key={id} onClick={() => { setTab(id); setError(""); setSuccess(""); }}
                style={{ padding:"10px 12px", cursor:"pointer", fontSize:11, letterSpacing:"0.06em", borderLeft:`2px solid ${tab===id?"var(--g)":"transparent"}`, background:tab===id?"var(--glow)":"none", color:tab===id?(id==="danger"?"var(--rd)":"var(--g)"):(id==="danger"?"rgba(255,49,49,0.5)":"var(--gd)"), transition:"all 0.12s" }}>
                {icon} {label}
              </div>
            ))}
          </div>
          <div style={{ flex:1, overflow:"auto", padding:"16px 18px" }}>
            {success && <div style={{ marginBottom:10, padding:"6px 10px", fontSize:11, color:"var(--g)", border:"1px solid var(--bor)", background:"var(--glow)" }}>{success}</div>}
            {error && <div style={{ marginBottom:10, padding:"6px 10px", fontSize:11, color:"var(--rd)", border:"1px solid rgba(255,49,49,0.3)", background:"rgba(255,49,49,0.05)" }}>{error}</div>}

            {tab==="general" && <div>
              <div style={{ fontSize:9, color:"#008a20", marginBottom:3, letterSpacing:"0.1em" }}>{tl.roomId}</div>
              <div style={{ fontSize:10, color:"var(--gd)", marginBottom:14, padding:"5px 8px", background:"var(--inp)", border:"1px solid var(--bor)", wordBreak:"break-all" }}>{room.roomId}</div>
              <div style={{ fontSize:9, color:"#008a20", marginBottom:3, letterSpacing:"0.1em" }}>{tl.encryption}</div>
              {encrypted
                ? <div style={{ fontSize:11, color:"var(--g)", marginBottom:14, display:"flex", alignItems:"center", gap:6 }}>🔒 {tl.yes} <span style={{fontSize:9,color:"var(--gd)",opacity:0.7}}>({lang==="ru"?"нельзя отключить":"cannot be disabled"})</span></div>
                : canEdit()
                  ? <button onClick={async () => {
                      try {
                        setSaving(true);
                        await client.sendStateEvent(room.roomId, "m.room.encryption", { algorithm: "m.megolm.v1.aes-sha2" }, "");
                        setSuccess(lang==="ru" ? "✓ E2EE включено" : "✓ E2EE enabled");
                      } catch(e) { setError(e.message); }
                      finally { setSaving(false); }
                    }} disabled={saving} style={{ marginBottom:14, padding:"7px 12px", border:"1px solid var(--g)", background:"var(--dk)", color:"var(--g)", fontFamily:"var(--mono)", fontSize:10, cursor:"pointer", clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", boxShadow:"0 0 8px var(--glow)" }}>
                      🔒 [ {saving ? "..." : (lang==="ru" ? "ВКЛЮЧИТЬ E2EE" : "ENABLE E2EE")} ]
                    </button>
                  : <div style={{ fontSize:11, color:"var(--gd)", marginBottom:14 }}>🔓 {tl.no}</div>
              }
              <div style={{ fontSize:9, color:"#008a20", marginBottom:5, letterSpacing:"0.1em" }}>{tl.roomName}</div>
              <input value={name} onChange={e=>setName(e.target.value)} disabled={!canEdit()} style={{ width:"100%", background:"var(--inp)", border:"1px solid var(--bor)", padding:"7px 9px", color:"var(--g)", fontFamily:"var(--mono)", fontSize:12, outline:"none", marginBottom:12, opacity:canEdit()?1:0.5 }} />
              <div style={{ fontSize:9, color:"#008a20", marginBottom:5, letterSpacing:"0.1em" }}>{tl.roomTopic}</div>
              <textarea value={topic} onChange={e=>setTopic(e.target.value)} disabled={!canEdit()} rows={3} style={{ width:"100%", background:"var(--inp)", border:"1px solid var(--bor)", padding:"7px 9px", color:"var(--g)", fontFamily:"var(--mono)", fontSize:12, outline:"none", resize:"vertical", marginBottom:12, opacity:canEdit()?1:0.5 }} />
              {!canEdit() && <div style={{ fontSize:10, color:"var(--am)", marginBottom:10 }}>⚠ {tl.noPerms}</div>}
              {canEdit() && <div style={{ display:"flex", gap:8 }}>
                <button onClick={onClose} style={{ flex:1, padding:"7px", border:"1px solid var(--bor)", background:"none", color:"var(--gd)", fontFamily:"var(--mono)", fontSize:11, cursor:"pointer", clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)" }}>[ {tl.cancel} ]</button>
                <button onClick={saveGeneral} disabled={saving} style={{ flex:1, padding:"7px", border:"1px solid var(--g)", background:"var(--dk)", color:"var(--g)", fontFamily:"var(--mono)", fontSize:11, cursor:"pointer", clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", boxShadow:"0 0 8px var(--glow)" }}>[ {saving?tl.saving:tl.save} ]</button>
              </div>}
            </div>}

            {tab==="members" && <div>
              <div style={{ fontSize:9, color:"#008a20", marginBottom:12, letterSpacing:"0.1em" }}>{tl.membersCount}: <span style={{ color:"var(--g)" }}>{members.length}</span></div>
              {members.map(m => (
                <div key={m.userId} style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 0", borderBottom:"1px solid var(--bor)" }}>
                  <div style={{ width:28, height:28, background:"var(--dk)", border:"1px solid var(--bor)", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"var(--disp)", fontSize:10, color:"var(--gd)", clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", flexShrink:0 }}>
                    {(m.name||m.userId).replace(/^@/,"").slice(0,2).toUpperCase()}
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:12, color:"var(--g)" }}>{(m.name||m.userId).replace(/^@/,"").split(":")[0]}</div>
                    <div style={{ fontSize:9, color:"#008a20" }}>{m.userId}</div>
                  </div>
                  {m.powerLevel>=100 && <span style={{ fontSize:9, color:"var(--am)", border:"1px solid var(--am)", padding:"1px 4px" }}>ADMIN</span>}
                  {canEdit() && m.userId!==myUserId && (
                    <div style={{display:"flex",gap:4}}>
                      <button onClick={async ()=>{
                        try {
                          const newLevel = m.powerLevel >= 50 ? 0 : 50;
                          await client.setPowerLevel(room.roomId, m.userId, newLevel);
                          setMembers(room.getJoinedMembers());
                          setSuccess(`✓ ${m.userId} → ${newLevel>=50?"mod":"user"}`);
                        } catch(e){setError(e.message);}
                      }} title={m.powerLevel>=50?"Demote":"Promote to mod"}
                        style={{background:"none",border:`1px solid ${m.powerLevel>=50?"var(--am)":"rgba(255,176,0,0.3)"}`,color:m.powerLevel>=50?"var(--am)":"rgba(255,176,0,0.5)",cursor:"pointer",fontSize:10,padding:"3px 7px",fontFamily:"var(--mono)"}}>
                        {m.powerLevel>=50?"↓":"★"}
                      </button>
                      <button onClick={()=>doKick(m.userId)} style={{background:"none",border:"1px solid rgba(255,49,49,0.3)",color:"var(--rd)",cursor:"pointer",fontSize:10,padding:"3px 7px",fontFamily:"var(--mono)"}}>✕</button>
                    </div>
                  )}
                </div>
              ))}
            </div>}

            {tab==="invite" && <div>
              <div style={{ fontSize:9, color:"#008a20", marginBottom:6, letterSpacing:"0.1em" }}>{tl.inviteUser}</div>
              <div style={{ display:"flex", gap:8, marginBottom:18 }}>
                <input value={inviteId} onChange={e=>setInviteId(e.target.value)} placeholder="@username" onKeyDown={e=>e.key==="Enter"&&doInvite()}
                  style={{ flex:1, background:"var(--inp)", border:"1px solid var(--bor)", padding:"7px 9px", color:"var(--g)", fontFamily:"var(--mono)", fontSize:12, outline:"none" }} />
                <button onClick={doInvite} disabled={inviting||!inviteId.trim()} style={{ padding:"7px 12px", border:"1px solid var(--g)", background:"var(--dk)", color:"var(--g)", fontFamily:"var(--mono)", fontSize:11, cursor:"pointer", clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)" }}>
                  {inviting?"...":tl.inviteBtn}
                </button>
              </div>
              <div style={{ fontSize:9, color:"#008a20", marginBottom:8, letterSpacing:"0.1em" }}>{tl.inviteLink}</div>
              {!inviteLink
                ? <button onClick={generateLink} style={{ padding:"7px 12px", border:"1px solid var(--bor)", background:"none", color:"var(--gd)", fontFamily:"var(--mono)", fontSize:11, cursor:"pointer" }}>{tl.generate}</button>
                : <div style={{ display:"flex", gap:6 }}>
                    <div style={{ flex:1, padding:"6px 8px", background:"var(--inp)", border:"1px solid var(--bor)", fontSize:10, color:"var(--gd)", wordBreak:"break-all" }}>{inviteLink}</div>
                    <button onClick={()=>{ navigator.clipboard.writeText(inviteLink); setSuccess("✓ Copied"); }} style={{ padding:"6px 10px", border:"1px solid var(--g)", background:"var(--dk)", color:"var(--g)", fontFamily:"var(--mono)", fontSize:10, cursor:"pointer", flexShrink:0 }}>{tl.copyLink}</button>
                  </div>
              }
            </div>}

            {tab==="danger" && <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <div style={{ padding:14, border:"1px solid rgba(255,49,49,0.3)", background:"rgba(255,49,49,0.05)" }}>
                <div style={{ fontSize:12, color:"var(--rd)", marginBottom:8 }}>⚠ {tl.leaveRoom}</div>
                <div style={{ fontSize:11, color:"rgba(255,49,49,0.7)", marginBottom:14 }}>{tl.leaveWarn}</div>
                <button onClick={doLeave} disabled={leaving} style={{ padding:"7px 14px", border:"1px solid var(--rd)", background:"rgba(255,49,49,0.1)", color:"var(--rd)", fontFamily:"var(--mono)", fontSize:11, cursor:"pointer", clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)" }}>
                  {leaving?"...":`[ ${tl.leaveRoom} ]`}
                </button>
              </div>
              {(() => {
                const myPower = room.getMember?.(myUserId)?.powerLevel || 0;
                const canClear = isServerAdmin || myPower >= 100;
                const canDelete = isServerAdmin;
                return (<>
                  {isServerAdmin && (
                    <div style={{ padding:14, border:"1px solid rgba(255,176,0,0.4)", background:"rgba(255,176,0,0.05)", marginBottom:10 }}>
                      <div style={{ fontSize:11, color:"var(--am)", marginBottom:6, letterSpacing:"0.08em" }}>★ {lang==="ru"?"НАЗНАЧИТЬ ВЛАДЕЛЬЦА":"SET ROOM OWNER"}</div>
                      <div style={{ fontSize:10, color:"rgba(255,176,0,0.5)", marginBottom:8 }}>{lang==="ru"?"Обходит ограничения прав через Admin API":"Bypasses power level restrictions via Admin API"}</div>
                      <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                        {room.getJoinedMembers().map(m => (
                          <button key={m.userId} onClick={async () => {
                            const uname = (m.name||m.userId).replace(/^@/,"").split(":")[0];
                            if (!window.confirm(lang==="ru"?`Назначить ${uname} владельцем (уровень 100)?`:`Make ${uname} owner (level 100)?`)) return;
                            try {
                              const tok = client.getAccessToken();
                              // Step 1: force-join @admin into the room so Synapse has a local admin
                              const joinRes = await fetch(`${homeserver}/_synapse/admin/v1/join/${encodeURIComponent(room.roomId)}`, {
                                method:"POST", headers:{"Authorization":`Bearer ${tok}`,"Content-Type":"application/json"},
                                body: JSON.stringify({ user_id: myUserId })
                              });
                              // Step 2: now make_room_admin should work
                              const res = await fetch(`${homeserver}/_synapse/admin/v1/rooms/${encodeURIComponent(room.roomId)}/make_room_admin`, {
                                method:"POST", headers:{"Authorization":`Bearer ${tok}`,"Content-Type":"application/json"},
                                body: JSON.stringify({ user_id: m.userId })
                              });
                              const d = await res.json();
                              if (res.ok) { alert("✓ " + uname + (lang==="ru"?" — теперь владелец":" is now owner")); }
                              else { alert("Error: " + (d.error || res.status)); }
                            } catch(e) { alert(e.message); }
                          }} style={{ padding:"4px 10px", border:"1px solid rgba(255,176,0,0.4)", background:"rgba(255,176,0,0.08)",
                            color:"var(--am)", fontFamily:"var(--mono)", fontSize:10, cursor:"pointer",
                            clipPath:"polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%)" }}>
                            ★ {(m.name||m.userId).replace(/^@/,"").split(":")[0]}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                  {canClear && (
                    <div style={{ padding:14, border:"1px solid rgba(255,49,49,0.4)", background:"rgba(255,49,49,0.05)", marginBottom:10 }}>
                      <div style={{ fontSize:11, color:"var(--rd)", marginBottom:6, letterSpacing:"0.08em" }}>🗑 {lang==="ru"?"ОЧИСТИТЬ ИСТОРИЮ ЧАТА":"CLEAR CHAT HISTORY"}</div>
                      <div style={{ fontSize:10, color:"rgba(255,49,49,0.6)", marginBottom:10 }}>{lang==="ru"?"Все сообщения будут удалены безвозвратно. Доступно только создателю комнаты или администратору.":"All messages will be permanently deleted. Only for room creator or server admin."}</div>
                      <button onClick={async () => {
                        if (!window.confirm(lang==="ru"?"Удалить ВСЮ историю чата? Это необратимо!":"Delete ALL chat history? This cannot be undone!")) return;
                        try {
                          const tok = client.getAccessToken();
                          // Use Synapse admin API to purge history up to now
                          const purgeTs = Date.now();
                          const res = await fetch(`${homeserver}/_synapse/admin/v1/purge_history/${encodeURIComponent(room.roomId)}`, {
                            method:"POST",
                            headers:{"Authorization":`Bearer ${tok}`,"Content-Type":"application/json"},
                            body: JSON.stringify({ purge_up_to_ts: purgeTs, delete_local_events: true })
                          });
                          if (res.ok) {
                            alert(lang==="ru"?"История очищена! Обновите страницу.":"History cleared! Please refresh.");
                          } else { const d = await res.json(); alert(d.error || "Error"); }
                        } catch(e) { alert(e.message); }
                      }} style={{ padding:"7px 14px", border:"1px solid var(--rd)", background:"rgba(255,49,49,0.1)", color:"var(--rd)", fontFamily:"var(--mono)", fontSize:10, cursor:"pointer", clipPath:"polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", letterSpacing:"0.08em" }}>
                        🗑 {lang==="ru"?"ОЧИСТИТЬ ВСЮ ИСТОРИЮ":"CLEAR ALL HISTORY"}
                      </button>
                    </div>
                  )}
                  {canDelete && (
                    <div style={{ padding:14, border:"2px solid rgba(255,49,49,0.5)", background:"rgba(255,49,49,0.07)" }}>
                      <div style={{ fontSize:12, color:"var(--rd)", marginBottom:6 }}>☠ {lang==="ru"?"УДАЛИТЬ КОМНАТУ":"DELETE ROOM"}</div>
                      <div style={{ fontSize:11, color:"rgba(255,49,49,0.6)", marginBottom:12 }}>{lang==="ru"?"Комната будет удалена безвозвратно для всех участников.":"Room will be permanently deleted for all members."}</div>
                      <button onClick={async () => {
                        const name = room.name || room.roomId;
                        if (!window.confirm(lang==="ru"?`Удалить комнату "${name}"? Это необратимо!`:`Delete room "${name}"? This cannot be undone!`)) return;
                        try {
                          const tok = client.getAccessToken();
                          const res = await fetch(`${homeserver}/_synapse/admin/v1/rooms/${encodeURIComponent(room.roomId)}`, {
                            method:"DELETE", headers:{"Authorization":`Bearer ${tok}`,"Content-Type":"application/json"},
                            body: JSON.stringify({message:"Deleted by admin",purge:true})
                          });
                          if (res.ok) onDeleteRoom(room.roomId);
                          else { const d = await res.json(); alert(d.error || "Error"); }
                        } catch(e) { alert(e.message); }
                      }} style={{ padding:"8px 14px", border:"2px solid var(--rd)", background:"rgba(255,49,49,0.15)", color:"var(--rd)", fontFamily:"var(--disp)", fontSize:10, cursor:"pointer", letterSpacing:"0.1em", fontWeight:"bold" }}>
                        ✕ {lang==="ru"?"УДАЛИТЬ КОМНАТУ":"DELETE ROOM"}
                      </button>
                    </div>
                  )}
                </>);
              })()}
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Admin Panel ───────────────────────────────────────────────
function AdminPanel({ client, myUserId, lang }) {
  const t = T[lang] || T.ru;
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [adminTab, setAdminTab] = useState("users");
  const [modal, setModal] = useState(null);
  const [invites, setInvites] = useState([]);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newUser, setNewUser] = useState({ username: "", password: "", admin: false, rooms: [] });
  const [allRooms, setAllRooms] = useState([]);
  const [newPassword, setNewPassword] = useState("");
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const baseUrl = client?.getHomeserverUrl?.() || HOMESERVER;
  const token = client?.getAccessToken?.();

  const adminFetch = async (path, method = "GET", body = null) => {
    const opts = { method, headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" } };
    if (body) opts.body = JSON.stringify(body);
    const res = await fetch(`${baseUrl}${path}`, opts);
    return res.json();
  };

  const loadUsers = async () => {
    setLoading(true); setError("");
    try {
      const data = await adminFetch("/_synapse/admin/v2/users?limit=100&guests=false");
      if (data.users) setUsers(data.users);
      else setError(data.error || "Failed to load users");
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const loadRooms = async () => {
    try {
      const data = await adminFetch("/_synapse/admin/v1/rooms?limit=100");
      if (data.rooms) setAllRooms(data.rooms);
    } catch(e) { console.error(e); }
  };

  useEffect(() => { loadUsers(); loadRooms(); }, []);

  const loadInvites = async () => {
    setInviteLoading(true);
    try {
      const data = await adminFetch("/_synapse/admin/v1/registration_tokens?valid=true");
      if (data.registration_tokens) setInvites(data.registration_tokens);
    } catch(e) { console.error(e); }
    finally { setInviteLoading(false); }
  };

  const [newInvite, setNewInvite] = useState({ uses: "1", rooms: [] });
  const [showInviteModal, setShowInviteModal] = useState(false);

  const createInvite = async () => {
    try {
      const uses = parseInt(newInvite.uses) || 0;
      const data = await adminFetch("/_synapse/admin/v1/registration_tokens/new", "POST", {
        uses_allowed: uses > 0 ? uses : null,
      });
      if (data.token) {
        // Store room list in localStorage keyed by token for post-register invite
        if (newInvite.rooms.length > 0) {
          const stored = JSON.parse(localStorage.getItem("nexus_token_rooms") || "{}");
          stored[data.token] = newInvite.rooms;
          localStorage.setItem("nexus_token_rooms", JSON.stringify(stored));
        }
        loadInvites();
        const link = `${window.location.origin}/register?token=${data.token}`;
        setSuccess(`✓ ${link}`);
        setShowInviteModal(false);
        setNewInvite({ uses: "1", rooms: [] });
      }
    } catch(e) { setError(e.message); }
  };

  const deleteInvite = async (token) => {
    try {
      await adminFetch(`/_synapse/admin/v1/registration_tokens/${token}`, "DELETE");
      loadInvites();
    } catch(e) { setError(e.message); }
  };

  const createUser = async () => {
    if (!newUser.username || !newUser.password) return;
    setActionLoading(true); setError(""); setSuccess("");
    try {
      const userId = `@${newUser.username}:${baseUrl.replace(/^https?:\/\//, "")}`;
      const data = await adminFetch(`/_synapse/admin/v2/users/${encodeURIComponent(userId)}`, "PUT", {
        password: newUser.password, admin: newUser.admin, deactivated: false,
      });
      if (data.name) {
        // Invite to selected rooms
        for (const roomId of (newUser.rooms || [])) {
          try { await adminFetch(`/_synapse/admin/v1/join/${encodeURIComponent(roomId)}`, "POST", { user_id: data.name }); }
          catch(e) { console.warn("Room invite failed:", e); }
        }
        setSuccess(`✓ ${lang === "ru" ? "Пользователь создан" : "User created"}: ${data.name}`);
        setModal(null); setNewUser({ username: "", password: "", admin: false, rooms: [] });
        loadUsers();
      } else setError(data.error || "Error");
    } catch (e) { setError(e.message); }
    finally { setActionLoading(false); }
  };

  const resetPassword = async () => {
    if (!newPassword || !selectedUser) return;
    setActionLoading(true); setError(""); setSuccess("");
    try {
      const data = await adminFetch(`/_synapse/admin/v1/reset_password/${encodeURIComponent(selectedUser.name)}`, "POST", {
        new_password: newPassword, logout_devices: true,
      });
      if (data.error) setError(data.error);
      else { setSuccess(`✓ ${lang === "ru" ? "Пароль изменён" : "Password changed"}`); setModal(null); setNewPassword(""); }
    } catch (e) { setError(e.message); }
    finally { setActionLoading(false); }
  };

  const deleteUser = async (user) => {
    if (!window.confirm(lang==="ru" ? `Удалить аккаунт ${user.name}? Это необратимо!` : `Delete account ${user.name}? This cannot be undone!`)) return;
    setActionLoading(true); setError(""); setSuccess("");
    try {
      const data = await adminFetch(`/_synapse/admin/v1/deactivate/${encodeURIComponent(user.name)}`, "POST", {
        erase: true,
      });
      if (data.error) setError(data.error);
      else {
        setSuccess(`✓ ${lang==="ru"?"Аккаунт удалён":"Account deleted"}: ${user.name}`);
        setModal(null); setSelectedUser(null); loadUsers();
      }
    } catch(e) { setError(e.message); }
    finally { setActionLoading(false); }
  };

  const toggleDeactivate = async (user) => {
    setActionLoading(true); setError(""); setSuccess("");
    try {
      const deactivate = !user.deactivated;
      const data = await adminFetch(`/_synapse/admin/v2/users/${encodeURIComponent(user.name)}`, "PUT", {
        deactivated: deactivate,
      });
      if (data.error) setError(data.error);
      else {
        setSuccess(`✓ ${user.name} ${deactivate ? (lang === "ru" ? "заблокирован" : "deactivated") : (lang === "ru" ? "разблокирован" : "activated")}`);
        loadUsers();
      }
    } catch (e) { setError(e.message); }
    finally { setActionLoading(false); setModal(null); }
  };

  const filtered = users.filter(u => u.name.toLowerCase().includes(search.toLowerCase()));
  const isAdmin = (u) => u.admin;

  const tl = {
    title: lang === "ru" ? "АДМИН-ПАНЕЛЬ" : "ADMIN PANEL",
    users: lang === "ru" ? "ПОЛЬЗОВАТЕЛИ" : "USERS",
    createUser: lang === "ru" ? "СОЗДАТЬ ПОЛЬЗОВАТЕЛЯ" : "CREATE USER",
    username: lang === "ru" ? "ИМЯ ПОЛЬЗОВАТЕЛЯ" : "USERNAME",
    password: lang === "ru" ? "ПАРОЛЬ" : "PASSWORD",
    makeAdmin: lang === "ru" ? "АДМИНИСТРАТОР" : "MAKE ADMIN",
    create: lang === "ru" ? "СОЗДАТЬ" : "CREATE",
    cancel: lang === "ru" ? "ОТМЕНА" : "CANCEL",
    resetPass: lang === "ru" ? "СМЕНИТЬ ПАРОЛЬ" : "RESET PASSWORD",
    newPass: lang === "ru" ? "НОВЫЙ ПАРОЛЬ" : "NEW PASSWORD",
    save: lang === "ru" ? "СОХРАНИТЬ" : "SAVE",
    deactivate: lang === "ru" ? "ЗАБЛОКИРОВАТЬ" : "DEACTIVATE",
    activate: lang === "ru" ? "РАЗБЛОКИРОВАТЬ" : "ACTIVATE",
    search: lang === "ru" ? "поиск..." : "search...",
    total: lang === "ru" ? "ВСЕГО" : "TOTAL",
    online: lang === "ru" ? "онлайн" : "online",
    refresh: lang === "ru" ? "ОБНОВИТЬ" : "REFRESH",
    admin: lang === "ru" ? "АДМИН" : "ADMIN",
    blocked: lang === "ru" ? "ЗАБЛОК." : "BLOCKED",
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: "var(--bg)", overflow: "hidden" }}>
      {/* Invite Modal */}
      {showInviteModal && (
        <div className="modal-bg" onClick={e => e.target===e.currentTarget && setShowInviteModal(false)}>
          <div className="modal" style={{width:400}}>
            <div className="modal-title">// {lang==="ru"?"СОЗДАТЬ ИНВАЙТ":"CREATE INVITE"}</div>
            <div className="modal-field">
              <div className="modal-label">{lang==="ru"?"КОЛ-ВО ИСПОЛЬЗОВАНИЙ (0 = без ограничений)":"MAX USES (0 = unlimited)"}</div>
              <input className="modal-input" type="number" min="0" value={newInvite.uses} autoFocus
                onChange={e => setNewInvite(p => ({...p, uses: e.target.value}))} />
            </div>
            {allRooms.length > 0 && (
              <div className="modal-field">
                <div className="modal-label">{lang==="ru"?"ДОБАВИТЬ В КОМНАТЫ ПОСЛЕ РЕГИСТРАЦИИ":"AUTO-JOIN ROOMS AFTER REGISTER"}</div>
                <div style={{maxHeight:160,overflowY:"auto",border:"1px solid var(--bor)",background:"var(--inp)",padding:"4px 0"}}>
                  {allRooms.filter(r=>r.name).map(r => (
                    <label key={r.room_id} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 10px",cursor:"pointer",fontSize:11,transition:"background 0.1s"}}
                      onMouseOver={e=>e.currentTarget.style.background="var(--glow)"} onMouseOut={e=>e.currentTarget.style.background=""}>
                      <input type="checkbox" style={{accentColor:"var(--g)",flexShrink:0}}
                        checked={newInvite.rooms.includes(r.room_id)}
                        onChange={e => setNewInvite(p => ({
                          ...p, rooms: e.target.checked ? [...p.rooms, r.room_id] : p.rooms.filter(id => id !== r.room_id)
                        }))} />
                      <span style={{color:"var(--g)",flex:1}}>{r.name}</span>
                      <span style={{fontSize:9,color:"var(--gd)"}}>{r.joined_members}👥</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            <div className="modal-btns">
              <button className="modal-btn" onClick={() => { setShowInviteModal(false); setNewInvite({uses:"1",rooms:[]}); }}>[ {lang==="ru"?"ОТМЕНА":"CANCEL"} ]</button>
              <button className="modal-btn primary" onClick={createInvite}>[ {lang==="ru"?"СОЗДАТЬ":"CREATE"} ]</button>
            </div>
          </div>
        </div>
      )}
      {/* Header */}
      <div style={{ padding: "0 16px", height: 48, borderBottom: "1px solid var(--bor)", background: "var(--pan)", display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
        <span style={{ color: "var(--am)", fontSize: 13 }}>⚡</span>
        <span style={{ fontFamily: "var(--disp)", fontSize: 12, fontWeight: 700, color: "var(--am)", textShadow: "0 0 10px var(--am)", letterSpacing: "0.1em" }}>{tl.title}</span>
        <span style={{ color: "var(--bor)" }}> // </span>
        <span style={{ fontSize: 10, color: "#008a20", flex: 1 }}>{tl.total}: <span style={{ color: "var(--g)" }}>{users.length}</span></span>
        <button onClick={loadUsers} style={{ background: "none", border: "1px solid var(--bor)", color: "var(--gd)", cursor: "pointer", fontSize: 10, padding: "4px 10px", fontFamily: "var(--mono)", letterSpacing: "0.1em", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", transition: "all 0.12s" }}
          onMouseOver={e => { e.target.style.borderColor = "var(--g)"; e.target.style.color = "var(--g)"; }}
          onMouseOut={e => { e.target.style.borderColor = "var(--bor)"; e.target.style.color = "var(--gd)"; }}>
          {tl.refresh}
        </button>
        <button onClick={() => { setModal("create"); setError(""); setSuccess(""); }}
          style={{ background: "var(--dk)", border: "1px solid var(--am)", color: "var(--am)", cursor: "pointer", fontSize: 10, padding: "4px 12px", fontFamily: "var(--mono)", letterSpacing: "0.1em", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", boxShadow: "0 0 8px rgba(255,176,0,0.2)" }}>
          ⊕ {tl.createUser}
        </button>
      </div>

      {/* Success / Error */}
      {success && <div style={{ padding: "8px 16px", background: "rgba(0,255,65,0.05)", borderBottom: "1px solid var(--bor)", fontSize: 11, color: "var(--g)" }}>{success}</div>}
      {error && <div style={{ padding: "8px 16px", background: "rgba(255,49,49,0.05)", borderBottom: "1px solid rgba(255,49,49,0.3)", fontSize: 11, color: "var(--rd)" }}>{error}</div>}

      {/* Tabs */}
      <div style={{ display: "flex", borderBottom: "1px solid var(--bor)", background: "var(--pan)", flexShrink: 0 }}>
        {[["users", lang === "ru" ? "◈ ПОЛЬЗОВАТЕЛИ" : "◈ USERS"], ["invites", lang === "ru" ? "⊕ ИНВАЙТЫ" : "⊕ INVITES"]].map(([id, label]) => (
          <div key={id} onClick={() => { setAdminTab(id); if (id === "invites") loadInvites(); }}
            style={{ flex: 1, padding: "10px", textAlign: "center", cursor: "pointer", fontSize: 10, letterSpacing: "0.1em", borderBottom: `2px solid ${adminTab === id ? "var(--g)" : "transparent"}`, color: adminTab === id ? "var(--g)" : "var(--gd)", background: adminTab === id ? "var(--glow)" : "none", transition: "all 0.12s" }}>
            {label}
          </div>
        ))}
      </div>

      {/* Search (users only) */}
      {adminTab === "users" && <div style={{ padding: "10px 16px", borderBottom: "1px solid var(--bor)", background: "var(--pan)", flexShrink: 0 }}>
        <div style={{ background: "var(--inp)", border: "1px solid var(--bor)", padding: "6px 10px", display: "flex", gap: 6, clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)" }}>
          <span style={{ color: "var(--gd)", fontSize: 12 }}>/&gt;</span>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder={tl.search}
            style={{ background: "none", border: "none", outline: "none", color: "var(--g)", fontFamily: "var(--mono)", fontSize: 12, width: "100%" }} />
        </div>
      </div>}

      {/* Users list */}
      <>{adminTab === "users" && <div style={{ flex: 1, overflowY: "auto", padding: "8px 16px" }}>
        {loading && <div style={{ padding: 20, textAlign: "center", color: "var(--gd)", fontSize: 11, letterSpacing: "0.1em" }}>LOADING<span className="blink">_</span></div>}
        {filtered.map(u => {
          const shortId = u.name.replace(/^@/, "").split(":")[0];
          const isMe = u.name === myUserId;
          return (
            <div key={u.name} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", borderBottom: "1px solid var(--bor)", transition: "background 0.1s" }}
              onMouseOver={e => e.currentTarget.style.background = "var(--glow)"}
              onMouseOut={e => e.currentTarget.style.background = "none"}>
              {/* Avatar */}
              <div style={{ width: 32, height: 32, background: u.deactivated ? "rgba(255,49,49,0.1)" : "var(--dk)", border: `1px solid ${u.deactivated ? "var(--rd)" : isAdmin(u) ? "var(--am)" : "var(--bor)"}`, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "var(--disp)", fontSize: 11, fontWeight: 700, color: u.deactivated ? "var(--rd)" : isAdmin(u) ? "var(--am)" : "var(--gd)", clipPath: "polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%)", flexShrink: 0 }}>
                {shortId.slice(0, 2).toUpperCase()}
              </div>
              {/* Info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span style={{ fontSize: 13, color: u.deactivated ? "var(--rd)" : "var(--g)", fontFamily: "var(--mono)" }}>{shortId}</span>
                  {isAdmin(u) && <span style={{ fontSize: 9, color: "var(--am)", border: "1px solid var(--am)", padding: "1px 4px", clipPath: "polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%)", letterSpacing: "0.1em" }}>{tl.admin}</span>}
                  {u.deactivated && <span style={{ fontSize: 9, color: "var(--rd)", border: "1px solid var(--rd)", padding: "1px 4px", clipPath: "polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%)", letterSpacing: "0.1em" }}>{tl.blocked}</span>}
                  {isMe && <span style={{ fontSize: 9, color: "var(--cy)", border: "1px solid var(--cy)", padding: "1px 4px", clipPath: "polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%)", letterSpacing: "0.1em" }}>YOU</span>}
                </div>
                <div style={{ fontSize: 10, color: "#008a20", marginTop: 2 }}>{u.name}</div>
              </div>
              {/* Actions */}
              {!isMe && (
                <div style={{ display: "flex", gap: 5 }}>
                  <button onClick={() => { setSelectedUser(u); setModal("manage"); setError(""); setSuccess(""); }}
                    title={lang === "ru" ? "Управление" : "Manage"}
                    style={{ background: "none", border: "1px solid var(--bor)", color: "var(--gd)", cursor: "pointer", fontSize: 11, padding: "4px 9px", fontFamily: "var(--mono)", clipPath: "polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%)", transition: "all 0.12s" }}
                    onMouseOver={e => { e.currentTarget.style.borderColor = "var(--g)"; e.currentTarget.style.color = "var(--g)"; }}
                    onMouseOut={e => { e.currentTarget.style.borderColor = "var(--bor)"; e.currentTarget.style.color = "var(--gd)"; }}>
                    ⚙
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>}

      {/* Invites panel */}
      {adminTab === "invites" && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <div style={{ padding: "12px 16px", borderBottom: "1px solid var(--bor)", background: "var(--pan)", display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
            <span style={{ fontSize: 10, color: "#008a20", flex: 1, letterSpacing: "0.1em" }}>
              {lang === "ru" ? "Генерируйте токены для регистрации новых пользователей" : "Generate tokens to register new users"}
            </span>
            <button onClick={() => { loadRooms(); setShowInviteModal(true); setError(""); }}
              style={{ background: "var(--dk)", border: "1px solid var(--am)", color: "var(--am)", cursor: "pointer", fontSize: 10, padding: "5px 12px", fontFamily: "var(--mono)", letterSpacing: "0.1em", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)" }}>
              ⊕ {lang === "ru" ? "СОЗДАТЬ ТОКЕН" : "CREATE TOKEN"}
            </button>
          </div>
          {success && <div style={{ padding: "8px 16px", background: "rgba(0,255,65,0.05)", borderBottom: "1px solid var(--bor)", fontSize: 11, color: "var(--g)" }}>{success}</div>}
          <div style={{ flex: 1, overflowY: "auto", padding: "8px 16px" }}>
            {inviteLoading && <div style={{ padding: 20, textAlign: "center", color: "var(--gd)", fontSize: 11 }}>LOADING<span className="blink">_</span></div>}
            {!inviteLoading && invites.length === 0 && (
              <div style={{ padding: 20, textAlign: "center", color: "#008a20", fontSize: 11, letterSpacing: "0.1em" }}>
                {lang === "ru" ? "Нет активных инвайтов" : "No active invite tokens"}
              </div>
            )}
            {invites.map(inv => {
              const link = `${window.location.origin}/register?token=${inv.token}`;
              return (
                <div key={inv.token} style={{ padding: "12px", marginBottom: 8, border: "1px solid var(--bor)", background: "var(--pan)" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                    <code style={{ flex: 1, fontSize: 13, color: "var(--g)", fontFamily: "var(--mono)", textShadow: "0 0 6px var(--g)", letterSpacing: "0.05em" }}>{inv.token}</code>
                    <span style={{ fontSize: 10, color: inv.uses_allowed ? "var(--am)" : "var(--gd)", border: `1px solid ${inv.uses_allowed ? "var(--am)" : "var(--bor)"}`, padding: "2px 6px" }}>
                      {inv.uses_allowed ? `${inv.pending || 0}/${inv.uses_allowed}` : "∞"}
                    </span>
                    <button onClick={() => deleteInvite(inv.token)}
                      style={{ background: "none", border: "1px solid rgba(255,49,49,0.3)", color: "var(--rd)", cursor: "pointer", fontSize: 10, padding: "3px 8px", fontFamily: "var(--mono)" }}>⊗</button>
                  </div>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    <div style={{ flex: 1, fontSize: 10, color: "#008a20", padding: "4px 6px", background: "var(--inp)", border: "1px solid var(--bor)", wordBreak: "break-all" }}>{link}</div>
                    <button onClick={() => { navigator.clipboard.writeText(link); setSuccess("✓ " + (lang === "ru" ? "Скопировано" : "Copied")); }}
                      style={{ background: "var(--dk)", border: "1px solid var(--g)", color: "var(--g)", cursor: "pointer", fontSize: 10, padding: "4px 8px", fontFamily: "var(--mono)", flexShrink: 0 }}>
                      {lang === "ru" ? "КОПИРОВАТЬ" : "COPY"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}</>

      {/* Create User Modal */}
      {modal === "create" && (
        <div className="modal-bg" onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div className="modal">
            <div className="modal-title">// {tl.createUser}</div>
            <div className="modal-field">
              <div className="modal-label">{tl.username}</div>
              <input className="modal-input" placeholder="username" value={newUser.username}
                onChange={e => setNewUser(p => ({ ...p, username: e.target.value }))} autoFocus />
            </div>
            <div className="modal-field">
              <div className="modal-label">{tl.password}</div>
              <input className="modal-input" type="password" placeholder="••••••••" value={newUser.password}
                onChange={e => setNewUser(p => ({ ...p, password: e.target.value }))}
                onKeyDown={e => e.key === "Enter" && createUser()} />
            </div>
            <label className="modal-check">
              <input type="checkbox" checked={newUser.admin} onChange={e => setNewUser(p => ({ ...p, admin: e.target.checked }))} />
              {tl.makeAdmin}
            </label>
            {allRooms.length > 0 && (
              <div className="modal-field">
                <div className="modal-label">{lang==="ru"?"ДОБАВИТЬ В КОМНАТЫ":"ADD TO ROOMS"}</div>
                <div style={{maxHeight:130,overflowY:"auto",border:"1px solid var(--bor)",background:"var(--inp)",padding:"4px 0"}}>
                  {allRooms.map(r => (
                    <label key={r.room_id} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 10px",cursor:"pointer",fontSize:11,color:"var(--gd)"}}
                      onMouseOver={e=>e.currentTarget.style.background="var(--glow)"} onMouseOut={e=>e.currentTarget.style.background=""}>
                      <input type="checkbox" style={{accentColor:"var(--g)"}}
                        checked={(newUser.rooms||[]).includes(r.room_id)}
                        onChange={e => setNewUser(p => ({
                          ...p, rooms: e.target.checked
                            ? [...(p.rooms||[]), r.room_id]
                            : (p.rooms||[]).filter(id => id !== r.room_id)
                        }))} />
                      <span style={{color:"var(--g)",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.name || r.room_id}</span>
                      <span style={{fontSize:9,color:"var(--gd)",flexShrink:0}}>{r.joined_members}👥</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            {error && <div style={{ fontSize: 11, color: "var(--rd)", margin: "8px 0" }}>{error}</div>}
            <div className="modal-btns">
              <button className="modal-btn" onClick={() => setModal(null)}>[ {tl.cancel} ]</button>
              <button className="modal-btn primary" disabled={!newUser.username || !newUser.password || actionLoading} onClick={createUser}>
                [ {actionLoading ? "..." : tl.create} ]
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Manage User Modal */}
      {modal === "manage" && selectedUser && (
        <div className="modal-bg" onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div style={{ background: "var(--pan)", border: "1px solid var(--borb)", width: 420, maxHeight: "85vh", display: "flex", flexDirection: "column", clipPath: "polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%)", boxShadow: "0 0 40px var(--glow)", animation: "slideIn 0.2s" }}>
            {/* Header */}
            <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--bor)", display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 32, height: 32, background: "var(--dk)", border: `1px solid ${selectedUser.admin ? "var(--am)" : "var(--bor)"}`, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "var(--disp)", fontSize: 11, color: selectedUser.admin ? "var(--am)" : "var(--gd)", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", flexShrink: 0 }}>
                {selectedUser.name.replace(/^@/,"").slice(0,2).toUpperCase()}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, color: "var(--g)", fontFamily: "var(--mono)" }}>{selectedUser.name.replace(/^@/,"").split(":")[0]}</div>
                <div style={{ fontSize: 10, color: "#008a20" }}>{selectedUser.name}</div>
              </div>
              <button onClick={() => setModal(null)} style={{ background: "none", border: "none", color: "var(--gd)", cursor: "pointer", fontSize: 16 }}>✕</button>
            </div>

            <div style={{ overflowY: "auto", padding: "16px 18px" }}>
              {error && <div style={{ marginBottom: 12, padding: "7px 10px", fontSize: 11, color: "var(--rd)", border: "1px solid rgba(255,49,49,0.3)", background: "rgba(255,49,49,0.05)" }}>{error}</div>}
              {success && <div style={{ marginBottom: 12, padding: "7px 10px", fontSize: 11, color: "var(--g)", border: "1px solid var(--bor)", background: "var(--glow)" }}>{success}</div>}

              {/* Status flags */}
              <div style={{ fontSize: 10, color: "#008a20", letterSpacing: "0.1em", marginBottom: 10 }}>// {lang === "ru" ? "СТАТУС И ПРАВА" : "STATUS & PERMISSIONS"}</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 20 }}>
                {[
                  { label: lang === "ru" ? "АДМИНИСТРАТОР" : "ADMIN", key: "admin", icon: "⚡", color: "var(--am)", value: selectedUser.admin },
                  { label: lang === "ru" ? "ЗАБЛОКИРОВАН" : "DEACTIVATED", key: "deactivated", icon: "⊗", color: "var(--rd)", value: selectedUser.deactivated },
                  { label: lang === "ru" ? "ТОЛЬКО ЧТЕНИЕ" : "READ-ONLY", key: "locked", icon: "🔒", color: "var(--cy)", value: selectedUser.locked },
                  { label: lang === "ru" ? "СКРЫТЬ ПРОФИЛЬ" : "SHADOW BAN", key: "shadow_banned", icon: "👻", color: "#888", value: selectedUser.shadow_banned },
                ].map(({ label, key, icon, color, value }) => (
                  <div key={key} onClick={async () => {
                    if (actionLoading) return;
                    setActionLoading(true); setError(""); setSuccess("");
                    try {
                      const body = {};
                      if (key === "admin") body.admin = !value;
                      else if (key === "deactivated") body.deactivated = !value;
                      else if (key === "locked") body.locked = !value;
                      else if (key === "shadow_banned") body.shadow_banned = !value;
                      const data = await adminFetch(`/_synapse/admin/v2/users/${encodeURIComponent(selectedUser.name)}`, "PUT", body);
                      if (data.error) { setError(data.error); }
                      else {
                        Object.assign(selectedUser, body);
                        setSuccess("✓ " + (lang === "ru" ? "Обновлено" : "Updated"));
                        loadUsers();
                      }
                    } catch(e) { setError(e.message); }
                    finally { setActionLoading(false); }
                  }}
                    style={{ padding: "10px 12px", border: `1px solid ${value ? color : "var(--bor)"}`, background: value ? `${color}11` : "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 8, transition: "all 0.15s", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)" }}>
                    <span style={{ fontSize: 14 }}>{icon}</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 9, color: value ? color : "var(--gd)", letterSpacing: "0.08em" }}>{label}</div>
                      <div style={{ fontSize: 10, color: value ? color : "#333", marginTop: 2 }}>{value ? "ON" : "OFF"}</div>
                    </div>
                    <div style={{ width: 24, height: 14, background: value ? color : "#111", border: `1px solid ${value ? color : "var(--bor)"}`, borderRadius: 7, position: "relative", transition: "all 0.2s", flexShrink: 0 }}>
                      <div style={{ position: "absolute", top: 2, left: value ? 11 : 2, width: 8, height: 8, background: value ? "#000" : "#333", borderRadius: "50%", transition: "left 0.2s" }} />
                    </div>
                  </div>
                ))}
              </div>

              {/* Reset password */}
              <div style={{ fontSize: 10, color: "#008a20", letterSpacing: "0.1em", marginBottom: 10 }}>// {lang === "ru" ? "СМЕНА ПАРОЛЯ" : "RESET PASSWORD"}</div>
              <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
                <input type="password" placeholder="••••••••" value={newPassword} onChange={e => setNewPassword(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && resetPassword()}
                  style={{ flex: 1, background: "var(--inp)", border: "1px solid var(--bor)", padding: "8px 10px", color: "var(--g)", fontFamily: "var(--mono)", fontSize: 12, outline: "none" }} />
                <button onClick={resetPassword} disabled={!newPassword || actionLoading}
                  style={{ padding: "8px 14px", border: "1px solid var(--g)", background: "var(--dk)", color: "var(--g)", fontFamily: "var(--mono)", fontSize: 11, cursor: "pointer", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)", boxShadow: "0 0 8px var(--glow)" }}>
                  {actionLoading ? "..." : "🔑"}
                </button>
              </div>

              {/* Danger zone */}
              <div style={{ fontSize: 10, color: "rgba(255,49,49,0.6)", letterSpacing: "0.1em", marginBottom: 10 }}>// {lang === "ru" ? "ОПАСНАЯ ЗОНА" : "DANGER ZONE"}</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                <button onClick={async () => {
                  if (!window.confirm(lang === "ru" ? `Выйти со всех устройств ${selectedUser.name}?` : `Log out all devices for ${selectedUser.name}?`)) return;
                  setActionLoading(true); setError(""); setSuccess("");
                  try {
                    await adminFetch(`/_synapse/admin/v1/user/${encodeURIComponent(selectedUser.name)}/devices`, "DELETE");
                    setSuccess("✓ " + (lang === "ru" ? "Все устройства отключены" : "All devices logged out"));
                  } catch(e) { setError(e.message); }
                  finally { setActionLoading(false); }
                }} style={{ padding: "8px", border: "1px solid rgba(255,49,49,0.3)", background: "rgba(255,49,49,0.05)", color: "var(--rd)", fontFamily: "var(--mono)", fontSize: 10, cursor: "pointer", clipPath: "polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%)", letterSpacing: "0.05em" }}>
                  ⏻ {lang === "ru" ? "ВЫЙТИ ВЕЗДЕ" : "LOGOUT ALL"}
                </button>
                <button onClick={async () => {
                  if (!window.confirm(lang === "ru" ? `Удалить все медиафайлы ${selectedUser.name}?` : `Delete all media for ${selectedUser.name}?`)) return;
                  setActionLoading(true); setError(""); setSuccess("");
                  try {
                    await adminFetch(`/_synapse/admin/v1/users/${encodeURIComponent(selectedUser.name)}/media`, "DELETE");
                    setSuccess("✓ " + (lang === "ru" ? "Медиа удалено" : "Media deleted"));
                  } catch(e) { setError(e.message); }
                  finally { setActionLoading(false); }
                }} style={{ padding: "8px", border: "1px solid rgba(255,49,49,0.3)", background: "rgba(255,49,49,0.05)", color: "var(--rd)", fontFamily: "var(--mono)", fontSize: 10, cursor: "pointer", clipPath: "polygon(2px 0%,100% 0%,calc(100% - 2px) 100%,0% 100%)", letterSpacing: "0.05em" }}>
                  🗑 {lang === "ru" ? "УДАЛИТЬ МЕДИА" : "DELETE MEDIA"}
                </button>
              </div>
              <div style={{ marginTop: 10 }}>
                <button onClick={() => deleteUser(selectedUser)} disabled={actionLoading}
                  style={{ width:"100%", padding: "10px", border: "2px solid var(--rd)", background: "rgba(255,49,49,0.08)", color: "var(--rd)", fontFamily: "var(--disp)", fontSize: 10, cursor: "pointer", letterSpacing: "0.12em", fontWeight:"bold" }}>
                  ✕ {lang === "ru" ? "УДАЛИТЬ АККАУНТ (ERASE)" : "DELETE ACCOUNT (ERASE)"}
                </button>
              </div>
            </div>

            <div style={{ padding: "12px 18px", borderTop: "1px solid var(--bor)", display: "flex", justifyContent: "flex-end" }}>
              <button onClick={() => setModal(null)} style={{ padding: "8px 20px", border: "1px solid var(--bor)", background: "none", color: "var(--gd)", fontFamily: "var(--mono)", fontSize: 11, cursor: "pointer", clipPath: "polygon(3px 0%,100% 0%,calc(100% - 3px) 100%,0% 100%)" }}>
                [ {lang === "ru" ? "ЗАКРЫТЬ" : "CLOSE"} ]
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function AppRouter() {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);

  if (path === "/register") {
    const token = params.get("token") || "";
    return <RegisterPage token={token} />;
  }
  return <App />;
}

export default AppRouter;

// ── Emoji Data ────────────────────────────────────────────────
const EMOJI_CATS = [
  { id:"smileys", icon:"😀", label:"Смайлики", emojis:["😀","😃","😄","😁","😆","😅","🤣","😂","🙂","😊","😇","🥰","😍","🤩","😘","😗","😙","😚","😋","😛","😜","🤪","😝","🤑","🤗","🤭","🤫","🤔","😐","😑","😶","😏","😒","🙄","😬","🤥","😌","😔","😪","🤤","😴","😷","🤒","🤕","🤢","🤮","🥵","🥶","😵","🤯","🤠","🥳","😎","🤓","🧐","😕","😟","🙁","😮","😯","😲","😳","🥺","😦","😧","😨","😰","😥","😢","😭","😱","😖","😣","😞","😓","😩","😫","🥱","😤","😡","😠","🤬","😈","👿","💀","☠️","💩","🤡","👹","👺","👻","👽","👾","🤖"] },
  { id:"people", icon:"👋", label:"Жесты", emojis:["👋","🤚","🖐","✋","🖖","👌","🤌","🤏","✌️","🤞","🤟","🤘","🤙","👈","👉","👆","🖕","👇","☝️","👍","👎","✊","👊","🤛","🤜","👏","🙌","👐","🤲","🤝","🙏","✍️","💅","🤳","💪","🦾","🦿","🦵","🦶","👂","🦻","👃","🧠","👀","👁","👅","👄","💋","🦷","👶","🧒","👦","👧","🧑","👱","👨","🧔","👩","🧓","👴","👵","🙍","🙎","🙅","🙆","💁","🙋","🧏","🙇","🤦","🤷"] },
  { id:"nature", icon:"🐶", label:"Природа", emojis:["🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐨","🐯","🦁","🐮","🐷","🐸","🐵","🙈","🙉","🙊","🐔","🐧","🐦","🐤","🦆","🦅","🦉","🦇","🐺","🐗","🐴","🦄","🐝","🦋","🐌","🐛","🦟","🦗","🕷","🦂","🐢","🐍","🦎","🦖","🦕","🐙","🦑","🦐","🦞","🦀","🐡","🐠","🐟","🐬","🐳","🐋","🦈","🐊","🐅","🐆","🦓","🦍","🦧","🦣","🐘","🦛","🦏","🐪","🐫","🦒","🦘","🦬","🐃","🐂","🐄","🐎","🐖","🐏","🐑","🦙","🐐","🦌","🐕","🐩","🦮","🐕‍🦺","🐈","🐈‍⬛","🪶","🐓","🦃","🦤","🦚","🦜","🦢","🦩","🕊","🐇","🦝","🦨","🦡","🦫","🦦","🦥","🐁","🐀","🐿","🦔","🌵","🎄","🌲","🌳","🌴","🪵","🌱","🌿","☘️","🍀","🎍","🪴","🎋","🍃","🍂","🍁","🌾","🌺","🌸","🌼","🌻","🌞","🌝","🌛","🌜","🌚","🌕","🌖","🌗","🌘","🌑","🌒","🌓","🌔","🌙","🌟","⭐","🌠","☀️","🌤","⛅","🌥","☁️","🌦","🌧","⛈","🌩","🌨","❄️","☃️","⛄","🌬","💨","💧","💦","🌊","🌀","🌈","☂️","⚡"] },
  { id:"food", icon:"🍕", label:"Еда", emojis:["🍕","🍔","🍟","🌭","🍿","🧂","🥓","🥚","🍳","🧇","🥞","🧈","🍞","🥐","🥨","🥯","🧀","🥗","🥙","🥪","🌮","🌯","🫔","🧆","🥚","🍝","🍜","🍲","🍛","🍣","🍱","🥟","🦪","🍤","🍙","🍘","🍥","🥮","🍢","🧁","🍰","🎂","🍮","🍭","🍬","🍫","🍿","🍩","🍪","🌰","🥜","🍯","🍺","🍻","🥂","🍷","🥃","🍸","🍹","🧉","🍾","☕","🍵","🧃","🥤","🧋","🧊"] },
  { id:"activity", icon:"⚽", label:"Активность", emojis:["⚽","🏀","🏈","⚾","🥎","🎾","🏐","🏉","🥏","🎱","🏓","🏸","🏒","🏑","🥍","🏏","🪃","🥅","⛳","🪁","🏹","🎣","🤿","🥊","🥋","🎽","🛹","🛼","🛷","⛸","🥌","🎿","⛷","🏂","🪂","🏋️","🤼","🤸","⛹️","🤺","🤾","🏌️","🏇","🧘","🏄","🏊","🤽","🚣","🧗","🚴","🏆","🥇","🥈","🥉","🏅","🎖","🏵","🎗","🎫","🎟","🎪","🤹","🎭","🎨","🎬","🎤","🎧","🎼","🎵","🎶","🎷","🪗","🎸","🎹","🎺","🎻","🪘","🥁","🪕","🎲","♟","🎯","🎳","🎮","🎰","🧩"] },
  { id:"travel", icon:"🚀", label:"Путешествия", emojis:["🚀","✈️","🛸","🚁","🛶","⛵","🚤","🛥","🛳","⛴","🚢","🚂","🚃","🚄","🚅","🚆","🚇","🚈","🚉","🚊","🚝","🚞","🚋","🚌","🚍","🚎","🚐","🚑","🚒","🚓","🚔","🚕","🚖","🚗","🚘","🚙","🛻","🚚","🚛","🚜","🏎","🏍","🛵","🦽","🦼","🛺","🚲","🛴","🛹","🛼","🚏","🛣","🛤","⛽","🛞","🚨","🚥","🚦","🛑","🚧","⚓","🪝","⛵","🏗","🏘","🏚","🏠","🏡","🏢","🏣","🏤","🏥","🏦","🏨","🏩","🏪","🏫","🏬","🏭","🏯","🏰","💒","🗼","🗽","⛪","🕌","🛕","🕍","⛩","🕋","⛲","⛺","🌁","🌃","🏙","🌄","🌅","🌆","🌇","🌉","♨️","🎠","🎡","🎢","💈","🎪"] },
  { id:"objects", icon:"💡", label:"Объекты", emojis:["💡","🔦","🕯","🪔","🧯","🛢","💰","💵","💴","💶","💷","💸","💳","🪙","💹","📈","📉","📊","📋","📌","📍","📎","🖇","📏","📐","✂️","🗃","🗄","🗑","🔒","🔓","🔏","🔐","🔑","🗝","🔨","🪓","⛏","⚒","🛠","🗡","⚔️","🔫","🪃","🏹","🛡","🪚","🔧","🪛","🔩","⚙️","🗜","⚖️","🦯","🔗","⛓","🪝","🧲","⚗️","🧪","🧫","🧬","🔬","🔭","📡","💉","🩸","💊","🩹","🩺","🚪","🪞","🪟","🛏","🛋","🪑","🚽","🪠","🚿","🛁","🪤","🪒","🧴","🧷","🧹","🧺","🧻","🪣","🧼","🫧","🪥","🧽","🪜","🛒"] },
  { id:"symbols", icon:"❤️", label:"Символы", emojis:["❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔","❣️","💕","💞","💓","💗","💖","💘","💝","💟","☮️","✝️","☪️","🕉","☸️","✡️","🔯","🕎","☯️","☦️","🛐","⛎","♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓","🆔","⚛️","🉑","☢️","☣️","📴","📳","🈶","🈚","🈸","🈺","🈷️","✴️","🆚","💮","🉐","㊙️","㊗️","🈴","🈵","🈹","🈲","🅰️","🅱️","🆎","🆑","🅾️","🆘","❌","⭕","🛑","⛔","📛","🚫","💯","💢","♨️","🚷","🚯","🚳","🚱","🔞","📵","🔕","🎵","🎶","💱","💲","♻️","🔱","📛","🔰","⭕","✅","☑️","✔️","❎","🔲","🔳","⬛","⬜","◼️","◻️","◾","◽","▪️","▫️","🟥","🟧","🟨","🟩","🟦","🟪","⚫","⚪","🟫"] },
];

const STICKER_PACKS = [
  { id:"nexus", label:"NEXUS", type:"emoji", stickers:["🤖","👾","💻","🖥","⌨️","🖱","💾","💿","📡","🔌","⚡","🌐","🔐","🛡","⚙️","🔧","🔩","🧬","🧪","🔬","🛸","🚀","🌌","⭐","🌠","💫","✨","🎯","🎮","🕹"] },
  { id:"mood", label:"НАСТРОЕНИЕ", type:"emoji", stickers:["😭😭","😱🔥","💀💀","🥺👉👈","😈😈","🤡🤡","👁👄👁","🥴🥴","😤💢","🫠🫠","🤌💋","💅✨","🫡🫡","😎🕶","🤯🤯","😴💤","🥳🎉","😏😏","🫶🫶","💪🔥"] },
  { id:"greet", label:"ПРИВЕТСТВИЯ", type:"emoji", stickers:["👋😊","🤝💼","🫂❤️","✌️😎","🙏🙏","👐🌟","🤗💕","🫡🎖","🤙😎","💯👊","🔥💪","👑⭐","🎉🥳","🫶💖","😘💌","🤩🌟","💥🔥","🌈✨","🚀⭐","🎊🎉"] },

];

function EmojiPicker({ onEmoji, onSticker, onClose }) {
  const [cat, setCat] = useState("smileys");
  const [pack, setPack] = useState("nexus");
  const [tab, setTab] = useState("emoji"); // "emoji" | "stickers"
  const [search, setSearch] = useState("");
  const ref = useRef();

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    setTimeout(() => document.addEventListener("mousedown", handler), 0);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  const currentCat = EMOJI_CATS.find(c => c.id === cat);
  const filtered = search
    ? EMOJI_CATS.flatMap(c => c.emojis).filter(e => e.includes(search))
    : currentCat?.emojis || [];

  return (
    <div className="emoji-popup" ref={ref}>
      {/* Top tabs: Emoji / Stickers */}
      <div style={{display:"flex",borderBottom:"1px solid var(--bor)"}}>
        {[["emoji","😀","EMOJI"],["stickers","🎭","СТИКЕРЫ"]].map(([id,icon,label]) => (
          <div key={id} onClick={() => setTab(id)}
            style={{flex:1,padding:"8px",textAlign:"center",cursor:"pointer",fontSize:11,
              borderBottom:`2px solid ${tab===id?"var(--g)":"transparent"}`,
              color:tab===id?"var(--g)":"var(--gd)",background:tab===id?"var(--glow)":"none",
              fontFamily:"var(--disp)",letterSpacing:"0.1em",transition:"all 0.1s"}}>
            {icon} {label}
          </div>
        ))}
      </div>

      {tab === "emoji" && (<>
        {/* Category tabs */}
        <div className="emoji-tabs">
          {EMOJI_CATS.map(c => (
            <div key={c.id} className={`emoji-tab ${cat===c.id?"active":""}`}
              onClick={() => { setCat(c.id); setSearch(""); }} title={c.label}>{c.icon}</div>
          ))}
        </div>
        {/* Search */}
        <div className="emoji-search">
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 поиск..." />
        </div>
        {/* Grid */}
        <div className="emoji-grid">
          {filtered.map((e, i) => (
            <button key={i} className="emoji-btn" onClick={() => { onEmoji(e); onClose(); }}>{e}</button>
          ))}
        </div>
      </>)}

      {tab === "stickers" && (<>
        {/* Pack selector */}
        <div className="emoji-tabs">
          {STICKER_PACKS.map(p => (
            <div key={p.id} className={`emoji-tab ${pack===p.id?"active":""}`}
              onClick={() => setPack(p.id)}
              style={{fontSize:11,fontFamily:"var(--disp)",letterSpacing:"0.05em",padding:"6px 10px"}}>
              {p.label}
            </div>
          ))}
        </div>
        {(() => {
          const currentPack = STICKER_PACKS.find(p => p.id === pack);
          if (!currentPack) return null;
          if (currentPack.type === "gif") return (
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:4,padding:8,maxHeight:220,overflowY:"auto"}}>
              {currentPack.stickers.map((url, i) => (
                <div key={i} onClick={() => { onSticker(url, "gif"); onClose(); }}
                  style={{cursor:"pointer",border:"1px solid var(--bor)",overflow:"hidden",transition:"all 0.1s",aspectRatio:"1"}}
                  onMouseOver={e=>e.currentTarget.style.borderColor="var(--g)"}
                  onMouseOut={e=>e.currentTarget.style.borderColor="var(--bor)"}>
                  <img src={url} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}} loading="lazy" alt="" />
                </div>
              ))}
            </div>
          );
          return (
            <div className="sticker-grid">
              {currentPack.stickers.map((s, i) => (
                <button key={i} className="sticker-btn" onClick={() => { onSticker(s, "emoji"); onClose(); }}>{s}</button>
              ))}
            </div>
          );
        })()}
      </>)}
    </div>
  );
}

// ── User Context Menu ─────────────────────────────────────────
// ── Profile Modal ─────────────────────────────────────────────
// ── Message Context Menu ──────────────────────────────────────
const QUICK_REACTIONS = ["👍","❤️","😂","😮","😢","🔥","👏","🤔"];

function MsgContextMenu({ msg, x, y, onClose, client, myUserId, activeRoomId, lang, canDelete, onReply, onEdit, onForward, onOptimisticReaction }) {
  const ref = useRef();
  const [showReactions, setShowReactions] = useState(false);

  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    setTimeout(() => document.addEventListener("mousedown", h), 0);
    return () => document.removeEventListener("mousedown", h);
  }, [onClose]);

  const sendReaction = async (emoji) => {
    if (msg.own) return;
    const rxEntries = Object.entries(msg.reactions || {});
    const myRx = rxEntries.filter(([, {senders}]) => senders.includes(myUserId));
    const alreadyThis = myRx.find(([e]) => e === emoji);
    if (alreadyThis) {
      // optimistic remove
      onOptimisticReaction(msg.id, emoji, myUserId, "remove");
      const room = client.getRoom(activeRoomId);
      const rxEvent = room?.getLiveTimeline().getEvents().find(e =>
        e.getType()==="m.reaction" && !e.isRedacted?.() &&
        e.getSender()===myUserId &&
        e.getContent()?.["m.relates_to"]?.event_id===msg.id &&
        e.getContent()?.["m.relates_to"]?.key===emoji
      );
      if (rxEvent) try { await client.redactEvent(activeRoomId, rxEvent.getId()); } catch(e) {}
      onClose(); return;
    }
    if (myRx.length >= 2) { onClose(); return; }
    // optimistic add
    onOptimisticReaction(msg.id, emoji, myUserId, "add");
    try {
      await client.sendEvent(activeRoomId, "m.reaction", {
        "m.relates_to": { rel_type: "m.annotation", event_id: msg.id, key: emoji }
      });
    } catch(e) { console.error(e); }
    onClose();
  };

  const copyText = () => { navigator.clipboard.writeText(msg.body || ""); onClose(); };

  const forwardMsg = () => {
    const text = msg.body || "";
    onReply(null, `> _${msg.senderName}: ${text}_

`);
    onClose();
  };

  const deleteMsg = async () => {
    if (!window.confirm(lang==="ru"?"Удалить сообщение?":"Delete message?")) return;
    try { await client.redactEvent(activeRoomId, msg.id); } catch(e) { console.error(e); }
    onClose();
  };

  const menuW = showReactions ? 220 : 190;
  const adjX = Math.min(x, window.innerWidth - menuW - 10);
  const adjY = Math.min(y, window.innerHeight - 320);

  return (
    <div ref={ref} className="msg-ctx" style={{left:adjX, top:adjY}}>
      {/* Quick reactions */}
      <div style={{display:"flex",gap:2,padding:"8px 10px",borderBottom:"1px solid var(--bor)",flexWrap:"wrap"}}>
        {QUICK_REACTIONS.map(e => (
          <button key={e} onClick={() => sendReaction(e)}
            style={{fontSize:18,background:"none",border:"none",cursor:"pointer",padding:"2px 3px",borderRadius:4,transition:"transform 0.1s"}}
            onMouseOver={ev=>ev.target.style.transform="scale(1.3)"}
            onMouseOut={ev=>ev.target.style.transform="scale(1)"}>
            {e}
          </button>
        ))}
        <button onClick={() => setShowReactions(p=>!p)}
          style={{fontSize:13,background:"none",border:"1px solid var(--bor)",color:"var(--gd)",cursor:"pointer",padding:"2px 6px",marginLeft:"auto"}}>
          {showReactions?"✕":"＋"}
        </button>
      </div>
      {showReactions && (
        <div style={{display:"grid",gridTemplateColumns:"repeat(8,1fr)",gap:1,padding:"6px",borderBottom:"1px solid var(--bor)",maxHeight:120,overflowY:"auto"}}>
          {["😀","😃","😄","😁","😆","😅","😂","🙂","😊","😇","🥰","😍","😘","😋","😛","😜","🤪","😝","🤑","🤗","🤭","🤔","😐","😑","😶","😏","😒","🙄","😬","😌","😔","😪","😴","😷","🤒","🤢","🤮","🥵","🥶","😵","🤯","😎","🤓","😕","😟","😮","😳","🥺","😦","😧","😨","😰","😢","😭","😱","😤","😡","😠","🤬","😈","💀","💩","🤡","👻","👽","👾","🤖","👍","👎","👏","🙌","🤝","🙏","❤️","🧡","💛","💚","💙","💜","🖤","💔","💯","🔥","⭐","✨","💫","🎉","🎊","🚀","💡","✅","❌"].map(e => (
            <button key={e} onClick={() => sendReaction(e)}
              style={{fontSize:16,background:"none",border:"none",cursor:"pointer",padding:"2px",transition:"transform 0.1s"}}
              onMouseOver={ev=>ev.target.style.transform="scale(1.3)"}
              onMouseOut={ev=>ev.target.style.transform="scale(1)"}>
              {e}
            </button>
          ))}
        </div>
      )}
      <div className="msg-ctx-sep" />
      <div className="msg-ctx-item" onClick={() => { onReply(msg); onClose(); }}>↩ {lang==="ru"?"Ответить":"Reply"}</div>
      <div className="msg-ctx-item" onClick={copyText}>⎘ {lang==="ru"?"Копировать текст":"Copy text"}</div>
      <div className="msg-ctx-item" onClick={() => { onForward(msg); onClose(); }}>⇥ {lang==="ru"?"Переслать":"Forward"}</div>
      {msg.own && !msg.redacted && <div className="msg-ctx-item" onClick={() => { onEdit(msg); onClose(); }}>✎ {lang==="ru"?"Редактировать":"Edit"}</div>}
      {canDelete && !msg.redacted && <>
        <div className="msg-ctx-sep" />
        <div className="msg-ctx-item danger" onClick={deleteMsg}>✕ {lang==="ru"?"Удалить":"Delete"}</div>
      </>}
    </div>
  );
}

// ── Forward Modal ─────────────────────────────────────────────
function ForwardModal({ msg, client, myUserId, lang, onClose, rooms }) {
  const [search, setSearch] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState([]);

  const targets = rooms
    .filter(r => {
      const name = r.name || r.roomId;
      return name.toLowerCase().includes(search.toLowerCase());
    })
    .sort((a,b) => (a.name||"").localeCompare(b.name||""));

  const forward = async (roomId) => {
    setSending(true);
    try {
      const text = msg.body || "";
      const senderName = msg.senderName || msg.sender;
      await client.sendEvent(roomId, "m.room.message", {
        msgtype: "m.text",
        body: `⇥ ${senderName}: ${text}`,
        "m.forward_from": msg.sender,
      });
      setSent(p => [...p, roomId]);
    } catch(e) { alert(e.message); }
    finally { setSending(false); }
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:300,display:"flex",alignItems:"center",justifyContent:"center"}}
      onClick={onClose}>
      <div style={{background:"var(--pan)",border:"1px solid var(--borb)",width:360,maxWidth:"90vw",maxHeight:"70vh",display:"flex",flexDirection:"column",
        clipPath:"polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%)",boxShadow:"0 0 40px var(--glow)",animation:"fadeIn 0.15s"}}
        onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 18px",borderBottom:"1px solid var(--bor)"}}>
          <span style={{fontFamily:"var(--disp)",fontSize:12,letterSpacing:"0.1em",color:"var(--g)"}}>⇥ {lang==="ru"?"ПЕРЕСЛАТЬ":"FORWARD"}</span>
          <span style={{cursor:"pointer",color:"var(--gd)",fontSize:16}} onClick={onClose}>✕</span>
        </div>
        <div style={{padding:"8px 12px",borderBottom:"1px solid var(--bor)"}}>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder={lang==="ru"?"Поиск комнат и людей...":"Search rooms and people..."}
            style={{width:"100%",background:"var(--inp)",border:"1px solid var(--bor)",padding:"6px 10px",color:"var(--g)",fontFamily:"var(--mono)",fontSize:12,outline:"none"}} />
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"6px 0"}}>
          {targets.map(r => {
            const isSent = sent.includes(r.roomId);
            const members = r.getJoinedMembers();
            const isDM = members.length <= 2;
            const name = isDM ? members.find(m=>m.userId!==myUserId)?.name || r.name : r.name;
            return (
              <div key={r.roomId}
                onClick={() => !isSent && !sending && forward(r.roomId)}
                style={{display:"flex",alignItems:"center",gap:10,padding:"9px 16px",cursor:isSent?"default":"pointer",
                  background:isSent?"rgba(0,255,65,0.05)":"none",transition:"background 0.1s"}}
                onMouseOver={e=>{ if(!isSent) e.currentTarget.style.background="var(--glow)"; }}
                onMouseOut={e=>{ if(!isSent) e.currentTarget.style.background="none"; }}>
                <span style={{fontSize:14,width:20,textAlign:"center"}}>{isDM?"👤":"#"}</span>
                <span style={{flex:1,fontSize:12,color:"var(--g)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{name}</span>
                {isSent
                  ? <span style={{fontSize:10,color:"var(--g)",letterSpacing:"0.1em"}}>✓ {lang==="ru"?"ОТПРАВЛЕНО":"SENT"}</span>
                  : <span style={{fontSize:10,color:"var(--gd)"}}>{lang==="ru"?"отправить":"send"} →</span>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const PROFILE_FIELDS = [
  { key:"bio",      label:"О СЕБЕ",    labelEn:"BIO",         icon:"📝", type:"textarea" },
  { key:"city",     label:"ГОРОД",     labelEn:"CITY",        icon:"🌍", type:"text" },
  { key:"birthday", label:"ДЕНЬ РОЖ.", labelEn:"BIRTHDAY",    icon:"📅", type:"date" },
  { key:"job",      label:"ДОЛЖНОСТЬ", labelEn:"JOB",         icon:"💼", type:"text" },
  { key:"email",    label:"EMAIL",     labelEn:"EMAIL",       icon:"✉️", type:"text" },
  { key:"telegram", label:"TELEGRAM",  labelEn:"TELEGRAM",    icon:"✈️", type:"text" },
  { key:"github",   label:"GITHUB",    labelEn:"GITHUB",      icon:"🐙", type:"text" },
  { key:"website",  label:"САЙТ",      labelEn:"WEBSITE",     icon:"🔗", type:"text" },
  { key:"interests",label:"ИНТЕРЕСЫ",  labelEn:"INTERESTS",   icon:"🎯", type:"text" },
];

function ProfileModal({ userId, client, myUserId, lang, onClose, onStartDM, isAdmin, homeserver }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [adminInfo, setAdminInfo] = useState(null);
  const [extProfile, setExtProfile] = useState({});   // {bio, city, ...}
  const [extVisible, setExtVisible] = useState({});   // {bio: true/false, ...}
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState({});
  const [editVis, setEditVis] = useState({});
  const [saving, setSaving] = useState(false);
  const isSelf = userId === myUserId;

  useEffect(() => {
    setLoading(true);
    client.getProfileInfo(userId).then(p => {
      setProfile(p);
      setLoading(false);
    }).catch(() => { setProfile({}); setLoading(false); });

    if (isAdmin) {
      const tok = client.getAccessToken();
      fetch(`${homeserver}/_synapse/admin/v2/users/${encodeURIComponent(userId)}`, {
        headers: { "Authorization": `Bearer ${tok}` }
      }).then(r => r.json()).then(d => setAdminInfo(d)).catch(() => {});
    }

    // Load extended profile
    if (isSelf) {
      // Own profile: read directly from account_data
      const loadOwn = () => {
        try {
          const own = client.getAccountData("nexus.profile.ext")?.getContent() || {};
          const vis = client.getAccountData("nexus.profile.visibility")?.getContent() || {};
          setExtProfile(own); setExtVisible(vis);
          setEditData({...own}); setEditVis({...vis});
        } catch(e) {}
      };
      loadOwn();
      // Also try after short delay in case account_data syncs late
      setTimeout(loadOwn, 800);
    } else {
      // Other user: read public fields from shared room state event
      try {
        const rooms = client.getRooms().filter(r => r.getMember(userId) && r.getMember(myUserId));
        for (const r of rooms) {
          const ev = r.currentState?.getStateEvents?.("nexus.profile.public", userId);
          if (ev) {
            const pub = ev.getContent() || {};
            setExtProfile(pub);
            // All fields in public event are visible
            const vis = {};
            Object.keys(pub).forEach(k => { if (pub[k]) vis[k] = true; });
            setExtVisible(vis);
            break;
          }
        }
      } catch(e) {}
    }
  }, [userId, client]);

  const saveProfile = async () => {
    setSaving(true);
    try {
      await client.setAccountData("nexus.profile.ext", editData);
      await client.setAccountData("nexus.profile.visibility", editVis);
      // Publish public fields to all shared rooms as state event
      const pubData = {};
      PROFILE_FIELDS.forEach(f => { if (editVis[f.key] && editData[f.key]) pubData[f.key] = editData[f.key]; });
      const rooms = client.getRooms().filter(r => r.getMember(myUserId)?.membership === "join");
      for (const r of rooms.slice(0,10)) {
        try { await client.sendStateEvent(r.roomId, "nexus.profile.public", pubData, myUserId); } catch(e) {}
      }
      setExtProfile(editData); setExtVisible(editVis); setEditMode(false);
    } catch(e) { alert(e.message); }
    finally { setSaving(false); }
  };

  const mxcToUrl = (mxc) => {
    if (!mxc?.startsWith("mxc://")) return null;
    const [server, id] = mxc.slice(6).split("/");
    return `${client.getHomeserverUrl()}/_matrix/client/v1/media/download/${server}/${id}?access_token=${client.getAccessToken()}`;
  };

  const name = profile?.displayname || userId.replace(/^@/,"").split(":")[0];
  const avatarUrl = mxcToUrl(profile?.avatar_url);
  const shortId = userId.replace(/^@/,"").split(":")[0];
  const sharedRooms = client.getRooms().filter(r => r.getMember(userId) && r.getMember(myUserId));
  const ru = lang === "ru";

  const inpStyle = {width:"100%",background:"var(--inp)",border:"1px solid var(--bor)",color:"var(--g)",
    fontFamily:"var(--mono)",fontSize:11,padding:"5px 8px",outline:"none",boxSizing:"border-box",resize:"vertical"};
  const labelStyle = {fontSize:9,color:"var(--gd)",letterSpacing:"0.12em",marginBottom:3,display:"flex",alignItems:"center",gap:6};

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center"}}
      onClick={onClose}>
      <div style={{background:"var(--pan)",border:"1px solid var(--borb)",width:440,maxWidth:"92vw",maxHeight:"88vh",
        display:"flex",flexDirection:"column",
        clipPath:"polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%)",
        boxShadow:"0 0 40px var(--glow)",animation:"fadeIn 0.15s"}}
        onClick={e=>e.stopPropagation()}>

        {/* Header */}
        <div style={{display:"flex",alignItems:"center",gap:14,padding:"16px 20px",borderBottom:"1px solid var(--bor)",flexShrink:0}}>
          <div style={{width:60,height:60,border:"2px solid var(--borb)",flexShrink:0,overflow:"hidden",
            clipPath:"polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%)",
            background:"var(--inp)",display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:22,color:"var(--gd)",fontFamily:"var(--disp)"}}>
            {avatarUrl
              ? <img src={avatarUrl} style={{width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"} />
              : shortId.slice(0,2).toUpperCase()}
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:15,color:"var(--g)",fontFamily:"var(--disp)",fontWeight:700,letterSpacing:"0.08em",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
              {name}
              {isSelf && <span style={{marginLeft:8,fontSize:9,color:"var(--cy)",border:"1px solid var(--cy)",padding:"1px 5px",letterSpacing:"0.1em"}}>YOU</span>}
            </div>
            <div style={{fontSize:10,color:"var(--gd)",marginTop:2,opacity:0.7}}>{userId}</div>
            {extProfile.city && !editMode && <div style={{fontSize:10,color:"var(--gd)",marginTop:2}}>🌍 {extProfile.city}</div>}
            {extProfile.job  && !editMode && <div style={{fontSize:10,color:"var(--gd)",marginTop:1}}>💼 {extProfile.job}</div>}
          </div>
          {isSelf && !editMode && (
            <button onClick={()=>{ setEditData({...extProfile}); setEditVis({...extVisible}); setEditMode(true); }}
              style={{padding:"5px 10px",background:"var(--inp)",border:"1px solid var(--bor)",color:"var(--gd)",
                fontFamily:"var(--mono)",fontSize:10,cursor:"pointer",letterSpacing:"0.08em",flexShrink:0}}>
              ✎ {ru?"ИЗМЕНИТЬ":"EDIT"}
            </button>
          )}
          <div style={{cursor:"pointer",color:"var(--gd)",fontSize:16,padding:4,flexShrink:0}} onClick={onClose}>✕</div>
        </div>

        {/* Body - scrollable */}
        <div style={{overflowY:"auto",flex:1,padding:"14px 20px",display:"flex",flexDirection:"column",gap:12}}>
          {loading ? (
            <div style={{textAlign:"center",color:"var(--gd)",fontSize:12,padding:20}}>LOADING...</div>
          ) : (<>

            {/* ── EDIT MODE ── */}
            {isSelf && editMode && (
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                <div style={{fontSize:10,color:"var(--gd)",letterSpacing:"0.15em",marginBottom:4}}>
                  // {ru?"РЕДАКТИРОВАТЬ ПРОФИЛЬ":"EDIT PROFILE"}
                  <span style={{marginLeft:8,fontSize:9,opacity:0.6}}>👁 = {ru?"видно всем":"visible to all"}</span>
                </div>
                {PROFILE_FIELDS.map(f => (
                  <div key={f.key}>
                    <div style={labelStyle}>
                      <span>{f.icon} {ru ? f.label : f.labelEn}</span>
                      <label style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:4,cursor:"pointer",fontSize:10,color:editVis[f.key]?"var(--g)":"var(--gd)"}}>
                        <input type="checkbox" checked={!!editVis[f.key]}
                          onChange={e=>setEditVis(v=>({...v,[f.key]:e.target.checked}))}
                          style={{accentColor:"var(--g)",cursor:"pointer"}} />
                        👁
                      </label>
                    </div>
                    {f.type === "textarea"
                      ? <textarea rows={3} value={editData[f.key]||""} onChange={e=>setEditData(d=>({...d,[f.key]:e.target.value}))} style={inpStyle} />
                      : <input type="text" value={editData[f.key]||""} onChange={e=>setEditData(d=>({...d,[f.key]:e.target.value}))} style={{...inpStyle,resize:undefined}} placeholder={f.type==="date"?"YYYY-MM-DD":""} />
                    }
                  </div>
                ))}
                <div style={{display:"flex",gap:8,marginTop:4}}>
                  <button onClick={saveProfile} disabled={saving}
                    style={{flex:1,padding:"8px",background:"rgba(0,180,60,0.1)",border:"1px solid var(--g)",color:"var(--g)",
                      fontFamily:"var(--disp)",fontSize:10,cursor:"pointer",letterSpacing:"0.1em"}}>
                    {saving?"...":`[ ${ru?"СОХРАНИТЬ":"SAVE"} ]`}
                  </button>
                  <button onClick={()=>setEditMode(false)}
                    style={{padding:"8px 16px",background:"var(--inp)",border:"1px solid var(--bor)",color:"var(--gd)",
                      fontFamily:"var(--mono)",fontSize:10,cursor:"pointer"}}>
                    {ru?"ОТМЕНА":"CANCEL"}
                  </button>
                </div>
              </div>
            )}

            {/* ── VIEW MODE: extended profile fields ── */}
            {!editMode && (() => {
              const visFields = PROFILE_FIELDS.filter(f =>
                extProfile[f.key] && (isSelf || extVisible[f.key])
              );
              if (!visFields.length) return null;
              return (
                <div style={{display:"flex",flexDirection:"column",gap:6}}>
                  <div style={{fontSize:10,color:"var(--gd)",letterSpacing:"0.15em",marginBottom:2}}>
                    // {ru?"ПРОФИЛЬ":"PROFILE"}
                  </div>
                  {visFields.map(f => (
                    <div key={f.key} style={{display:"flex",gap:8,alignItems:"flex-start",
                      background:"var(--inp)",padding:"6px 10px",border:"1px solid var(--bor)"}}>
                      <span style={{fontSize:14,flexShrink:0}}>{f.icon}</span>
                      <div>
                        <div style={{fontSize:9,color:"var(--gd)",letterSpacing:"0.1em"}}>{ru?f.label:f.labelEn}</div>
                        <div style={{fontSize:11,color:"var(--g)",marginTop:2,wordBreak:"break-word"}}>
                          {f.key==="telegram" && extProfile[f.key]
                            ? <a href={`https://t.me/${extProfile[f.key].replace(/^@/,"")}`} target="_blank" rel="noreferrer"
                                style={{color:"var(--cy)",textDecoration:"none"}}>
                                @{extProfile[f.key].replace(/^@/,"")}
                              </a>
                            : f.key==="website" && extProfile[f.key]
                            ? <a href={extProfile[f.key]} target="_blank" rel="noreferrer"
                                style={{color:"var(--cy)",textDecoration:"none"}}>{extProfile[f.key]}</a>
                            : f.key==="github" && extProfile[f.key]
                            ? <a href={`https://github.com/${extProfile[f.key].replace(/^@/,"")}`} target="_blank" rel="noreferrer"
                                style={{color:"var(--cy)",textDecoration:"none"}}>{extProfile[f.key]}</a>
                            : extProfile[f.key]
                          }
                        </div>
                      </div>
                      {isSelf && <span style={{marginLeft:"auto",fontSize:9,opacity:0.5,flexShrink:0}}>{extVisible[f.key]?"👁 публично":"🔒 приватно"}</span>}
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* Shared rooms */}
            {sharedRooms.length > 0 && (
              <div>
                <div style={{fontSize:10,color:"var(--gd)",letterSpacing:"0.15em",marginBottom:6}}>
                  // {ru?"ОБЩИЕ КОМНАТЫ":"SHARED ROOMS"} ({sharedRooms.length})
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                  {sharedRooms.map(r => (
                    <span key={r.roomId} style={{fontSize:10,padding:"2px 8px",border:"1px solid var(--bor)",color:"var(--gd)",background:"var(--inp)"}}>
                      {r.name || r.roomId}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Admin info */}
            {isAdmin && adminInfo && (
              <div style={{borderTop:"1px solid var(--bor)",paddingTop:10}}>
                <div style={{fontSize:10,color:"var(--gd)",letterSpacing:"0.15em",marginBottom:6}}>// ADMIN INFO</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:4,fontSize:11}}>
                  {[
                    ["STATUS", adminInfo.deactivated ? "⛔ DEACTIVATED" : "✓ ACTIVE"],
                    ["ADMIN", adminInfo.admin ? "✓ YES" : "✗ NO"],
                    ["CREATED", adminInfo.creation_ts ? new Date(adminInfo.creation_ts > 1e12 ? adminInfo.creation_ts : adminInfo.creation_ts*1000).toLocaleDateString() : "—"],
                    ["TYPE", adminInfo.user_type || "regular"],
                  ].map(([k,v]) => (
                    <div key={k} style={{background:"var(--inp)",padding:"4px 8px",border:"1px solid var(--bor)"}}>
                      <div style={{fontSize:9,color:"var(--gd)",letterSpacing:"0.1em"}}>{k}</div>
                      <div style={{color:"var(--g)",marginTop:2}}>{v}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Actions */}
            {!isSelf && (
              <div style={{borderTop:"1px solid var(--bor)",paddingTop:10,display:"flex",gap:8}}>
                <button onClick={() => { onStartDM(userId); onClose(); }}
                  style={{flex:1,padding:"8px",background:"var(--inp)",border:"1px solid var(--bor)",color:"var(--gd)",
                    fontFamily:"var(--disp)",fontSize:10,cursor:"pointer",letterSpacing:"0.08em",transition:"all 0.1s"}}
                  onMouseOver={e=>{e.currentTarget.style.borderColor="var(--g)";e.currentTarget.style.color="var(--g)"}}
                  onMouseOut={e=>{e.currentTarget.style.borderColor="var(--bor)";e.currentTarget.style.color="var(--gd)"}}>
                  💬 {ru?"НАПИСАТЬ":"DM"}
                </button>
              </div>
            )}
          </>)}
        </div>
      </div>
    </div>
  );
}

function UserContextMenu({ userId, displayName, x, y, onClose, client, myUserId, activeRoomId, lang, onStartDM, onMention, onMuteChange, onProfile }) {
  const ref = useRef();
  const [muted, setMuted] = useState(() => {
    try { return JSON.parse(localStorage.getItem("nexus_muted") || "[]").includes(userId); } catch(e){ return false; }
  });

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    setTimeout(() => document.addEventListener("mousedown", h), 0);
    return () => document.removeEventListener("mousedown", h);
  }, [onClose]);

  const toggleMute = () => {
    const stored = JSON.parse(localStorage.getItem("nexus_muted") || "[]");
    const next = muted ? stored.filter(id => id !== userId) : [...stored, userId];
    localStorage.setItem("nexus_muted", JSON.stringify(next));
    setMuted(!muted);
    if (onMuteChange) onMuteChange(next);
    onClose();
  };

  const myLevel = client?.getRoom(activeRoomId)?.getMember(myUserId)?.powerLevel || 0;
  const theirLevel = client?.getRoom(activeRoomId)?.getMember(userId)?.powerLevel || 0;
  const canKick = myLevel >= 50 && theirLevel < myLevel && userId !== myUserId;
  const isSelf = userId === myUserId;
  const name = displayName || userId.replace(/^@/,"").split(":")[0];

  const menuItems = [
    !isSelf && { icon:"💬", label: lang==="ru"?"Написать в личку":"Send DM", action: () => { onStartDM(userId); onClose(); } },
    !isSelf && { icon:"↩️", label: lang==="ru"?"Упомянуть":"Mention", action: () => { onMention(userId, name); onClose(); } },
    !isSelf && { icon: muted?"🔔":"🔕", label: muted ? (lang==="ru"?"Включить уведомления":"Unmute") : (lang==="ru"?"Замутить":"Mute"), action: toggleMute },
    { icon:"👤", label: lang==="ru"?"Профиль":"View Profile", action: () => {
      onProfile(userId); onClose();
    }},
    !isSelf && canKick && { icon:"🚫", label: lang==="ru"?"Кикнуть из комнаты":"Kick from room", danger: true, action: async () => {
      if (!window.confirm(lang==="ru"?`Кикнуть ${name}?`:`Kick ${name}?`)) return;
      try { await client.kick(activeRoomId, userId); } catch(e) { alert(e.message); }
      onClose();
    }},
  ].filter(Boolean);

  // Adjust position to stay on screen
  const menuW = 200, menuH = menuItems.length * 38 + 16;
  const adjX = Math.min(x, window.innerWidth - menuW - 10);
  const adjY = Math.min(y, window.innerHeight - menuH - 10);

  return (
    <div ref={ref} style={{
      position:"fixed", left:adjX, top:adjY, zIndex:500,
      background:"var(--pan)", border:"1px solid var(--borb)",
      width:menuW, boxShadow:"0 0 20px var(--glow)",
      clipPath:"polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%)",
      animation:"fadeIn 0.12s"
    }}>
      <div style={{padding:"8px 12px 6px", borderBottom:"1px solid var(--bor)", fontSize:11, color:"var(--g)", fontFamily:"var(--disp)", letterSpacing:"0.1em", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>
        {name}
        {muted && <span style={{marginLeft:6,fontSize:9,color:"var(--am)",background:"rgba(255,176,0,0.1)",padding:"1px 5px",border:"1px solid rgba(255,176,0,0.3)"}}>MUTED</span>}
      </div>
      {menuItems.map((item, i) => (
        <div key={i} onClick={item.action}
          style={{display:"flex",alignItems:"center",gap:8,padding:"9px 12px",cursor:"pointer",
            fontSize:12,color:item.danger?"var(--rd)":"var(--gd)",transition:"all 0.1s",
            borderLeft:"2px solid transparent"}}
          onMouseOver={e=>{e.currentTarget.style.background="var(--glow)";e.currentTarget.style.borderLeftColor=item.danger?"var(--rd)":"var(--g)";e.currentTarget.style.color=item.danger?"var(--rd)":"var(--g)"}}
          onMouseOut={e=>{e.currentTarget.style.background="";e.currentTarget.style.borderLeftColor="transparent";e.currentTarget.style.color=item.danger?"var(--rd)":"var(--gd)"}}>
          <span style={{fontSize:14}}>{item.icon}</span>
          {item.label}
        </div>
      ))}
    </div>
  );
}


// Derives a 32-byte key from password+salt using PBKDF2 — used for E2EE secret storage

// Derives a 32-byte key from password+salt using PBKDF2 — used for E2EE secret storage
async function deriveKeyFromPassword(password, salt, hash = "SHA-512") {
  const enc = new TextEncoder();
  const km = await window.crypto.subtle.importKey("raw", enc.encode(password), "PBKDF2", false, ["deriveBits"]);
  const bits = await window.crypto.subtle.deriveBits(
    { name: "PBKDF2", salt: enc.encode(salt), iterations: 500000, hash }, km, 256
  );
  return new Uint8Array(bits);
}

// Encode raw 32-byte key into Matrix recovery key format (base58 with prefix+parity)
function encodeRecoveryKey(keyBytes) {
  var OLM_RECOVERY_KEY_PREFIX = [0x8B, 0x01];
  var data = new Uint8Array(OLM_RECOVERY_KEY_PREFIX.length + keyBytes.length + 1);
  data.set(OLM_RECOVERY_KEY_PREFIX, 0);
  data.set(keyBytes, OLM_RECOVERY_KEY_PREFIX.length);
  var parity = 0;
  for (var i = 0; i < data.length - 1; i++) parity ^= data[i];
  data[data.length - 1] = parity;
  // Base58 encode using repeated division on byte array
  var ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  var digits = [0];
  for (var b = 0; b < data.length; b++) {
    var carry = data[b];
    for (var j = 0; j < digits.length; j++) {
      carry += digits[j] * 256;
      digits[j] = carry % 58;
      carry = Math.floor(carry / 58);
    }
    while (carry > 0) { digits.push(carry % 58); carry = Math.floor(carry / 58); }
  }
  var encoded = "";
  for (var k = 0; k < data.length && data[k] === 0; k++) encoded += "1";
  for (var m = digits.length - 1; m >= 0; m--) encoded += ALPHABET[digits[m]];
  return encoded.match(/.{1,4}/g).join(" ");
}

function SecuritySetupScreen({ client, userId, passphrase, lang, onDone }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const setup = async () => {
    setLoading(true); setError("");
    try {
      const crypto = client.getCrypto?.();
      if (!crypto) throw new Error("Crypto not available");

      const privateKey = await deriveKeyFromPassword(passphrase, userId, "SHA-512");

      await crypto.bootstrapSecretStorage({
        createSecretStorageKey: async () => ({
          keyInfo: {
            passphrase: {
              algorithm: "m.pbkdf2",
              iterations: 500000,
              salt: userId,
              bits: 256,
            }
          },
          privateKey
        }),
        setupNewKeyBackup: true,
        setupNewSecretStorage: true,
      });

      // Set up cross-signing so Element can verify this device
      await crypto.bootstrapCrossSigning?.({ setupNewCrossSigning: true, authUploadDeviceSigningKeys: makeAuthUploadDeviceSigningKeys(client) }).catch(e => console.warn("Cross-signing setup:", e.message));
      // Recovery pass: reads back keys from secret storage → signs our device
      await crypto.bootstrapCrossSigning?.({ setupNewCrossSigning: false, authUploadDeviceSigningKeys: makeAuthUploadDeviceSigningKeys(client) }).catch(e => console.warn("Cross-signing recovery:", e.message));
      await crossSignAllOwnDevices(client);

      // Mark setup as done for this user — won't show again on next login
      localStorage.setItem(`nexus_e2ee_setup_${userId}`, "1");
      console.log("E2EE: secret storage + key backup created");
      setDone(true);
      setTimeout(onDone, 1500);
    } catch(e) {
      console.error("E2EE setup error:", e);
      setError(e.message);
    } finally { setLoading(false); }
  };

  return (
    <div style={{position:"fixed",inset:0,background:"var(--bg)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,flexDirection:"column"}}>
      <MatrixRain />
      <div style={{position:"relative",zIndex:2,background:"var(--pan)",border:"1px solid var(--borb)",padding:"32px 40px",maxWidth:480,width:"100%",boxShadow:"0 0 40px var(--glow)",clipPath:"polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%)"}}>
        <div style={{fontFamily:"var(--disp)",fontSize:14,fontWeight:700,color:"var(--g)",letterSpacing:"0.15em",textShadow:"0 0 10px var(--g)",marginBottom:8}}>
          🔒 SECURE BACKUP
        </div>
        <div style={{fontSize:10,color:"var(--gd)",letterSpacing:"0.08em",marginBottom:20,lineHeight:1.6}}>
          {lang==="ru"
            ? "Для защиты ключей шифрования необходимо настроить безопасное хранилище. Ключи будут зашифрованы и сохранены на сервере — это позволит расшифровать сообщения при следующем входе."
            : "To protect your encryption keys, secure backup must be set up. Keys will be encrypted and stored on the server — this allows decrypting messages after next login."}
        </div>
        {done
          ? <div style={{color:"var(--g)",fontSize:12,textAlign:"center",letterSpacing:"0.1em"}}>✓ {lang==="ru"?"ГОТОВО":"DONE"}</div>
          : <>
            {error && <div style={{color:"#ff4444",fontSize:10,marginBottom:12,padding:"6px 8px",border:"1px solid rgba(255,68,68,0.3)",background:"rgba(255,68,68,0.05)"}}>{error}</div>}
            <button onClick={setup} disabled={loading}
              style={{width:"100%",padding:"12px",border:"1px solid var(--g)",background:"var(--dk)",color:"var(--g)",fontFamily:"var(--mono)",fontSize:12,cursor:"pointer",letterSpacing:"0.1em",boxShadow:"0 0 12px var(--glow)",clipPath:"polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%)"}}>
              {loading ? "[ НАСТРОЙКА... ]" : (lang==="ru" ? "[ НАСТРОИТЬ ЗАЩИТУ ]" : "[ SET UP SECURE BACKUP ]")}
            </button>
          </>
        }
      </div>
    </div>
  );
}

function App() {
  const [booted, setBooted] = useState(false);
  const [client, setClient] = useState(null);
  const [myUserId, setMyUserId] = useState("");
  const [loginData, setLoginData] = useState({ user: "", pass: "", server: HOMESERVER });
  const [loginError, setLoginError] = useState("");
  const [storeConflict, setStoreConflict] = useState(false);

  const [loginLoading, setLoginLoading] = useState(false);
  const [securitySetup, setSecuritySetup] = useState(false); // unused, kept for compat
  const [rooms, setRooms] = useState([]);
  const [activeRoomId, setActiveRoomId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [members, setMembers] = useState([]);
  const [input, setInput] = useState("");
  const [search, setSearch] = useState("");
  const [showMembers, setShowMembers] = useState(() => window.innerWidth > 768);
  const [showSettings, setShowSettings] = useState(false);
  // Clear room search when settings opens — prevents browser autofill bleeding into search
  useEffect(() => { if (showSettings) setSearch(""); }, [showSettings]);
  const [lang, setLang] = useState(() => localStorage.getItem("nexus_lang") || "ru");
  const t = T[lang] || T.ru;
  const [theme, setTheme] = useState(() => localStorage.getItem("nexus_theme") || "dark");
  const [notifs, setNotifs] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [typing, setTyping] = useState(false);
  const [notif, setNotif] = useState(null);
  const [unread, setUnread] = useState({});
  const [modal, setModal] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [activeView, setActiveView] = useState("chat");
  const [isAdminUser, setIsAdminUser] = useState(false);
  const [showRoomSettings, setShowRoomSettings] = useState(false);
  const [showE2EEInfo, setShowE2EEInfo] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [showPollModal, setShowPollModal] = useState(false);
  const [pollQuestion, setPollQuestion] = useState("");
  const [pollOptions, setPollOptions] = useState(["", ""]);
  const [pollAnon, setPollAnon] = useState(true);
  const [pollMulti, setPollMulti] = useState(false);
  const [userMenu, setUserMenu] = useState(null); // {userId, displayName, x, y}
  const [profileModal, setProfileModal] = useState(null); // userId
  const [msgCtx, setMsgCtx] = useState(null); // {msg, x, y}
  const [replyTo, setReplyTo] = useState(null); // message being replied to
  const [editingMsg, setEditingMsg] = useState(null); // message being edited
  const [forwardMsg, setForwardMsg] = useState(null); // message being forwarded
  const [roomTopic, setRoomTopic] = useState("");
  const [activeCall, setActiveCall] = useState(null);   // {peerName, isVideo, isConnected, isCaller, localStream, remoteStream}
  const [peerMuted, setPeerMuted] = useState({ audio: false, video: false });
  const [incomingCall, setIncomingCall] = useState(null); // {roomId, callId, peerName, isVideo, offer}
  const incomingCallRef = useRef(null);
  const hangupCallIdsRef = useRef(new Set()); // callIds that already received hangup
  const [jitsiCall, setJitsiCall] = useState(null);
  const [incomingGroupCall, setIncomingGroupCall] = useState(null);
  const pcRef = useRef(null);   // RTCPeerConnection
  const callRoomRef = useRef(null); // roomId of active call
  const callIdRef = useRef(null);   // callId
  const [mobileRoomsOpen, setMobileRoomsOpen] = useState(false); // mobile rooms panel
  const [mobileView, setMobileView] = useState("rooms"); // "rooms" | "chat"
  const [cmdHints, setCmdHints] = useState([]); // autocomplete hints for /commands
  const [mutedUsers, setMutedUsers] = useState(() => { try { return JSON.parse(localStorage.getItem("nexus_muted")||"[]"); } catch(e){ return []; } });
  const [font, setFont] = useState(() => { const f = localStorage.getItem("nexus_font"); return f === "ibm" ? "space" : f === "victor" ? "space" : f || "mono"; });
  const [rainMode, setRainMode] = useState(() => localStorage.getItem("nexus_rain") || "off"); // off | subtle | intense | chaos
  const [fontSize, setFontSize] = useState(() => localStorage.getItem("nexus_fsize") || "md");
  const endRef = useRef(); const notifTimer = useRef(); const msgsRef = useRef(); const histLoadingRef = useRef(false); const shouldScrollRef = useRef(false);
  const clientRef = useRef(); const activeRoomIdRef = useRef();
  const pendingPushRoomRef = useRef(null);

  // Android hardware back button
  useEffect(() => {
    if (!window.Capacitor?.isNativePlatform()) return;
    const App = window.Capacitor?.Plugins?.App;
    if (!App) return;
    let lastBack = 0;
    const handler = App.addListener('backButton', () => {
      // If any modal/overlay is open — close it
      if (jitsiCall || activeCall || incomingCall) return; // let calls handle their own back
      if (showSettings) { setShowSettings(false); return; }
      if (showRoomSettings) { setShowRoomSettings(false); return; }
      if (showE2EEInfo) { setShowE2EEInfo(false); return; }
      if (showMembers) { setShowMembers(false); return; }
      if (modal) { setModal(null); return; }
      // If in chat view on mobile — go back to room list
      if (mobileView === 'chat') { setMobileView('rooms'); setMobileRoomsOpen(true); return; }
      // If already in room list — minimize app on double back tap (within 2s)
      const now = Date.now();
      if (now - lastBack < 2000) { App.minimizeApp?.(); }
      else { lastBack = now; }
    });
    return () => { handler?.then?.(h => h?.remove?.()); };
  }, [jitsiCall, activeCall, incomingCall, showSettings, showRoomSettings, showE2EEInfo, showMembers, modal, mobileView]);

  // Handle Answer/Decline from system call notification
  useEffect(() => {
    if (!window.Capacitor?.isNativePlatform()) return;

    const handleAnswer = (e) => {
      try {
        let data = e.detail;
        if (typeof data === 'string') { try { data = JSON.parse(data); } catch(_) {} }
        const roomId = data?.roomId || data?.room_id;
        console.log('[NEXUS] nexusAnswerCallIntent roomId:', roomId);
        try { window.Capacitor?.Plugins?.NexusCallScreen?.endCall?.(); } catch(_) {}
        // Set pending answer — if roomId known use it, otherwise __any__ matches first incoming
        if (!window.__nexusPendingAnswerRoomId) {
          window.__nexusPendingAnswerRoomId = roomId || '__any__';
        }
      } catch(err) { console.warn('[NEXUS] handleAnswer error:', err); }
    };

    const handleDecline = (e) => {
      try {
        let data = e.detail;
        if (typeof data === 'string') { try { data = JSON.parse(data); } catch(_) {} }
        const roomId = data?.roomId || data?.room_id;
        console.log('[NEXUS] nexusIncomingCallIntent decline roomId:', roomId);
        try { window.Capacitor?.Plugins?.NexusCallScreen?.endCall?.(); } catch(_) {}
        // Send hangup for the current incoming call
        window.__nexusPendingDeclineTs = Date.now();
      } catch(err) {}
    };

    const handleCallDeclined = (e) => {
      console.log('[NEXUS] nexus-call-declined received');
      try { window.Capacitor?.Plugins?.NexusCallScreen?.endCall?.(); } catch(_) {}
      try { window.Capacitor?.Plugins?.NexusCallScreen?.clearLockscreen?.(); } catch(_) {}
      if (incomingCallRef.current) {
        const call = incomingCallRef.current;
        setIncomingCall(null);
        clientRef.current?.sendEvent(call.roomId, 'm.call.hangup', { call_id: call.callId, version: 1, reason: 'user_hangup' }).catch(()=>{});
      } else {
        window.__nexusPendingDeclineTs = Date.now();
      }
    };

    window.addEventListener('nexusAnswerCallIntent', handleAnswer);
    window.addEventListener('nexusIncomingCallIntent', handleDecline);
    window.addEventListener('nexus-call-declined', handleCallDeclined);
    return () => {
      window.removeEventListener('nexusAnswerCallIntent', handleAnswer);
      window.removeEventListener('nexusIncomingCallIntent', handleDecline);
      window.removeEventListener('nexus-call-declined', handleCallDeclined);
    };
  }, []);

  // Global early listener for push tap events — fires before client useEffect
  useEffect(() => {
    if (!window.Capacitor?.isNativePlatform()) return;
    const earlyHandler = (e) => {
      try {
        const data = typeof e.detail === 'string' ? JSON.parse(e.detail) : e.detail;
        const roomId = data?.roomId;
        if (!roomId) return;
        // If full handler is registered, let it handle
        if (window.__nexusOpenRoomHandler) {
          window.__nexusOpenRoomHandler(e);
          return;
        }
        // Otherwise store for later
        pendingPushRoomRef.current = roomId;
        console.log('[NEXUS] Early push tap stored:', roomId);
      } catch(err) {}
    };
    window.addEventListener('nexusOpenRoomFromPush', earlyHandler);
    return () => window.removeEventListener('nexusOpenRoomFromPush', earlyHandler);
  }, []);
  activeRoomIdRef.current = activeRoomId;

  const showNotif = useCallback((title, text) => {
    setNotif({ title, text }); clearTimeout(notifTimer.current);
    notifTimer.current = setTimeout(() => setNotif(null), 3500);
  }, []);

  const refreshRooms = useCallback((cl) => {
    const c = cl || clientRef.current; if (!c) return;
    setRooms(c.getRooms().filter(r => r.getMyMembership() === "join")
      .sort((a, b) => (b.getLastActiveTimestamp() || 0) - (a.getLastActiveTimestamp() || 0)));
  }, []);

  const loadMessages = useCallback(async (roomId) => {
    const c = clientRef.current; if (!c || !roomId) return;
    const room = c.getRoom(roomId); if (!room) return;
    // Initial load - paginate back once to get ~50 messages
    const timeline = room.getLiveTimeline();
    try {
      if (timeline.getPaginationToken("b")) {
        await c.paginateEventTimeline(timeline, { backwards: true, limit: 50 });
      }
    } catch(e) {}
    const allEvents = room.getLiveTimeline().getEvents();
    // Build edit map: eventId -> latest body
    const editMap = {};
    allEvents.filter(e => e.getType() === "m.room.message" && e.getContent()?.["m.relates_to"]?.rel_type === "m.replace").forEach(e => {
      const orig = e.getContent()["m.relates_to"].event_id;
      editMap[orig] = { body: e.getContent()["m.new_content"]?.body || "", edited: true };
    });
    // Build reaction map: eventId -> {emoji: {count, senders, eventIds}}
    const rxMap = {};
    allEvents.filter(e => e.getType() === "m.reaction" && !e.isRedacted?.()).forEach(e => {
      const rel = e.getContent()?.["m.relates_to"]; if (!rel) return;
      const sender = e.getSender();
      if (!rxMap[rel.event_id]) rxMap[rel.event_id] = {};
      if (!rxMap[rel.event_id][rel.key]) rxMap[rel.event_id][rel.key] = { count: 0, senders: [], eventIds: {} };
      const entry = rxMap[rel.event_id][rel.key];
      if (!entry.eventIds[sender]) { // deduplicate: one per user per emoji
        entry.count++;
        entry.senders.push(sender);
      }
      entry.eventIds[sender] = e.getId();
    });
    // Build call history: pair invites with hangups to get duration
    const callInvites = {}; // callId -> {ts, sender}
    const callHangups = {}; // callId -> {ts, reason}
    const callAnswers = new Set(); // callIds that have an m.call.answer
    allEvents.forEach(e => {
      const t = e.getType(); const ct = e.getContent() || {};
      if (t === "m.call.invite") callInvites[ct.call_id] = { ts: e.getTs(), sender: e.getSender(), eventId: e.getId() };
      if (t === "m.call.hangup") callHangups[ct.call_id] = { ts: e.getTs(), reason: ct.reason };
      if (t === "m.call.answer") callAnswers.add(ct.call_id);
    });
    // Build set of callId eventIds to skip as raw messages
    const callEventIds = new Set(allEvents.filter(e => e.getType().startsWith("m.call.") || e.getType() === "org.matrix.msc3401.call.member" || e.getType() === "m.call.notify").map(e => e.getId()));

    // Filter: only real messages, skip edit-replacements
    const msgs = allEvents
      .filter(e => {
        const t = e.getType();
        if (t === "m.call.invite") return true; // include as call history item
        if (!["m.room.message","m.room.encrypted"].includes(t)) return false;
        if (e.getContent()?.["m.relates_to"]?.rel_type === "m.replace") return false;
        return true;
      })
      .map(e => {
        const id = e.getId();
        const t = e.getType();
        // Call invite — render as call history bubble
        if (t === "m.call.invite") {
          const ct = e.getContent() || {};
          const callId = ct.call_id;
          const hangup = callHangups[callId];
          const wasAnswered = callAnswers.has(callId);
          const durationMs = hangup ? hangup.ts - e.getTs() : 0;
          const durationStr = (wasAnswered && durationMs > 3000)
            ? (durationMs >= 60000
              ? `${Math.floor(durationMs/60000)}м ${Math.floor((durationMs%60000)/1000)}с`
              : `${Math.floor(durationMs/1000)}с`)
            : null;
          const own = e.getSender() === c.getUserId();
          const missed = !wasAnswered && !own;
          return {
            id, sender: e.getSender(),
            senderName: room.getMember(e.getSender())?.name || e.getSender(),
            body: "", msgtype: "m.call",
            callType: ct.offer?.sdp?.includes("m=video") ? "video" : "audio",
            callMissed: missed,
            callDuration: durationStr,
            callDirection: own ? "outgoing" : "incoming",
            redacted: false, encrypted: false,
            ts: e.getTs(), own,
            reactions: {}, replyTo: null,
          };
        }
        const c2 = e.getContent() || {};
        const edit = editMap[id];
        return {
          id, sender: e.getSender(),
          senderName: room.getMember(e.getSender())?.name || e.getSender(),
          body: edit?.body || c2.body || (e.getType() === "m.room.encrypted" ? "[🔒 encrypted]" : ""),
          edited: !!edit,
          msgtype: c2.msgtype || "m.text",
          url: c2.url || null,
          fileInfo: c2.info ? {...c2.info, format:c2.format, "m.sticker_url":c2["m.sticker_url"]} : (c2.format ? {format:c2.format,"m.sticker_url":c2["m.sticker_url"],"pollData":c2.pollData} : null),
          redacted: e.isRedacted?.() || false,
          encrypted: e.isEncrypted?.() || e.getType() === "m.room.encrypted",
          ts: e.getTs(), own: e.getSender() === c.getUserId(),
          reactions: rxMap[id] || {},
          replyTo: c2["m.relates_to"]?.["m.in_reply_to"]?.event_id || null,
        };
      });
    setMessages(msgs);
    setMembers(room.getJoinedMembers().map(m => ({
      userId: m.userId, name: m.name || m.userId,
      presence: c.getUser(m.userId)?.presence || "offline",
    })));
  }, []);

  // Auto-restore session on app start — same device_id every time (like Element)
  const startClientRef = useRef(null);
  const clearE2EEStoresRef = useRef(null);
  // Wipe all E2EE IndexedDB stores — needed after logout/all or device mismatch
  const clearE2EEStores = useCallback(async () => {
    try {
      // Only wipe E2EE IndexedDB stores — NOT localStorage sessions
      if (indexedDB.databases) {
        const dbs = await indexedDB.databases();
        await Promise.all(dbs
          .filter(db => db.name && (db.name.includes("nexus-e2ee") || db.name.includes("matrix") || db.name.includes("crypto")))
          .map(db => new Promise(r => { const q = indexedDB.deleteDatabase(db.name); q.onsuccess = q.onerror = q.onblocked = r; }))
        );
      } else {
        const knownNames = ["nexus-e2ee", "matrix-js-sdk:crypto", "matrix-js-sdk:riot:crypto"];
        await Promise.all(knownNames.map(n => new Promise(r => { const q = indexedDB.deleteDatabase(n); q.onsuccess = q.onerror = q.onblocked = r; })));
      }
      // Do NOT clear nexus_session_* — keep the saved access token & device ID!
      setStoreConflict(false);
      setLoginError("");
    } catch(e) { console.warn("clearE2EEStores:", e); }
  }, []);

  useEffect(() => {
    // Restore last session — per-user key prevents cross-user conflicts
    const lastUser = localStorage.getItem("nexus_last_user");
    const saved = lastUser ? localStorage.getItem(`nexus_session_${lastUser}`) : null;
    if (!saved) return;
    try {
      const session = JSON.parse(saved);
      if (session.accessToken && session.userId && session.deviceId && session.baseUrl) {
        // Check session age — auto-expire after 24h of inactivity
        const SESSION_TTL = 24 * 60 * 60 * 1000; // 24 hours
        if (session.lastSeen && (Date.now() - session.lastSeen > SESSION_TTL)) {
          console.log("Session expired (24h TTL), logging out device:", session.deviceId);
          // Logout on server to clean up device
          fetch(`${session.baseUrl}/_matrix/client/v3/logout`, {
            method: "POST", headers: { "Authorization": `Bearer ${session.accessToken}`, "Content-Type": "application/json" }, body: "{}"
          }).catch(() => {});
          localStorage.removeItem(`nexus_session_${lastUser}`);
          localStorage.removeItem("nexus_last_user");
          return;
        }
        // Update lastSeen timestamp
        session.lastSeen = Date.now();
        localStorage.setItem(`nexus_session_${lastUser}`, JSON.stringify(session));
        setLoginLoading(true);
        if (startClientRef.current) startClientRef.current(session);
      }
    } catch(e) {
      if (lastUser) localStorage.removeItem(`nexus_session_${lastUser}`);
    }
  }, []);

  const startClient = useCallback(async ({ accessToken, userId, deviceId, baseUrl, pass }) => {
    setLoginLoading(true); setLoginError("");
    try {
      // storePath is per-user (no deviceId) — stable across logins since we reuse device_id
      const storePath = `nexus-e2ee-${userId}`;

      // Wipe stores from OTHER users only
      const allDbs = await indexedDB.databases().catch(() => []);
      const otherDbs = allDbs.filter(db =>
        db.name?.includes("nexus-e2ee") && !db.name?.includes(userId)
      );
      if (otherDbs.length > 0) {
        await Promise.all(otherDbs.map(db => new Promise(r => {
          const q = indexedDB.deleteDatabase(db.name);
          q.onsuccess = q.onerror = q.onblocked = r;
        })));
        await new Promise(r => setTimeout(r, 200));
      }

      // Secret storage key callback — derives key from password
      // New backups (with bits:256 in keyInfo) use SHA-512, old backups use SHA-256
      const getSecretStorageKey = pass ? async ({ keys }) => {
        try {
          const keyId = Object.keys(keys).find(id => keys[id]?.passphrase?.salt === userId)
            || Object.keys(keys)[0];
          if (!keyId) return null;
          const keyInfo = keys[keyId];
          // If keyInfo has bits field, it's new format (SHA-512), otherwise try SHA-256 first for legacy
          const hasNewFormat = keyInfo?.passphrase?.bits === 256;
          const hashOrder = hasNewFormat ? ["SHA-512"] : ["SHA-256", "SHA-512"];
          for (const hashAlg of hashOrder) {
            try {
              const privateKey = await deriveKeyFromPassword(pass, userId, hashAlg);
              return [keyId, privateKey];
            } catch(e) {}
          }
          return null;
        } catch(e) { console.warn("getSecretStorageKey failed:", e.message); return null; }
      } : undefined;

      let cl = sdk.createClient({
        baseUrl, accessToken, userId, deviceId,
        ...(getSecretStorageKey ? { cryptoCallbacks: { getSecretStorageKey } } : {}),
      });

      const initE2EE = async () => {
        // Only wipe stores that belong to OTHER users — keep our own store intact
        const allDbs = await indexedDB.databases().catch(() => []);
        // Our store name contains our userId (encoded)
        const ourStoreId = userId.replace(/[@:.]/g, "");
        const foreignDbs = allDbs.filter(db =>
          db.name?.includes("nexus-e2ee") && !db.name?.includes(ourStoreId)
        );
        if (foreignDbs.length > 0) {
          console.log("E2EE: wiping foreign stores:", foreignDbs.map(d => d.name));
          await Promise.all(foreignDbs.map(db => new Promise(r => {
            const q = indexedDB.deleteDatabase(db.name);
            q.onsuccess = q.onerror = q.onblocked = r;
          })));
          await new Promise(r => setTimeout(r, 200));
        }
        try {
          await cl.initRustCrypto({ storePath });
          console.log("E2EE: ready, device:", deviceId);
        } catch(e) {
          if (e.message?.includes("doesn't match the account")) {
            // Our store has wrong device — wipe it and retry
            console.warn("E2EE: device mismatch, clearing our store...");
            const ourDbs = allDbs.filter(db => db.name?.includes("nexus-e2ee"));
            await Promise.all(ourDbs.map(db => new Promise(r => {
              const q = indexedDB.deleteDatabase(db.name);
              q.onsuccess = q.onerror = q.onblocked = r;
            })));
            await new Promise(r => setTimeout(r, 300));
            await cl.initRustCrypto({ storePath });
            console.log("E2EE: ready after store reset, device:", deviceId);
          } else {
            console.error("E2EE initRustCrypto failed:", e.message);
          }
        }
      };
      await initE2EE();

      clientRef.current = cl;
setMyUserId(userId);
setClient(cl);
setSyncing(true);

if (window.Capacitor?.isNativePlatform()) {
  try {
    const { registerPlugin } = await import('@capacitor/core');
    const NexusSession = registerPlugin('NexusSession');
    await NexusSession.saveSession({
      homeserver: baseUrl,
      accessToken,
      userId,
      deviceId,
    });
    console.log('[NEXUS] Session saved for push service');
  } catch (e) {
    console.warn('[NEXUS] saveSession failed:', e);
  }
}

      let initialSyncDone = false;
      cl.on("Room.timeline", (event, room, toStartOfTimeline, removed, data) => {
        refreshRooms(cl);
        if (room.roomId === activeRoomIdRef.current) {
          // Auto-scroll only if user is near bottom (within 200px)
          const c = msgsRef.current;
          if (c && (c.scrollHeight - c.scrollTop - c.clientHeight) < 200) {
            shouldScrollRef.current = true;
          }
          loadMessages(room.roomId);
        } else if (!toStartOfTimeline && data?.liveEvent && initialSyncDone) {
          const type = event.getType();
          // Ignore call signaling events — they should not count as unread messages
          const isCallEvent = type.startsWith("m.call.") || type === "nexus.group_call" || type === MATRIXRTC_MEMBER || type === "m.call.notify"
            || type === "m.room.member" || type === "m.room.encryption"
            || type === "m.room.create" || type === "m.room.join_rules"
            || type === "m.room.history_visibility" || type === "m.room.guest_access"
            || type === "m.room.power_levels" || type === "m.room.topic"
            || type === "m.room.name" || type === "m.room.avatar"
            || type === "m.reaction" || type === "m.room.redaction";
          if (!isCallEvent && (type === "m.room.message" || type === "m.room.encrypted")) {
            setUnread(p => {
              const count = room.getUnreadNotificationCount("total") || (p[room.roomId] || 0) + 1;
              return { ...p, [room.roomId]: count };
            });
          }
        }
      });
      cl.on("RoomMember.membership", (event, member) => {
        if (member.userId === userId && member.membership === "invite") {
          cl.joinRoom(member.roomId).then(() => {
            refreshRooms(cl);
            if (initialSyncDone) showNotif(lang === "ru" ? "НОВОЕ ПРИГЛАШЕНИЕ" : "NEW INVITE", member.roomId);
          }).catch(console.error);
        }
      });
      cl.on("RoomMember.typing", (_, m) => { if (m.userId !== userId && m.roomId === activeRoomIdRef.current) setTyping(m.typing); });
      cl.on("sync", s => {
        if (s === "PREPARED") {
          setSyncing(false);
          refreshRooms(cl);
          // Check SharedPreferences for pending call actions (survives page reload + cold start)
          (async () => {
            try {
              const NexusSession = window.Capacitor?.Plugins?.NexusSession;
              if (NexusSession?.getPendingCallAction) {
                const action = await NexusSession.getPendingCallAction();
                if (action.decline) {
                  console.log('[NEXUS] PREPARED: pending decline from SharedPrefs');
                  const call = incomingCallRef.current || window.__lastIncomingCallInfo;
                  if (call?.roomId && call?.callId) {
                    setIncomingCall(null);
                    clientRef.current?.sendEvent(call.roomId, 'm.call.hangup', { call_id: call.callId, version: 1, reason: 'user_hangup' }).catch(e => console.warn('[NEXUS] hangup sendEvent failed:', e));
                    try { window.Capacitor?.Plugins?.NexusCallScreen?.endCall?.(); } catch(_) {}
                    try { window.Capacitor?.Plugins?.NexusCallScreen?.clearLockscreen?.(); } catch(_) {}
                    try { window.Capacitor?.Plugins?.NexusSession?.notifyCallEnded?.({ roomId: call.roomId }); } catch(_) {}
                    window.__lastIncomingCallInfo = null;
                  }
                  // Keep flag alive for 15s to catch caller retries, then auto-expire
                  window.__nexusPendingDeclineTs = Date.now();
                  window.__nexusPendingAnswerCallId = null;
                } else if (action.answerRoomId) {
                  const age = Date.now() - (action.answerTs || 0);
                  if (age < 30000) {
                    const expectedCallId = action.answerCallId || '';
                    console.log('[NEXUS] PREPARED: pending answer from SharedPrefs, age=' + age + 'ms, expectedCallId=' + expectedCallId);
                    if (expectedCallId) window.__nexusPendingAnswerCallId = expectedCallId;
                    if (incomingCallRef.current) {
                      // Only auto-answer if callId matches (or no expected callId)
                      if (!expectedCallId || incomingCallRef.current.callId === expectedCallId) {
                        window.__nexusCallAnswered = true;
                        const call = incomingCallRef.current;
                        setIncomingCall(null);
                        answerCall(call, call.isVideo ?? true);
                      } else {
                        console.log('[NEXUS] PREPARED: callId mismatch, waiting for correct invite');
                        window.__nexusPendingAnswerRoomId = action.answerRoomId;
                      }
                    } else {
                      window.__nexusPendingAnswerRoomId = action.answerRoomId;
                    }
                  }
                }
              }
            } catch(e) { console.warn('[NEXUS] getPendingCallAction failed:', e); }
          })();
          // Also check synchronously (evaluateJavascript retries may have set these)
          if (window.__nexusPendingAnswerRoomId && incomingCallRef.current) {
            window.__nexusPendingAnswerRoomId = null;
            window.__nexusCallAnswered = true;
            const call = incomingCallRef.current;
            setIncomingCall(null);
            answerCall(call, call.isVideo ?? true);
          } else if (pendingPushRoomRef.current) {
            // Regular push tap — navigate to room
            const rid = pendingPushRoomRef.current;
            pendingPushRoomRef.current = null;
            console.log('[NEXUS] Applying cold-start pending room after PREPARED:', rid);
            // Dismiss provisional call notification only if no pending answer and no real call
            if (window.Capacitor?.isNativePlatform()) {
              setTimeout(() => {
                if (!incomingCallRef.current && !window.__nexusPendingAnswerRoomId) {
                  console.log('[NEXUS] No call after PREPARED — dismissing provisional call notification');
                  try { window.Capacitor?.Plugins?.NexusCallScreen?.endCall?.(); } catch(_) {}
                }
              }, 3000);
            }
            selectRoomRef.current?.(rid);
          }
          const realUnread = {};
          cl.getRooms().forEach(room => {
            const count = room.getUnreadNotificationCount("total") || 0;
            if (count > 0) realUnread[room.roomId] = count;
          });
          setUnread(realUnread);
          setTimeout(() => { initialSyncDone = true; }, 2000);

          // Keep session alive — update lastSeen every 30 min
          const keepAliveInterval = setInterval(() => {
            try {
              const s = JSON.parse(localStorage.getItem(`nexus_session_${userId}`) || "{}");
              if (s.accessToken) { s.lastSeen = Date.now(); localStorage.setItem(`nexus_session_${userId}`, JSON.stringify(s)); }
            } catch(e) {}
          }, 30 * 60 * 1000);
          cl._nexusKeepAlive = keepAliveInterval;
          fetch(`${baseUrl}/_synapse/admin/v1/users/${encodeURIComponent(userId)}/admin`, {
            headers: { "Authorization": `Bearer ${accessToken}` }
          }).then(r => r.json()).then(d => { if (d.admin) setIsAdminUser(true); }).catch(() => {});

          // Key backup: restore or setup
          setTimeout(async () => {
            try {
              const crypto = cl.getCrypto?.();
              if (!crypto) return;

              // Check if backup exists on server
              // Query backup directly via Matrix API — SDK getKeyBackupVersion() returns null for untrusted backups
              let backupVersion = null;
              try {
                const resp = await fetch(`${baseUrl}/_matrix/client/v3/room_keys/version`, {
                  headers: { "Authorization": `Bearer ${accessToken}` }
                });
                if (resp.ok) backupVersion = await resp.json();
              } catch(e) {}
              console.log("E2EE: backup on server:", backupVersion?.version || "none");

              if (backupVersion && pass) {
                console.log("E2EE: backup version", backupVersion.version, "found, decrypting backup key...");
                try {
                  const defaultKeyData = await cl.getAccountDataFromServer?.("m.secret_storage.default_key").catch(() => null);
                  const defaultKeyId = defaultKeyData?.key;
                  const backupKeySecret = await cl.getAccountDataFromServer?.("m.megolm_backup.v1").catch(() => null);
                  const encEntry = backupKeySecret?.encrypted?.[defaultKeyId];

                  if (encEntry && defaultKeyId) {
                    // Try to decrypt backup key — SHA-512 first (spec), then SHA-256 (legacy)
                    let backupKey = null;
                    for (const hashAlg of ["SHA-512", "SHA-256"]) {
                      try {
                        const pbkdf2Key = await deriveKeyFromPassword(pass, userId, hashAlg);
                        const secretName = "m.megolm_backup.v1";
                        const hkdfKey = await window.crypto.subtle.importKey("raw", pbkdf2Key, "HKDF", false, ["deriveBits"]);
                        const derived = await window.crypto.subtle.deriveBits(
                          { name: "HKDF", hash: "SHA-256", salt: new Uint8Array(32), info: new TextEncoder().encode(secretName) },
                          hkdfKey, 512
                        );
                        const aesKeyBytes = new Uint8Array(derived).slice(0, 32);
                        const iv = Uint8Array.from(atob(encEntry.iv), c => c.charCodeAt(0));
                        const ciphertext = Uint8Array.from(atob(encEntry.ciphertext), c => c.charCodeAt(0));
                        const aesKey = await window.crypto.subtle.importKey("raw", aesKeyBytes, { name: "AES-CTR" }, false, ["decrypt"]);
                        const decryptedRaw = await window.crypto.subtle.decrypt(
                          { name: "AES-CTR", counter: iv, length: 64 },
                          aesKey, ciphertext
                        );
                        const decryptedStr = new TextDecoder().decode(decryptedRaw);
                        // Validate — must be valid base64url
                        const b64 = decryptedStr.replace(/-/g, "+").replace(/_/g, "/");
                        const decoded = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
                        if (decoded.length === 32) {
                          backupKey = decoded;
                          console.log("E2EE: decrypted backup key with " + hashAlg + " ✓");
                          break;
                        }
                      } catch(e) {
                        console.log("E2EE: " + hashAlg + " derivation failed, trying next...");
                      }
                    }

                    if (backupKey) {
                      // Store in crypto and enable
                      await crypto.storeSessionBackupPrivateKey?.(backupKey, backupVersion.version)
                        .catch(e => console.warn("E2EE storeKey:", e.message));
                      await crypto.checkKeyBackupAndEnable?.().catch(() => {});

                      // Restore all room keys
                      const result = await crypto.restoreKeyBackupWithRecoveryKey?.(
                        backupKey, undefined, undefined, backupVersion
                      ).catch(e => { console.warn("E2EE restoreWithKey:", e.message); return null; });

                      if (result?.imported > 0) {
                        console.log("E2EE: restored " + result.imported + " keys ✓");
                        setTimeout(() => { if (activeRoomIdRef.current) loadMessages(activeRoomIdRef.current); }, 1000);
                      } else {
                        console.warn("E2EE: restore returned", result?.imported, "keys");
                      }
                    } else {
                      console.warn("E2EE: could not decrypt backup key with either hash");
                      setSecuritySetup(true);
                    }
                  } else {
                    console.warn("E2EE: no backup key in account_data");
                    setSecuritySetup(true);
                  }

                  await crypto.requestAllMissingSessionKeys?.().catch(() => {});
                  localStorage.setItem("nexus_e2ee_setup_" + userId, "1");

                } catch(e) {
                  console.warn("E2EE restore error:", e.message);
                }
              } else if (!backupVersion) {
                // No backup on server — show setup only once
                const setupDone = localStorage.getItem(`nexus_e2ee_setup_${userId}`);
                if (!setupDone && pass) {
                  console.log("E2EE: no backup found, showing setup");
                  setSecuritySetup(true);
                }
              }

              // Request missing keys from other active devices (cross-device sharing)
              await crypto.requestAllMissingSessionKeys?.().catch(() => {});

              // Auto-verify our device: bootstrap cross-signing in recovery mode
              // This reads cross-signing keys from secret storage and signs our device
              try {
                const cs = await crypto.getCrossSigningStatus?.().catch(() => null);
                console.log("E2EE: cross-signing status:", JSON.stringify(cs));
                // Recovery bootstrap: reads existing keys from secret storage, caches them, signs device
                await crypto.bootstrapCrossSigning?.({
                  setupNewCrossSigning: false,
                  authUploadDeviceSigningKeys: makeAuthUploadDeviceSigningKeys(cl),
                }).catch(e => console.log("E2EE: recovery bootstrap:", e.message));
                console.log("E2EE: cross-signing recovery bootstrap done ✓");

                // Cross-sign ALL own devices (not just current)
                await crossSignAllOwnDevices(cl);
              } catch(e) { console.warn("E2EE self-verify:", e.message); }
            } catch(e) { console.warn("E2EE key restore:", e.message); }
          }, 3000);
        }
      });
      cl.on("Event.decrypted", ev => {
        if (ev.getRoomId() === activeRoomIdRef.current) {
          const c = msgsRef.current;
          if (c && (c.scrollHeight - c.scrollTop - c.clientHeight) < 200) {
            shouldScrollRef.current = true;
          }
          loadMessages(ev.getRoomId());
        }
      });
      cl.on("Room.myMembership", (room, membership, prevMembership) => {
        refreshRooms(cl);
        // When joining a room (e.g. after leaving and rejoining), request missing keys
        if (membership === "join" && prevMembership !== "join") {
          setTimeout(async () => {
            try {
              const crypto = cl.getCrypto?.();
              if (crypto?.requestAllMissingSessionKeys) {
                await crypto.requestAllMissingSessionKeys();
                console.log("🔑 Requested missing keys after join");
              }
            } catch(e) { console.warn("key request on join:", e.message); }
          }, 2000);
        }
      });

      await cl.startClient({ initialSyncLimit: 50 });
    } catch(e) {
      const isAuthError = e.message?.includes("M_UNKNOWN_TOKEN") || e.message?.includes("Invalid access token") || e.message?.includes("M_FORBIDDEN");
      // Only clear session on actual auth failures — NOT on E2EE store issues
      if (isAuthError) {
        const lastUser = localStorage.getItem("nexus_last_user");
        if (lastUser) localStorage.removeItem(`nexus_session_${lastUser}`);
      }
      // If E2EE store conflict — auto-clear stores and retry login once
      if (e.message?.includes("doesn't match") || isAuthError) {
        try {
          if (clearE2EEStoresRef.current) await clearE2EEStoresRef.current();
          if (startClientRef.current) {
            await startClientRef.current({ accessToken, userId, deviceId, baseUrl, pass });
            return;
          }
        } catch(retryErr) {
          setLoginError(`AUTH_FAILED: ${retryErr.message}`);
          setStoreConflict(true);
        }
      } else {
        setLoginError(`AUTH_FAILED: ${e.message}`);
      }
    } finally { setLoginLoading(false); }
  }, [lang, refreshRooms, loadMessages, showNotif]);

  // Store ref so useEffect can access it
  startClientRef.current = startClient;
  clearE2EEStoresRef.current = clearE2EEStores;

  const doLogin = async () => {
    setLoginError(""); setLoginLoading(true);
    try {
      const baseUrl = loginData.server.startsWith("http") ? loginData.server : `https://${loginData.server}`;
      const serverName = baseUrl.replace(/^https?:\/\//, "").replace(/\/$/, "");
      let userId = loginData.user.trim();
      if (!userId.startsWith("@")) userId = `@${userId}`;
      if (!userId.includes(":")) userId = `${userId}:${serverName}`;

      // Try to reuse saved session first — avoids new device creation
      const savedSession = localStorage.getItem(`nexus_session_${userId}`);
      if (savedSession) {
        try {
          const session = JSON.parse(savedSession);
          // Verify token is still valid
          const whoamiController = new AbortController();
          const whoamiTimeout = setTimeout(() => whoamiController.abort(), 8000);
          let check;
          try {
            check = await fetch(`${baseUrl}/_matrix/client/v3/account/whoami`, {
              headers: { "Authorization": `Bearer ${session.accessToken}` },
              signal: whoamiController.signal
            });
          } finally {
            clearTimeout(whoamiTimeout);
          }
          if (check.ok) {
            console.log("E2EE: reusing saved session, device:", session.deviceId);
            session.lastSeen = Date.now();
            session.pass = loginData.pass; // update password in case changed
            localStorage.setItem(`nexus_session_${userId}`, JSON.stringify(session));
            localStorage.setItem("nexus_last_user", userId);
            await startClient(session);
            return;
          }
        } catch(e) { /* token expired, fall through to fresh login */ }
      }

      // Fresh login — request same device_id if we have one saved
      const savedDeviceId = localStorage.getItem(`nexus_device_${userId}`);
      const tmp = sdk.createClient({ baseUrl });
      const res = await tmp.loginWithPassword(userId, loginData.pass, null, {
        initial_device_display_name: "NEXUS",
        ...(savedDeviceId ? { device_id: savedDeviceId } : {}),
      });

      localStorage.setItem(`nexus_device_${res.user_id}`, res.device_id);
      const session = {
        accessToken: res.access_token,
        userId: res.user_id,
        deviceId: res.device_id,
        baseUrl,
        pass: loginData.pass,
        lastSeen: Date.now(),
      };
      localStorage.setItem(`nexus_session_${res.user_id}`, JSON.stringify(session));
      localStorage.setItem("nexus_last_user", res.user_id);
      await startClient(session);
    } catch(e) {
      setLoginError(`AUTH_FAILED: ${e.message}`);
    } finally { setLoginLoading(false); }
  };

  const doLogout = useCallback(async (clearSession = false) => {
    const lastUser = myUserId;
    const cl = clientRef.current;
    if (cl?._nexusKeepAlive) clearInterval(cl._nexusKeepAlive);
    // Logout on server to remove device (prevents ghost sessions)
    if (clearSession && cl) {
      try {
        const tok = cl.getAccessToken();
        const base = cl.getHomeserverUrl();
        await fetch(`${base}/_matrix/client/v3/logout`, {
          method: "POST", headers: { "Authorization": `Bearer ${tok}`, "Content-Type": "application/json" }, body: "{}"
        });
      } catch(e) { console.warn("logout API:", e.message); }
    }
    cl?.stopClient(); clientRef.current = null;
    setClient(null); setMyUserId(""); setRooms([]); setMessages([]);
    setActiveRoomId(null); setShowSettings(false); setIsAdminUser(false); setUnread({});
    if (clearSession && lastUser) {
      localStorage.removeItem(`nexus_session_${lastUser}`);
      localStorage.removeItem("nexus_last_user");
      localStorage.removeItem(`nexus_device_${lastUser}`);
    }

  try {
    const plugin = window.Capacitor?.Plugins?.NexusSession;
    await plugin?.setActiveRoom?.({ roomId: '' });
    await plugin?.setForeground?.({ value: false });
  } catch (e) {
    console.warn('[NEXUS] Failed to reset native state:', e?.message || e);
  }

  try {
    const plugin = window.Capacitor?.Plugins?.NexusSession;
    await plugin?.clearSession?.();
    console.log('[NEXUS] Session cleared for push service');
  } catch (e) {
    console.warn('[NEXUS] clearSession failed:', e?.message || e);
  }

  }, [myUserId]);

  // ─── WebRTC Engine ────────────────────────────────────────────────────────
  const getTurnServers = useCallback(async () => {
    try {
      const res = await clientRef.current.getTurnServers();
      if (res?.length) {
        const servers = res.flatMap(s => {
          const uris = s.uris || s.urls || s.uri || s.url;
          const uriList = Array.isArray(uris) ? uris : (uris ? [uris] : []);
          return uriList.filter(Boolean).map(url => {
            const server = { urls: url };
            if (s.username) server.username = s.username;
            if (s.password || s.credential) server.credential = s.password || s.credential;
            return server;
          });
        }).filter(s => s.urls);
        if (servers.length) return servers;
      }
    } catch(e) { console.warn("TURN fetch failed:", e.message); }
    // Fallback: multiple STUN + free public TURN servers
    // These are last resort — best to configure coturn on Synapse
    return [
      { urls: "stun:stun.l.google.com:19302" },
      { urls: "stun:stun1.l.google.com:19302" },
      { urls: "stun:stun.cloudflare.com:3478" },
      {
        urls: [
          "turn:openrelay.metered.ca:80",
          "turn:openrelay.metered.ca:443",
          "turns:openrelay.metered.ca:443"
        ],
        username: "openrelayproject",
        credential: "openrelayproject"
      }
    ];
  }, []);

  const closePc = useCallback(() => {
    if (pcRef.current) { pcRef.current.close(); pcRef.current = null; }
  }, []);

  const hangupCall = useCallback(async (sendEvent = true) => {
    window.__nexusCallAnswered = false;
    window.__nexusPendingAnswerRoomId = null;
    if (sendEvent && callRoomRef.current && callIdRef.current) {
      try {
        await clientRef.current.sendEvent(callRoomRef.current, CALL_MSG.HANGUP, {
          call_id: callIdRef.current, version: 1, reason: "user_hangup"
        });
      } catch(e) {}
    }
    // Also clear MatrixRTC call.member state
    if (callRoomRef.current && clientRef.current) {
      sendCallMemberEvent(clientRef.current, callRoomRef.current, false).catch(()=>{});
    }
    closePc();
    const endedRoomId = callRoomRef.current;
    setActiveCall(prev => {
      if (prev?.localStream) prev.localStream.getTracks().forEach(t => t.stop());
      return null;
    });
    setIncomingCall(null);
    callRoomRef.current = null;
    callIdRef.current = null;
    // Clear lockscreen flags so phone locks normally again
    try { window.Capacitor?.Plugins?.NexusCallScreen?.clearLockscreen?.(); } catch(_) {}
    // Mark call ended for push notification suppression (prevents "Новое защищённое сообщение")
    if (endedRoomId && window.Capacitor?.isNativePlatform()) {
      try { window.Capacitor?.Plugins?.NexusSession?.notifyCallEnded?.({ roomId: endedRoomId }); } catch(_) {}
    }
  }, [closePc]);

  const startCall = useCallback(async (roomId, isVideo) => {
    const room = clientRef.current?.getRoom(roomId);
    if (!room) return;

    const peer = room.getJoinedMembers().find(m => m.userId !== myUserId);
    const peerName = peer?.name || peer?.userId?.replace(/^@/,"").split(":")[0] || "?";
    const callId = `nexus_${Date.now()}_${Math.random().toString(36).slice(2,8)}`;
    callRoomRef.current = roomId;
    callIdRef.current = callId;

    try {
      const iceServers = await getTurnServers();
      const pc = new RTCPeerConnection({ iceServers });
      pcRef.current = pc;

      let stream;
      let hasVideoTrack = false;
      try {
        console.log("📞 Requesting media: audio=true video=" + isVideo);
        const videoConstraints = isVideo ? { facingMode: "user", width: { ideal: 640 }, height: { ideal: 480 } } : false;
        stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }, video: videoConstraints });
        hasVideoTrack = stream.getVideoTracks().length > 0;
        console.log("📞 Got tracks:", stream.getTracks().map(t => t.kind + "/" + t.readyState).join(", "));
      } catch(e) {
        console.warn("📞 getUserMedia failed:", e.name, "— audio only");
        stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true }, video: false });
        hasVideoTrack = false;
      }
      // Add tracks — always sendrecv
      stream.getAudioTracks().forEach(t => { t.enabled = true; pc.addTrack(t, stream); });
      if (hasVideoTrack) {
        stream.getVideoTracks().forEach(t => { t.enabled = true; pc.addTrack(t, stream); });
      } else if (isVideo) {
        console.log("📞 No local camera, remote video will arrive via ontrack");
      }

      // Use a single persistent MediaStream — accumulates all tracks (audio + video)
      const remoteStream = new MediaStream();
      pc.ontrack = (e) => {
        console.log("📞 Remote track received:", e.track.kind, e.track.readyState);
        if (!remoteStream.getTracks().find(t => t.id === e.track.id)) remoteStream.addTrack(e.track);
        e.track.onunmute = () => {
          console.log("📞 Remote track unmuted:", e.track.kind);
          setActiveCall(prev => prev ? { ...prev, remoteStream: new MediaStream(remoteStream.getTracks()), isConnected: true } : prev);
        };
        // Force React re-render with fresh MediaStream snapshot so useEffect always fires
        setActiveCall(prev => {
          if (!prev) return prev;
          return { ...prev, remoteStream: new MediaStream(remoteStream.getTracks()), isConnected: true };
        });
      };
      pc.onconnectionstatechange = () => {
        const s = pc.connectionState;
        console.log("📞 Connection state:", s);
        if (s === "connected") setActiveCall(prev => prev ? { ...prev, isConnected: true } : prev);
        if (s === "failed" || s === "disconnected" || s === "closed") hangupCall(false);
      };

      // Batched ICE — avoids 429 rate limits from Matrix
      const iceBatch = []; let iceTimer = null;
      const flushIce = async () => {
        if (!iceBatch.length) return;
        const toSend = iceBatch.splice(0);
        try {
          await clientRef.current.sendEvent(roomId, CALL_MSG.CANDIDATES, { call_id: callId, version: 1, candidates: toSend });
          console.log("📞 Sent", toSend.length, "ICE candidates");
        } catch(err) { console.warn("📞 ICE batch failed:", err.message); }
      };
      pc.onicecandidate = (e) => {
        if (!e.candidate) { if (iceTimer) { clearTimeout(iceTimer); flushIce(); } return; }
        iceBatch.push({ sdpMid: e.candidate.sdpMid, sdpMLineIndex: e.candidate.sdpMLineIndex, candidate: e.candidate.candidate });
        if (iceTimer) clearTimeout(iceTimer);
        iceTimer = setTimeout(flushIce, 200);
      };
      pc.onicegatheringstatechange = () => {
        console.log("📞 ICE gathering:", pc.iceGatheringState);
        if (pc.iceGatheringState === "complete") { if (iceTimer) clearTimeout(iceTimer); flushIce(); }
      };

      const offer = await pc.createOffer({ offerToReceiveAudio: true, offerToReceiveVideo: isVideo });
      await pc.setLocalDescription(offer);

      await clientRef.current.sendEvent(roomId, CALL_MSG.INVITE, {
        call_id: callId, version: 1, lifetime: 60000,
        offer: { type: offer.type, sdp: offer.sdp }
      });

      // Send m.call.notify UNENCRYPTED so FCM/Sygnal can see type=m.call.notify
      // This enables system call notification on receiver's locked phone
      try {
        const hs = clientRef.current.getHomeserverUrl();
        const tok = clientRef.current.getAccessToken();
        const txnId = 'notify_' + Date.now();
        const members = clientRef.current.getRoom(roomId)?.getJoinedMembers()
          ?.filter(m => m.userId !== myUserId).map(m => m.userId) || [];
        await fetch(`${hs}/_matrix/client/v3/rooms/${encodeURIComponent(roomId)}/send/m.call.notify/${txnId}`, {
          method: 'PUT',
          headers: { 'Authorization': `Bearer ${tok}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            application: 'm.call', call_id: callId,
            'm.mentions': { user_ids: members }, notify_type: 'ring'
          })
        });
        console.log('📞 Sent unencrypted m.call.notify for FCM');
      } catch(e) { console.warn('📞 call.notify failed:', e.message); }

      setActiveCall({ peerName, peerId: peer?.userId || null, isVideo, isConnected: false, isCaller: true, localStream: stream, remoteStream: null });
    } catch(e) {
      console.error("Call start failed:", e);
      hangupCall(false);
    }
  }, [myUserId, getTurnServers, hangupCall]);

  const answerCall = useCallback(async (info, withVideo) => {
    setIncomingCall(null);
    const { roomId, callId, offer, peerName, peerId, isVideo: offerVideo } = info;
    const isVideo = withVideo && offerVideo;
    callRoomRef.current = roomId;
    callIdRef.current = callId;

    try {
      const iceServers = await getTurnServers();
      const pc = new RTCPeerConnection({ iceServers });
      pcRef.current = pc;

      let stream;
      let hasVideoTrack = false;
      try {
        console.log("📞 Requesting media: audio=true video=" + isVideo);
        const videoConstraints = isVideo ? { facingMode: "user", width: { ideal: 640 }, height: { ideal: 480 } } : false;
        stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }, video: videoConstraints });
        hasVideoTrack = stream.getVideoTracks().length > 0;
        console.log("📞 Got tracks:", stream.getTracks().map(t => t.kind + "/" + t.readyState).join(", "));
      } catch(e) {
        console.warn("📞 getUserMedia failed:", e.name, "— audio only");
        stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true }, video: false });
        hasVideoTrack = false;
      }
      // Add tracks — always sendrecv
      stream.getAudioTracks().forEach(t => { t.enabled = true; pc.addTrack(t, stream); });
      if (hasVideoTrack) {
        stream.getVideoTracks().forEach(t => { t.enabled = true; pc.addTrack(t, stream); });
        console.log("📞 Sending video track");
      } else if (isVideo) {
        console.log("📞 No camera — will receive video only");
      }

      // Persistent stream — KEY: setActiveCall BEFORE setRemoteDescription
      // so ontrack (fires during setRemoteDescription) finds prev !== null
      const remoteStream = new MediaStream();
      setActiveCall({ peerName, peerId: peerId || null, isVideo, isConnected: false, isCaller: false, localStream: stream, remoteStream });

      pc.ontrack = (e) => {
        console.log("📞 Remote track received:", e.track.kind, e.track.readyState);
        if (!remoteStream.getTracks().find(t => t.id === e.track.id)) remoteStream.addTrack(e.track);
        e.track.onunmute = () => {
          setActiveCall(prev => prev ? { ...prev, remoteStream: new MediaStream(remoteStream.getTracks()), isConnected: true } : prev);
        };
        setActiveCall(prev => prev ? { ...prev, remoteStream: new MediaStream(remoteStream.getTracks()), isConnected: true } : prev);
      };
      pc.onconnectionstatechange = () => {
        const s = pc.connectionState;
        console.log("📞 Connection state:", s);
        if (s === "connected") setActiveCall(prev => prev ? { ...prev, isConnected: true } : prev);
        if (s === "failed" || s === "disconnected" || s === "closed") hangupCall(false);
      };

      // Batched ICE — avoids 429
      const iceBatch = []; let iceTimer = null;
      const flushIce = async () => {
        if (!iceBatch.length) return;
        const toSend = iceBatch.splice(0);
        try {
          await clientRef.current.sendEvent(roomId, CALL_MSG.CANDIDATES, { call_id: callId, version: 1, candidates: toSend });
          console.log("📞 Sent", toSend.length, "ICE candidates");
        } catch(err) { console.warn("📞 ICE batch failed:", err.message); }
      };
      pc.onicecandidate = (e) => {
        if (!e.candidate) { if (iceTimer) { clearTimeout(iceTimer); flushIce(); } return; }
        iceBatch.push({ sdpMid: e.candidate.sdpMid, sdpMLineIndex: e.candidate.sdpMLineIndex, candidate: e.candidate.candidate });
        if (iceTimer) clearTimeout(iceTimer);
        iceTimer = setTimeout(flushIce, 200);
      };
      pc.onicegatheringstatechange = () => {
        console.log("📞 ICE gathering:", pc.iceGatheringState);
        if (pc.iceGatheringState === "complete") { if (iceTimer) clearTimeout(iceTimer); flushIce(); }
      };

      await pc.setRemoteDescription(new RTCSessionDescription(offer));

      if (!hasVideoTrack) {
        pc.getTransceivers().forEach(tc => {
          if (tc.sender?.track === null && tc.receiver?.track?.kind === "video") {
            tc.direction = "recvonly";
          }
        });
      }

      const answer = await pc.createAnswer();
      await pc.setLocalDescription(answer);

      await clientRef.current.sendEvent(roomId, CALL_MSG.ANSWER, {
        call_id: callId, version: 1,
        answer: { type: answer.type, sdp: answer.sdp }
      });
    } catch(e) {
      console.error("Call answer failed:", e);
      hangupCall(false);
    }
  }, [getTurnServers, hangupCall]);

  // Handle incoming call Matrix events
  const handleCallEventRef = useRef(null);
  handleCallEventRef.current = useCallback((event) => {
    const type = event.getType();
    const content = event.getContent();
    const sender = event.getSender();
    if (!sender || sender === myUserId) return;

    // Ignore events older than 60 seconds — prevents history replay on reconnect
    const eventAge = Date.now() - (event.getTs?.() || 0);
    if (eventAge > 60000) return;

    const roomId = event.getRoomId();
    const room = clientRef.current?.getRoom(roomId);
    const peerName = room?.getMember(sender)?.name || sender.replace(/^@/,"").split(":")[0];

    if (type === CALL_MSG.INVITE) {
      // Skip if this call was already hung up (stale replay during sync)
      if (hangupCallIdsRef.current.has(content.call_id)) {
        console.log('📞 Skipping stale invite (already hung up):', content.call_id);
        return;
      }
      // Skip if call was declined from lock screen before JS loaded (cold start)
      if (window.__nexusPendingDeclineTs && (event.getTs?.() || 0) < window.__nexusPendingDeclineTs + 5000) {
        console.log('[NEXUS] Pending decline — auto-rejecting call', content.call_id);
        clientRef.current?.sendEvent(roomId, CALL_MSG.HANGUP, { call_id: content.call_id, version: 1, reason: 'user_hangup' }).catch(()=>{});
        try { window.Capacitor?.Plugins?.NexusSession?.notifyCallEnded?.({ roomId }); } catch(_) {}
        return;
      }
      // P2P invite always takes priority over matrixRTC — replace if needed
      const isVideo = !!(content.offer?.sdp?.includes("m=video"));
      // On Android: show system call notification via native plugin
      if (window.Capacitor?.isNativePlatform()) {
        try {
          const plugin = window.Capacitor?.Plugins?.NexusCallScreen;
          if (plugin?.showIncomingCall) {
            plugin.showIncomingCall({ callerName: peerName, roomId, isVideo });
          }
        } catch(e) { console.warn("[Call] Native notification failed:", e); }
      }
      setIncomingCall(prev => {
        if (prev && !prev.matrixRTC) return prev; // keep existing real P2P call
        const callInfo = { roomId, callId: content.call_id, peerName, peerId: sender, isVideo, offer: content.offer };
        // If user already tapped Answer from notification, auto-answer — only fresh invites (< 30s)
        const inviteAge = Date.now() - (event?.getTs?.() || 0);
        const expectedCallId = window.__nexusPendingAnswerCallId;
        const callIdMatch = !expectedCallId || expectedCallId === content.call_id;
        if (window.__nexusPendingAnswerRoomId && inviteAge < 30000 && callIdMatch &&
            (window.__nexusPendingAnswerRoomId === roomId || window.__nexusPendingAnswerRoomId === '__any__')) {
          console.log('[NEXUS] Auto-answering invite callId=' + content.call_id);
          window.__nexusPendingAnswerRoomId = null;
          window.__nexusPendingAnswerCallId = null;
          window.__nexusCallAnswered = true;
          setTimeout(() => answerCall(callInfo, isVideo), 100);
          return null; // don't show UI
        }
        // If user tapped Decline — reject fresh invites (flag stays alive for 15s)
        if (window.__nexusPendingDeclineTs && (event.getTs?.() || 0) < window.__nexusPendingDeclineTs + 5000) {
          clientRef.current?.sendEvent(roomId, CALL_MSG.HANGUP, { call_id: content.call_id, version: 1, reason: 'user_hangup' }).catch(()=>{});
          return null; // ignore this call
        }
        return callInfo;
      });
    } else if (type === CALL_MSG.ANSWER && pcRef.current && content.call_id === callIdRef.current) {
      console.log("📞 Received answer, setting remote description");
      pcRef.current.setRemoteDescription(new RTCSessionDescription(content.answer))
        .then(() => console.log("📞 Remote description set OK"))
        .catch(e => console.error("📞 setRemoteDescription failed:", e));
    } else if (type === CALL_MSG.CANDIDATES && content.call_id === callIdRef.current) {
      console.log("📞 Received", (content.candidates||[]).length, "ICE candidates from", sender);
      const tryAdd = async () => {
        const pc = pcRef.current;
        if (!pc) return;
        // Wait until remoteDescription is set (poll up to 10s)
        let waited = 0;
        while (!pc.remoteDescription && waited < 10000) {
          await new Promise(r => setTimeout(r, 100));
          waited += 100;
        }
        (content.candidates || []).forEach(c => {
          pc.addIceCandidate(new RTCIceCandidate(c)).catch(e => {
            console.warn("📞 addIceCandidate failed:", e.message);
          });
        });
      };
      tryAdd();
    } else if (type === CALL_MSG.MUTE && content.call_id === callIdRef.current) {
      setPeerMuted({ audio: !!content.audio, video: !!content.video });
    } else if (type === CALL_MSG.HANGUP) {
      // Record this callId as dead so we never show it as incoming
      if (content.call_id) hangupCallIdsRef.current.add(content.call_id);
      if (content.call_id === callIdRef.current || !callIdRef.current) {
        hangupCall(false);
      }
      setIncomingCall(prev => prev?.callId === content.call_id ? null : prev);
      // Clear pending answer if this hangup is for the call we were trying to answer
      if (window.__nexusPendingAnswerCallId === content.call_id) {
        window.__nexusPendingAnswerCallId = null;
        window.__nexusPendingAnswerRoomId = null;
      }
      // Dismiss native call notification if on Android
      if (window.Capacitor?.isNativePlatform()) {
        try { window.Capacitor?.Plugins?.NexusCallScreen?.endCall?.(); } catch(_) {}
        try { window.Capacitor?.Plugins?.NexusCallScreen?.clearLockscreen?.(); } catch(_) {}
        try { window.Capacitor?.Plugins?.NexusSession?.notifyCallEnded?.({ roomId }); } catch(_) {}
      }
    } else if (type === CALL_MSG.GROUP_CALL) {
      if (content.status === "started") {
        setIncomingGroupCall({ roomId, roomName: content.roomName, peerName, video: content.video });
      } else if (content.status === "ended") {
        setIncomingGroupCall(null);
      }
    } else if (type === MATRIXRTC_MEMBER) {
      // MatrixRTC call member event (Element X compatible)
      if (content.application === "m.call" && content.device_id) {
        // Someone joined a MatrixRTC call — show as incoming if DM
        // But skip if we already have an active P2P call (we sent MatrixRTC signals alongside P2P)
        if (callIdRef.current || pcRef.current) {
          console.log("[MatrixRTC] Ignoring call.member — active P2P call exists");
          return;
        }
        const rm = clientRef.current?.getRoom(roomId);
        if (rm && isDM(rm)) {
          // Delay 3s to let P2P m.call.invite arrive first (NEXUS-to-NEXUS calls send both)
          // If P2P invite arrives in this window, it takes priority via the INVITE handler
          console.log("[MatrixRTC] Incoming call.member from", sender, "— waiting 3s for P2P invite...");
          setTimeout(() => {
            setIncomingCall(prev => {
              // Only set matrixRTC incoming if no P2P call was established in the meantime
              if (prev) return prev;
              if (callIdRef.current || pcRef.current) return prev;
              console.log("[MatrixRTC] No P2P invite received — showing MatrixRTC incoming call");
              const matrixRTCCall = { roomId, callId: "matrixrtc_" + Date.now(), peerName, peerId: sender, isVideo: true, matrixRTC: true };
              // Auto-answer check happens outside via useEffect on incomingCall state
              return matrixRTCCall;
            });
          }, 3000);
        }
      } else if (!content.application && !content.device_id) {
        // Empty content = peer left the call
        setIncomingCall(prev => {
          if (prev?.matrixRTC && prev?.peerId === sender) return null;
          return prev;
        });
      }
    }
  }, [myUserId, hangupCall]);

  // Register call event listener once per client session
  useEffect(() => {
    const cl = clientRef.current;
    if (!cl) return;
    const listener = (event) => {
      const t = event.getType();
      if (Object.values(CALL_MSG).includes(t) || t === CALL_MSG.GROUP_CALL || t === MATRIXRTC_MEMBER || t === "m.call.notify") {
        console.log("📞 Call event:", t, event.getContent()?.call_id, "from", event.getSender());
        handleCallEventRef.current?.(event);
      }
    };
    // Listen on both — unencrypted rooms use Room.timeline, encrypted use Event.decrypted
    cl.on("Room.timeline", listener);
    cl.on("Event.decrypted", listener);
    return () => { cl.off("Room.timeline", listener); cl.off("Event.decrypted", listener); };
  }, [client]);

  // Register FCM pusher with Synapse
  useEffect(() => {
    if (!client || !window.Capacitor?.isNativePlatform()) return;
    const handleToken = async (e) => {
      const token = e?.detail || window.__fcmToken;
      if (!token || !clientRef.current) return;
      try {
        await clientRef.current.setPusher({
          pushkey: token,
          kind: 'http',
          app_id: 'org.hipogas.nexus',
          app_display_name: 'NEXUS',
          device_display_name: 'Android',
          lang: 'ru',
          data: {
            url: 'http://sygnal:5000/_matrix/push/v1/notify',

          },
          profile_tag: 'nexus_android',
          append: false,
        });
        console.log('[NEXUS] Pusher registered with Synapse');
      } catch(e) {
        console.error('[NEXUS] Pusher registration failed:', e);
      }
    };
    window.addEventListener('nexus-fcm-token', handleToken);
    if (window.__fcmToken) handleToken();
    return () => window.removeEventListener('nexus-fcm-token', handleToken);
  }, [client]);

// Handle push notification tap — open specific room
  useEffect(() => {
    if (!client) return;

    const openRoomWhenReady = (roomId) => {
      if (!roomId) return;
      console.log('[NEXUS] Opening room from push:', roomId);
      if (clientRef.current?.getRoom(roomId)) {
        selectRoomRef.current?.(roomId);
      } else {
        // Room not loaded yet - wait for sync then navigate
        const retry = () => {
          if (clientRef.current?.getRoom(roomId)) {
            selectRoomRef.current?.(roomId);
          }
          clientRef.current?.off('sync', retry);
        };
        clientRef.current?.on('sync', retry);
        setTimeout(() => clientRef.current?.off('sync', retry), 10000);
      }
    };

    const handleOpenRoom = (e) => {
      try {
        const data = typeof e.detail === 'string' ? JSON.parse(e.detail) : e.detail;
        const roomId = data?.roomId;
        if (roomId) openRoomWhenReady(roomId);
      } catch(err) { console.warn('[NEXUS] handleOpenRoom error:', err); }
    };

    // Also update global handler ref so early events are caught
    window.__nexusOpenRoomHandler = handleOpenRoom;
    window.addEventListener('nexusOpenRoomFromPush', handleOpenRoom);

    // Cold start: read pending room from native SharedPreferences
    if (window.Capacitor?.isNativePlatform()) {
      (async () => {
        try {
          const { registerPlugin } = await import('@capacitor/core');
          const NexusSession = registerPlugin('NexusSession');
          const result = await NexusSession.getPendingOpenRoom();
          if (result?.roomId) {
            console.log('[NEXUS] Cold start pending room:', result.roomId);
            // Store in ref — will be applied after PREPARED sync
            pendingPushRoomRef.current = result.roomId;
            // If client is already synced, navigate immediately
            if (clientRef.current?.isInitialSyncComplete()) {
              pendingPushRoomRef.current = null;
              openRoomWhenReady(result.roomId);
            }
          }
        } catch (e) { console.warn('[NEXUS] getPendingOpenRoom failed:', e); }
      })();
    }

    if (window.__pendingRoomId) {
      const rid = window.__pendingRoomId;
      window.__pendingRoomId = null;
      openRoomWhenReady(rid);
    }

    return () => {
      window.removeEventListener('nexusOpenRoomFromPush', handleOpenRoom);
      if (window.__nexusOpenRoomHandler === handleOpenRoom) {
        window.__nexusOpenRoomHandler = null;
      }
    };
  }, [client]);

// Save Matrix session for native Android push service
useEffect(() => {
  if (!client || !window.Capacitor?.isNativePlatform()) return;

  let cancelled = false;

  const saveNativeSession = async () => {
    try {
      const { registerPlugin } = await import('@capacitor/core');
      const NexusSession = registerPlugin('NexusSession');

      const homeserver =
        client.getHomeserverUrl?.() ||
        client.baseUrl ||
        '';

      const accessToken =
        client.getAccessToken?.() ||
        client.credentials?.accessToken ||
        '';

      const userId =
        client.getUserId?.() ||
        client.credentials?.userId ||
        '';

      const deviceId =
        client.getDeviceId?.() ||
        client.credentials?.deviceId ||
        '';

      if (!homeserver || !accessToken || !userId) {
        console.warn('[NEXUS] saveSession skipped: incomplete session', {
          homeserver,
          userId,
          hasAccessToken: !!accessToken,
          deviceId,
        });
        return;
      }

      if (cancelled) return;

      await NexusSession.saveSession({
        homeserver,
        accessToken,
        userId,
        deviceId: deviceId || '',
      });

      console.log('[NEXUS] Session saved for push service', {
        homeserver,
        userId,
        deviceId,
      });
    } catch (e) {
      console.warn('[NEXUS] saveSession failed:', e);
    }
  };

  saveNativeSession();

  return () => {
    cancelled = true;
  };
}, [client]);

// Tell native layer whether app is in foreground
useEffect(() => {
  if (!window.Capacitor?.isNativePlatform()) return;

  let disposed = false;

  const applyForeground = async (value) => {
    try {
      const plugin = window.Capacitor?.Plugins?.NexusSession;
      if (plugin?.setForeground) {
        await plugin.setForeground({ value });
        console.log('[NEXUS] setForeground =', value);
      }
      // On resume: check for pending push room
      if (value && window.__pendingRoomId) {
        const rid = window.__pendingRoomId;
        window.__pendingRoomId = null;
        console.log('[NEXUS] Resume pending room:', rid);
        setTimeout(() => selectRoomRef.current?.(rid), 100);
      }
    } catch (e) {
      if (!disposed) console.warn('[NEXUS] setForeground failed', e);
    }
  };

  applyForeground(true);

  const onVisibilityChange = () => {
    applyForeground(document.visibilityState === 'visible');
  };

  const onFocus = () => applyForeground(true);
  const onBlur = () => applyForeground(false);

  document.addEventListener('visibilitychange', onVisibilityChange);
  window.addEventListener('focus', onFocus);
  window.addEventListener('blur', onBlur);

  return () => {
    disposed = true;
    document.removeEventListener('visibilitychange', onVisibilityChange);
    window.removeEventListener('focus', onFocus);
    window.removeEventListener('blur', onBlur);
    applyForeground(false);
  };
}, []);

// Tell native layer which room is currently open
useEffect(() => {
  if (!window.Capacitor?.isNativePlatform()) return;

  const plugin = window.Capacitor?.Plugins?.NexusSession;
  if (!plugin?.setActiveRoom) return;

  const roomId = activeRoomId || null;

  plugin.setActiveRoom({ roomId: roomId || '' })
    .then(() => {
      console.log('[NEXUS] setActiveRoom =', roomId);
    })
    .catch((e) => {
      console.warn('[NEXUS] setActiveRoom failed', e);
    });
}, [activeRoomId]);


  const loadMoreHistory = useCallback(async () => {
    const c = clientRef.current; if (!c || !activeRoomId) return;
    if (histLoadingRef.current) return;
    const room = c.getRoom(activeRoomId); if (!room) return;
    const timeline = room.getLiveTimeline();
    if (!timeline.getPaginationToken("b")) return; // no more history
    histLoadingRef.current = true;
    // Save scroll position before loading
    const container = msgsRef.current;
    const prevScrollHeight = container?.scrollHeight || 0;
    try {
      await c.paginateEventTimeline(timeline, { backwards: true, limit: 50 });
      // Rebuild messages after pagination
      await loadMessages(activeRoomId);
      // Restore scroll position so user stays at same place
      if (container) {
        const newScrollHeight = container.scrollHeight;
        container.scrollTop = newScrollHeight - prevScrollHeight;
      }
    } catch(e) { console.error(e); }
    finally { histLoadingRef.current = false; }
  }, [activeRoomId, loadMessages]);

  const selectRoomRef = useRef(null);
  const selectRoom = useCallback((roomId) => {
    setActiveRoomId(roomId);
    setActiveView("chat");
    setUnread(p => ({ ...p, [roomId]: 0 }));
    setMobileRoomsOpen(false); // close rooms panel on mobile
    setMobileView("chat");    // switch to chat view on mobile
    const _r = clientRef.current?.getRoom(roomId);
    setRoomTopic(_r?.currentState?.getStateEvents?.("m.room.topic","")?.getContent?.()?.topic || "");
    // Send read receipt to server
    const roomObj = clientRef.current?.getRoom(roomId);
    if (roomObj) {
      const lastEv = roomObj.getLiveTimeline().getEvents().slice(-1)[0];
      if (lastEv) clientRef.current.sendReadReceipt(lastEv).catch(() => {});
    }
    setShowSettings(false); setShowRoomSettings(false);
    shouldScrollRef.current = true;
    loadMessages(roomId);
  }, [loadMessages]);
  selectRoomRef.current = selectRoom;
  // Keep incomingCallRef in sync with state
  incomingCallRef.current = incomingCall;
  if (incomingCall) window.__lastIncomingCallInfo = { roomId: incomingCall.roomId, callId: incomingCall.callId };

  // Auto-answer MatrixRTC incoming call if user tapped Answer from notification
  useEffect(() => {
    if (!incomingCall?.matrixRTC) return;
    if (!window.__nexusPendingAnswerRoomId) return;
    window.__nexusPendingAnswerRoomId = null;
    const call = incomingCall;
    setIncomingCall(null);
    getMatrixRTCToken(clientRef.current, call.roomId).then(({ url, jwt }) => {
      sendCallMemberEvent(clientRef.current, call.roomId, true).catch(() => {});
      const rm = clientRef.current?.getRoom(call.roomId);
      const rName = rm ? getRoomName(rm, myUserId) : call.peerName;
      setJitsiCall({ roomId: call.roomId, roomName: rName, video: true, lkToken: jwt, lkUrl: url, matrixRTC: true });
    }).catch(e => console.error('[MatrixRTC] Auto-answer failed:', e));
  }, [incomingCall, myUserId]);

  // Expose globally for direct Kotlin→JS navigation
  window.__nexusSelectRoom = (roomId) => {
    console.log('[NEXUS] __nexusSelectRoom called:', roomId);
    selectRoom(roomId);
  };
  // Expose answer/decline for system call notification buttons
  window.__nexusAnswerIncomingCall = (withVideo = true) => {
    console.log('[NEXUS] __nexusAnswerIncomingCall called, incomingCall:', incomingCallRef.current?.callId, 'expectedCallId:', window.__nexusPendingAnswerCallId);
    try { window.Capacitor?.Plugins?.NexusCallScreen?.endCall?.(); } catch(_) {}
    // If the expected call was already hung up, stop retrying
    const expected = window.__nexusPendingAnswerCallId;
    if (expected && hangupCallIdsRef.current.has(expected)) {
      console.log('[NEXUS] Answer cancelled — call already hung up:', expected);
      window.__nexusPendingAnswerCallId = null;
      window.__nexusPendingAnswerRoomId = null;
      return;
    }
    if (incomingCallRef.current) {
      // If we have an expected callId from push, only answer if it matches
      const expectedCallId = window.__nexusPendingAnswerCallId;
      if (expectedCallId && incomingCallRef.current.callId !== expectedCallId) {
        console.log('[NEXUS] Answer skipped — callId mismatch:', incomingCallRef.current.callId, '!==', expectedCallId);
        return; // don't consume — retry will fire again when the right invite arrives
      }
      const call = incomingCallRef.current;
      setIncomingCall(null);
      window.__nexusPendingAnswerRoomId = null;
      window.__nexusPendingAnswerCallId = null;
      if (call.matrixRTC) {
        getMatrixRTCToken(clientRef.current, call.roomId).then(({ url, jwt }) => {
          sendCallMemberEvent(clientRef.current, call.roomId, true).catch(() => {});
          const rm = clientRef.current?.getRoom(call.roomId);
          const rName = rm ? getRoomName(rm, myUserId) : call.peerName;
          setJitsiCall({ roomId: call.roomId, roomName: rName, video: withVideo, lkToken: jwt, lkUrl: url, matrixRTC: true });
        }).catch(e => console.error('[MatrixRTC] Answer failed:', e));
      } else {
        answerCall(call, call.isVideo ?? withVideo);
      }
    }
    // If no incomingCall, do nothing — Kotlin answerJs handles setting __nexusPendingAnswerRoomId
  };
  window.__nexusDeclineIncomingCall = () => {
    console.log('[NEXUS] __nexusDeclineIncomingCall called');
    window.__nexusPendingAnswerRoomId = null;
    window.__nexusPendingAnswerCallId = null; // stop stale answer retries
    try { window.Capacitor?.Plugins?.NexusCallScreen?.endCall?.(); } catch(_) {}
    try { window.Capacitor?.Plugins?.NexusCallScreen?.clearLockscreen?.(); } catch(_) {}
    const call = incomingCallRef.current || window.__lastIncomingCallInfo;
    if (call?.roomId && call?.callId) {
      setIncomingCall(null);
      console.log('[NEXUS] Decline: sending hangup for callId=' + call.callId);
      clientRef.current?.sendEvent(call.roomId, 'm.call.hangup', { call_id: call.callId, version: 1, reason: 'user_hangup' }).catch(e => console.warn('[NEXUS] hangup sendEvent failed:', e));
      try { window.Capacitor?.Plugins?.NexusSession?.notifyCallEnded?.({ roomId: call.roomId }); } catch(_) {}
      window.__lastIncomingCallInfo = null;
    } else {
      console.warn('[NEXUS] Decline: no call info available (native hangup should handle it)');
    }
    window.__nexusPendingDeclineTs = Date.now();
    
  };

  // ── Terminal commands ─────────────────────────────────────────
  const COMMANDS = [
    { cmd: "/poll",     args: "Вопрос? | A | B", desc: "Создать голосование" },
    { cmd: "/whois",    args: "@user",   desc: "Info o polzovatele" },
    { cmd: "/roomstat", args: "",        desc: "Statistika komnaty" },
    { cmd: "/ping",     args: "",        desc: "Ping servera" },
    { cmd: "/me",       args: "<text>",  desc: "Deystvie ot svoego lica" },
    { cmd: "/help",     args: "",        desc: "Spisok komand" },
    { cmd: "/clear",    args: "",        desc: "Ochistit chat lokalno" },
    { cmd: "/members",  args: "",        desc: "Spisok uchastnikov" },
    { cmd: "/topic",    args: "",        desc: "Pokazat temu komnaty" },
  ];

  const addSystemMsg = (text) => {
    const sysMsg = {
      id: "sys_" + Date.now(),
      sender: "SYSTEM",
      senderName: "NEXUS",
      body: text,
      msgtype: "m.system",
      ts: Date.now(),
      own: false,
      reactions: {},
      replyTo: null,
      redacted: false,
      system: true,
    };
    setMessages(prev => [...prev, sysMsg]);
    setTimeout(() => endRef.current?.scrollIntoView({ behavior: "smooth" }), 50);
  };

  const executeCommand = async (text) => {
    const parts = text.trim().split(/\s+/);
    const cmd = parts[0].toLowerCase();
    const arg = parts.slice(1).join(" ");
    const c = clientRef.current;
    const room = c?.getRoom(activeRoomId);

    if (cmd === "/poll") {
      if (!arg || !arg.includes("|")) {
        addSystemMsg("// USAGE: /poll Question? | Option 1 | Option 2 | Option 3");
        return true;
      }
      const parts2 = arg.split("|").map(s => s.trim()).filter(Boolean);
      const question = parts2[0];
      const optTexts = parts2.slice(1);
      if (optTexts.length < 2) { addSystemMsg("// POLL: need at least 2 options"); return true; }
      // Use letter emojis as unique vote keys
      const letters = ["🅐","🅑","🅒","🅓","🅔","🅕","🅖","🅗"];
      const options = optTexts.slice(0,8).map((t, i) => ({ text: t, emoji: letters[i] }));
      const body = "📊 " + question + "\n" + options.map(o => o.emoji + " " + o.text).join("\n");
      try {
        await c.sendEvent(activeRoomId, "m.room.message", {
          msgtype: "m.text", body,
          format: "m.poll",
          pollData: { question, options, anonymous: true, multiVote: false }
        });
      } catch(e) { addSystemMsg("// ERROR: " + e.message); }
      return true;
    }

    if (cmd === "/help") {
      const lines = COMMANDS.map(x => "  " + x.cmd.padEnd(12) + " " + x.args.padEnd(10) + " - " + x.desc).join("\n");
      addSystemMsg("// AVAILABLE COMMANDS:\n" + lines);
      return true;
    }

    if (cmd === "/ping") {
      const t0 = Date.now();
      try {
        await fetch(c.getHomeserverUrl() + "/_matrix/client/versions");
        const ms = Date.now() - t0;
        const quality = ms < 100 ? "[###] EXCELLENT" : ms < 300 ? "[##.] GOOD" : "[#..] SLOW";
        addSystemMsg("// PING " + c.getHomeserverUrl() + "\n  RESPONSE: " + ms + "ms  " + quality);
      } catch(e) {
        addSystemMsg("// PING FAILED: " + e.message);
      }
      return true;
    }

    if (cmd === "/me") {
      if (!arg) { addSystemMsg("// USAGE: /me <action>"); return true; }
      try {
        await c.sendEvent(activeRoomId, "m.room.message", { msgtype: "m.emote", body: arg });
      } catch(e) { addSystemMsg("// ERROR: " + e.message); }
      return true;
    }

    if (cmd === "/clear") {
      setMessages([]);
      addSystemMsg("// CHAT CLEARED LOCALLY. Re-enter room to restore.");
      return true;
    }

    if (cmd === "/topic") {
      const topic = room?.currentState?.getStateEvents?.("m.room.topic","")?.getContent?.()?.topic;
      addSystemMsg(topic ? "// TOPIC: " + topic : "// NO TOPIC SET");
      return true;
    }

    if (cmd === "/members") {
      const members = room?.getJoinedMembers() || [];
      const lines = members.map(m => "  " + (m.name || m.userId).slice(0,20).padEnd(20) + " " + m.userId).join("\n");
      addSystemMsg("// MEMBERS (" + members.length + "):\n" + lines);
      return true;
    }

    if (cmd === "/roomstat") {
      const memberCount = room?.getJoinedMembers()?.length || 0;
      const events = room?.getLiveTimeline()?.getEvents()?.length || 0;
      const name = room?.name || activeRoomId;
      const topic = room?.currentState?.getStateEvents?.("m.room.topic","")?.getContent?.()?.topic || "-";
      const enc = room?.currentState?.getStateEvents?.("m.room.encryption") ? "YES" : "NO";
      const firstEv = room?.getLiveTimeline()?.getEvents()?.[0];
      const createdStr = firstEv ? new Date(firstEv.getTs()).toLocaleDateString() : "-";
      addSystemMsg(
        "// ROOM STATS: " + name + "\n" +
        "  ID:          " + activeRoomId + "\n" +
        "  TOPIC:       " + topic + "\n" +
        "  MEMBERS:     " + memberCount + "\n" +
        "  EVENTS:      " + events + " (in memory)\n" +
        "  ENCRYPTION:  " + enc + "\n" +
        "  CREATED:     " + createdStr
      );
      return true;
    }

    if (cmd === "/whois") {
      const serverDomain = clientRef.current?.getDomain() || myUserId.split(":")[1] || "";
      let uid = arg.startsWith("@") ? arg : "@" + arg;
      if (!uid.includes(":")) uid = uid + ":" + serverDomain;
      const member = room?.getMember(uid);
      const user = c.getUser(uid);
      if (!member && !user) { addSystemMsg("// USER NOT FOUND: " + uid); return true; }
      const presence = user?.presence || "unknown";
      const lastActive = user?.lastActiveAgo ? Math.round(user.lastActiveAgo / 60000) + " min ago" : "-";
      const power = member?.powerLevel ?? "-";
      const joined = member?.events?.member?.getTs?.() ? new Date(member.events.member.getTs()).toLocaleDateString() : "-";
      addSystemMsg(
        "// WHOIS: " + uid + "\n" +
        "  NAME:        " + (member?.name || user?.displayName || uid) + "\n" +
        "  STATUS:      " + presence + "\n" +
        "  LAST SEEN:   " + lastActive + "\n" +
        "  POWER LEVEL: " + power + "\n" +
        "  JOINED:      " + joined
      );
      return true;
    }

    return false;
  };

    const sendMessage = async () => {
    if (!input.trim() || !activeRoomId || !clientRef.current) return;
    const text = input.trim(); setInput("");
    setCmdHints([]);
    if (text.startsWith("/") && text !== "/") {
      const handled = await executeCommand(text);
      if (handled) return;
    }
    try {
      if (editingMsg) {
        await clientRef.current.sendEvent(activeRoomId, "m.room.message", {
          msgtype: "m.text", body: `* ${text}`,
          "m.new_content": { msgtype: "m.text", body: text },
          "m.relates_to": { rel_type: "m.replace", event_id: editingMsg.id }
        });
        setEditingMsg(null);
      } else if (replyTo) {
        const cleanBody = (() => { const b = replyTo.body||""; if(b.includes("\n\n")) return b.split("\n\n").pop()?.trim()||b; return b.split("\n").filter(l=>!l.startsWith(">")&&l.trim()).join(" ").trim()||b; })();
        const replyBody = `> <${replyTo.sender}> ${cleanBody}

${text}`;
        await clientRef.current.sendEvent(activeRoomId, "m.room.message", {
          msgtype: "m.text", body: replyBody,
          "m.relates_to": { "m.in_reply_to": { event_id: replyTo.id } }
        });
        setReplyTo(null);
      } else {
        await clientRef.current.sendMessage(activeRoomId, { msgtype: "m.text", body: text });
      }
    } catch (e) { showNotif("SEND_ERROR", e.message); setInput(text); }
  };

  const createRoom = async ({ name, topic, priv, enc }) => {
    setModalLoading(true);
    try {
      const initial_state = enc ? [{ type: "m.room.encryption", state_key: "", content: { algorithm: "m.megolm.v1.aes-sha2" } }] : [];
      const res = await clientRef.current.createRoom({
        name, topic,
        visibility: priv ? "private" : "public",
        preset: priv ? "private_chat" : "public_chat",
        initial_state,
      });
      setModal(null); refreshRooms(); setTimeout(() => selectRoom(res.room_id), 800);
      showNotif("CHANNEL_CREATED", name);
    } catch (e) { showNotif("CREATE_ERROR", e.message); }
    finally { setModalLoading(false); }
  };

  const createDM = async (targetUserId) => {
    const cl = clientRef.current;
    if (!cl) return;

    // Find existing DM: the only reliable way is to find a room where
    // targetUser is the ONLY other person who was ever a member
    const findExistingDM = () => {
      // Method 1: m.direct account data
      try {
        const dmData = cl.getAccountData("m.direct")?.getContent() || {};
        const roomIds = dmData[targetUserId] || [];
        for (const roomId of [...roomIds].reverse()) {
          const r = cl.getRoom(roomId);
          if (r && r.getMyMembership?.() === "join") return r;
        }
      } catch(e) {}

      // Method 2: find room where targetUser is the ONLY other member (ever)
      try {
        const allRooms = cl.getRooms();
        const candidates = allRooms.filter(r => {
          try {
            if (r.getMyMembership?.() !== "join") return false;
            const allMems = r.getMembers?.() || r.getJoinedMembers();
            const others = allMems.filter(m => m.userId !== myUserId);
            // Only one other person ever, and it's our target
            return others.length >= 1 &&
                   others.every(m => m.userId === targetUserId);
          } catch(e) { return false; }
        });
        if (candidates.length > 0) {
          // Pick most recently active
          candidates.sort((a, b) =>
            (b.getLastActiveTimestamp?.() || 0) - (a.getLastActiveTimestamp?.() || 0)
          );
          return candidates[0];
        }
      } catch(e) {}

      return null;
    };

    const existing = findExistingDM();
    if (existing) {
      setModal(null);
      selectRoom(existing.roomId);
      return;
    }

    // Create new DM
    setModalLoading(true);
    try {
      const res = await cl.createRoom({
        invite: [targetUserId],
        preset: "trusted_private_chat",
        is_direct: true,
        initial_state: [{ type: "m.room.encryption", state_key: "", content: { algorithm: "m.megolm.v1.aes-sha2" } }],
      });
      // Register in m.direct so future lookups find it
      try {
        const dmData = cl.getAccountData("m.direct")?.getContent() || {};
        dmData[targetUserId] = [...(dmData[targetUserId] || []), res.room_id];
        await cl.setAccountData("m.direct", dmData);
      } catch(e) {}
      setModal(null); refreshRooms(); setTimeout(() => selectRoom(res.room_id), 800);
    } catch (e) { showNotif("DM_ERROR", e.message); }
    finally { setModalLoading(false); }
  };

  useEffect(() => {
    if (histLoadingRef.current) return;
    if (!shouldScrollRef.current) return;
    shouldScrollRef.current = false;
    const scrollNow = () => {
      const c = msgsRef.current;
      if (c) { c.scrollTop = c.scrollHeight; return; }
      endRef.current?.scrollIntoView({ behavior: "instant" });
    };
    scrollNow();
    setTimeout(scrollNow, 150);
  }, [messages]);

  const filtered = rooms.filter(r => getRoomName(r, myUserId).toLowerCase().includes(search.toLowerCase()));
  // Public = join_rule is "public" or room has public visibility
  const isPublicRoom = (r) => {
    const joinRule = r.currentState?.getStateEvents?.("m.room.join_rules","")?.getContent?.()?.join_rule;
    return !isDM(r) && (joinRule === "public" || joinRule === "knock");
  };
  const isPrivateRoom = (r) => !isDM(r) && !isPublicRoom(r);
  const publicRooms = filtered.filter(r => isPublicRoom(r));
  const privateRooms = filtered.filter(r => isPrivateRoom(r));
  const dms = filtered.filter(r => isDM(r));
  const activeRoom = client?.getRoom(activeRoomId);

  if (!booted) return <><style>{css}</style><MatrixRain /><BootScreen onDone={() => setBooted(true)} /></>;

  if (securitySetup && client) return (
    <><style>{css}</style>
      <SecuritySetupScreen
        client={client} userId={myUserId}
        passphrase={localStorage.getItem(`nexus_session_${myUserId}`) ? JSON.parse(localStorage.getItem(`nexus_session_${myUserId}`)).pass || "" : ""}
        lang={lang}
        onDone={() => setSecuritySetup(false)}
      />
    </>
  );

  if (!client) return loginLoading ? (
    <><style>{css}</style>
      <div style={{position:"fixed",inset:0,background:"var(--bg)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:16,zIndex:100}}>
        <div style={{fontFamily:"var(--disp)",fontSize:20,color:"var(--g)",letterSpacing:"0.2em",textShadow:"0 0 20px var(--g)"}}>NEXUS<span className="blink">_</span></div>
        <div style={{fontSize:11,color:"var(--gd)",fontFamily:"var(--mono)",letterSpacing:"0.15em"}}>RESTORING SESSION<span className="blink">_</span></div>
      </div>
    </>
  ) : (
    <><style>{css}</style><LoginRain />
      {notif && <div className="notif"><div className="notif-tag">[ERR]</div><div><div className="notif-title">{notif.title}</div><div className="notif-text">{notif.text}</div></div></div>}
      <div className="login crt">
        <LoginRain />
        <div className="login-card" style={{position:"relative",zIndex:2}}>
          <div className="login-logo">NEXUS<span className="blink">_</span></div>
          <div className="login-sub">SECURE MATRIX CLIENT // E2EE // <span>v0.2.0</span></div>
          <div className="lf"><div className="lf-label">HOMESERVER</div><input className="lf-input" value={loginData.server} onChange={e => setLoginData(p => ({ ...p, server: e.target.value }))} /></div>
          <div className="lf"><div className="lf-label">USERNAME</div><input className="lf-input" value={loginData.user} onChange={e => setLoginData(p => ({ ...p, user: e.target.value }))} placeholder="admin" onKeyDown={e => e.key === "Enter" && doLogin()} /></div>
          <div className="lf"><div className="lf-label">PASSPHRASE</div><input className="lf-input" type="password" value={loginData.pass} onChange={e => setLoginData(p => ({ ...p, pass: e.target.value }))} placeholder="••••••••" onKeyDown={e => e.key === "Enter" && doLogin()} /></div>
          <button className="login-btn" onClick={doLogin} disabled={loginLoading}>{loginLoading ? "[ AUTHENTICATING... ]" : "[ AUTHENTICATE ]"}</button>
          {loginError && <div className="login-error">{loginError}</div>}
          {storeConflict && (
            <button onClick={async () => { await clearE2EEStores(); }} style={{
              marginTop: 10, width: "100%", padding: "8px", background: "rgba(255,49,49,0.1)",
              border: "1px solid rgba(255,49,49,0.5)", color: "var(--rd)",
              fontFamily: "var(--mono)", fontSize: 11, cursor: "pointer", letterSpacing: "0.1em"
            }}>[ ОЧИСТИТЬ КЕШИРОВАН. ДАННЫЕ И ВОЙТИ ЗАНОВО ]</button>
          )}
        </div>
      </div>
    </>
  );

  return (
    <><style>{css}</style><MatrixRain />
      {notif && <div className="notif"><div className="notif-tag">[MSG]</div><div><div className="notif-title">{notif.title}</div><div className="notif-text">{notif.text}</div></div></div>}
      {modal === "room" && <CreateRoomModal onClose={() => setModal(null)} onSubmit={createRoom} loading={modalLoading} lang={lang} />}
      {modal === "dm" && <NewDMModal onClose={() => setModal(null)} onSubmit={createDM} loading={modalLoading} lang={lang} />}

      <div className={`app crt ${theme === "light" ? "light-theme" : theme === "cyberpunk" ? "cyberpunk-theme" : theme === "midnight" ? "midnight-theme" : theme === "amber" ? "amber-theme" : theme === "red" ? "red-theme" : theme === "paper" ? "paper-theme" : theme === "ocean" ? "ocean-theme" : theme === "rose" ? "rose-theme" : ""}${showSettings ? " settings-open" : ""}`}>
        <div className="sidebar">
          <div className="sb-logo">NXS</div>
          <div className={`sb-icon ${activeView === "chat" && !showSettings ? "active" : ""}`} title={lang === "ru" ? "КАНАЛЫ" : "CHANNELS"} onClick={() => { setActiveView("chat"); setShowSettings(false); }}>◈</div>
          {isAdminUser && (
            <div className={`sb-icon ${activeView === "admin" ? "active" : ""}`} title={lang === "ru" ? "АДМИН" : "ADMIN"}
              style={{ color: activeView === "admin" ? "var(--am)" : undefined, borderColor: activeView === "admin" ? "var(--am)" : undefined }}
              onClick={() => { setActiveView("admin"); setShowSettings(false); }}>⚡</div>
          )}
          <div className={`sb-icon ${showSettings ? "active" : ""}`} title={lang === "ru" ? "НАСТРОЙКИ" : "SETTINGS"} onClick={() => { setShowSettings(p => !p); setActiveView("chat"); }}>⚙</div>
          <div className="sb-div" style={{ marginTop: "auto" }} />
          <div className="sb-user" title={myUserId} onClick={() => setShowSettings(p => !p)} style={{padding:0,overflow:"hidden"}}>
          {(() => { const url = getAvatarUrl(client, myUserId); return url ? <img className="av-img" src={url} alt="" onError={e=>e.target.style.display="none"} /> : initials(myUserId); })()}
        </div>
        </div>

        <div className={`rooms${mobileRoomsOpen ? " mobile-open" : ""}`} onClick={e => { if (e.target === e.currentTarget) setMobileRoomsOpen(false); }}>
          <div className="rooms-header">
            <div className="rooms-title">NEXUS <span>MESH</span></div>
            <div className="search-box">
              <span style={{ color: "var(--gd)", fontSize: 12 }}>/&gt;</span>
              <input placeholder="search..." value={search} onChange={e => setSearch(e.target.value)} autoComplete="off" />
            </div>
          </div>
          <div className="rooms-list">
            {syncing && <div style={{ padding: "12px", fontSize: 10, color: "var(--gd)", letterSpacing: "0.1em" }}>SYNCING<span className="blink">_</span></div>}

            {/* PUBLIC ROOMS */}
            <div className="sec-label" style={{color:"var(--g)"}}>
              {lang==="ru"?"ОБЩИЕ":"PUBLIC"}
              {isAdminUser && <span className="sec-add" title={lang==="ru"?"Новая публичная комната":"New public channel"} onClick={() => setModal("room")}>⊕</span>}
            </div>
            {publicRooms.length === 0 && <div style={{padding:"4px 14px",fontSize:10,color:"#005510"}}>{lang==="ru"?"нет комнат":"no rooms"}</div>}
            {publicRooms.map(r => {
              const name = getRoomName(r, myUserId); const u = unread[r.roomId] || 0;
              const myLevel = r.getMember?.(myUserId)?.powerLevel || 0;
              const canManage = isAdminUser || myLevel >= 100;
              return (
                <div key={r.roomId} className={`room-item ${activeRoomId === r.roomId ? "active" : ""}`}
                  onClick={() => selectRoom(r.roomId)}
                  style={{position:"relative"}}
                  onMouseOver={e=>e.currentTarget.querySelector(".room-actions")&&(e.currentTarget.querySelector(".room-actions").style.opacity="1")}
                  onMouseOut={e=>e.currentTarget.querySelector(".room-actions")&&(e.currentTarget.querySelector(".room-actions").style.opacity="0")}>
                  <span className="room-sigil" style={{color:"var(--g)"}}>⊞</span>
                  <div className="room-body"><div className="room-name">{name}</div><div className="room-preview">{getLastMsg(r)}</div></div>
                  <div className="room-meta" style={{visibility: canManage ? undefined : undefined}}>
                    <div className="room-time">{fmtTime(r.getLastActiveTimestamp())}</div>
                    {u > 0 && <div className="room-unread">{u}</div>}
                  </div>
                  {canManage && (
                    <button className="room-gear"
                      onClick={e=>{ e.stopPropagation(); setActiveRoomId(r.roomId); setShowRoomSettings(true); }}
                      style={{marginLeft:4,background:"none",border:"1px solid var(--bor)",color:"var(--gd)",cursor:"pointer",fontSize:11,padding:"2px 6px",lineHeight:1,opacity:0,transition:"opacity 0.15s",flexShrink:0}}>⚙</button>
                  )}
                </div>
              );
            })}

            {/* PRIVATE ROOMS */}
            <div className="sec-label" style={{color:"var(--am)"}}>
              {lang==="ru"?"ПРИВАТНЫЕ":"PRIVATE"}
              <span className="sec-add" style={{color:"var(--am)"}} title={lang==="ru"?"Новая приватная комната":"New private channel"} onClick={() => setModal("room")}>⊕</span>
            </div>
            {privateRooms.length === 0 && <div style={{padding:"4px 14px",fontSize:10,color:"#005510"}}>{lang==="ru"?"нет комнат":"no rooms"}</div>}
            {privateRooms.map(r => {
              const name = getRoomName(r, myUserId); const u = unread[r.roomId] || 0;
              const myLevel = r.getMember?.(myUserId)?.powerLevel || 0;
              const canManage = myLevel >= 50 || isAdminUser;
              const isEnc = clientRef.current?.isRoomEncrypted?.(r.roomId) ?? false;
              return (
                <div key={r.roomId} className={`room-item ${activeRoomId === r.roomId ? "active" : ""}`}
                  onClick={() => selectRoom(r.roomId)}
                  style={{position:"relative"}}
                  onMouseOver={e=>e.currentTarget.querySelector(".room-actions")&&(e.currentTarget.querySelector(".room-actions").style.opacity="1")}
                  onMouseOut={e=>e.currentTarget.querySelector(".room-actions")&&(e.currentTarget.querySelector(".room-actions").style.opacity="0")}>
                  <span className="room-sigil" style={{color: isEnc ? "var(--am)" : "var(--gd)"}}>{ isEnc ? "🔒" : "💬"}</span>
                  <div className="room-body"><div className="room-name">{name}</div><div className="room-preview">{getLastMsg(r)}</div></div>
                  <div className="room-meta">
                    <div className="room-time">{fmtTime(r.getLastActiveTimestamp())}</div>
                    {u > 0 && <div className="room-unread">{u}</div>}
                  </div>
                  {canManage && (
                    <button className="room-gear"
                      onClick={e=>{ e.stopPropagation(); setActiveRoomId(r.roomId); setShowRoomSettings(true); }}
                      style={{marginLeft:4,background:"none",border:"1px solid var(--bor)",color:"var(--am)",cursor:"pointer",fontSize:11,padding:"2px 6px",lineHeight:1,opacity:0,transition:"opacity 0.15s",flexShrink:0}}>⚙</button>
                  )}
                </div>
              );
            })}

            {/* DMs */}
            <div className="sec-label" style={{color:"var(--cy)"}}>
              {lang==="ru"?"ЛИЧНЫЕ":"DIRECT"}
              <span className="sec-add" style={{color:"var(--cy)"}} title="New DM" onClick={() => setModal("dm")}>⊕</span>
            </div>
            {dms.length === 0 && <div style={{padding:"4px 14px",fontSize:10,color:"#005510"}}>{lang==="ru"?"нет диалогов":"no chats"}</div>}
            {dms.map(r => {
              const name = getRoomName(r, myUserId); const u = unread[r.roomId] || 0;
              const otherId = r.getJoinedMembers().find(m => m.userId !== myUserId)?.userId;
              const otherMxc = otherId ? (r.getMember(otherId)?.getMxcAvatarUrl?.() || client?.getUser(otherId)?.avatarUrl) : null;
              const otherAvUrl = mxcToHttp(client, otherMxc);
              return (
                <div key={r.roomId} className={`room-item ${activeRoomId === r.roomId ? "active" : ""}`}
                  onClick={() => selectRoom(r.roomId)}
                  style={{position:"relative"}}
                  onMouseOver={e=>{ const g=e.currentTarget.querySelector(".room-gear"); if(g) g.style.opacity="1"; }}
                  onMouseOut={e=>{ const g=e.currentTarget.querySelector(".room-gear"); if(g) g.style.opacity="0"; }}>
                  <div style={{width:20,height:20,border:"1px solid var(--bor)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontFamily:"var(--disp)",color:"var(--cy)",overflow:"hidden",flexShrink:0}}>
                    {otherAvUrl ? <img src={otherAvUrl} style={{width:"100%",height:"100%",objectFit:"cover"}} alt="" onError={e=>e.target.style.display="none"} /> : initials(name)}
                  </div>
                  <div className="room-body"><div className="room-name" style={{color:"var(--cy)"}}>{name}</div><div className="room-preview">{getLastMsg(r)}</div></div>
                  <div className="room-meta">
                    <div className="room-time">{fmtTime(r.getLastActiveTimestamp())}</div>
                    {u > 0 && <div className="room-unread">{u}</div>}
                  </div>
                  <button className="room-gear"
                    onClick={e=>{ e.stopPropagation(); setActiveRoomId(r.roomId); setShowRoomSettings(true); }}
                    style={{marginLeft:4,background:"none",border:"1px solid var(--bor)",color:"var(--cy)",cursor:"pointer",fontSize:11,padding:"2px 6px",lineHeight:1,opacity:0,transition:"opacity 0.15s",flexShrink:0}}>⚙</button>
                </div>
              );
            })}
          </div>
        </div>

        {activeView === "admin" ? (
          <AdminPanel client={client} myUserId={myUserId} lang={lang} />
        ) : activeRoom ? (
          <div className="chat">
            <ChatRain mode={rainMode} themeColor={
              theme==="cyberpunk"?"cyan":theme==="amber"?"amber":theme==="red"?"red":"default"
            } />
            <div className="chat-header" style={{position:"relative",zIndex:2}}>
              {/* Row 1: back + name + topic */}
              <div className="chat-header-row1">
                <button className="mobile-back" onClick={() => { setMobileView("rooms"); setMobileRoomsOpen(true); }}>◂</button>
                <span className="ch-prefix">{isDM(activeRoom) ? "@" : "#"}</span>
                <span className="ch-name">{getRoomName(activeRoom, myUserId)}</span>
                {roomTopic && <span className="ch-topic">— {roomTopic}</span>}
                <span className="ch-sub">{t.matrix}:<span>{HOMESERVER.replace("https://","")}</span></span>
                {activeRoom && (clientRef.current?.isRoomEncrypted?.(activeRoomId) ?? false)
                  ? <button className="e2ee-badge" onClick={() => setShowE2EEInfo(p=>!p)} title={lang==="ru"?"Шифрование E2EE":"E2EE Encryption"} style={{background:"none",border:"1px solid var(--bor)",cursor:"pointer",padding:"3px 6px",display:"flex",alignItems:"center",gap:3,flexShrink:0}}>
                      <svg width="11" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    </button>
                  : null}
              </div>
              {/* Row 2: action buttons */}
              <div className="chat-header-row2">
                {!isDM(activeRoom) && (
                  <button className={`hbtn ${showMembers ? "on" : ""}`} title={lang==="ru"?"Участники":"Members"} onClick={() => setShowMembers(p => !p)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                  </button>
                )}
                {(clientRef.current?.isRoomEncrypted?.(activeRoomId) ?? false) && (<>
                <button className="hbtn" title={lang==="ru"?"Аудиозвонок":"Voice call"} onClick={async () => {
                  if (isDM(activeRoom)) {
                    startCall(activeRoomId, false);
                    sendCallMemberEvent(clientRef.current, activeRoomId, true).catch(()=>{});
                    sendCallNotify(clientRef.current, activeRoomId).catch(()=>{});
                  } else {
                    const rName = getRoomName(activeRoom, myUserId);
                    clientRef.current?.sendEvent(activeRoomId, CALL_MSG.GROUP_CALL, { status:"started", roomName:rName, video:false }).catch(()=>{});
                    setJitsiCall({ roomId: activeRoomId, roomName: rName, video: false });
                  }
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5 19.79 19.79 0 0 1 1.61 4.9 2 2 0 0 1 3.6 2.69h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.3a16 16 0 0 0 6 6l.92-.92a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.5 18"/></svg>
                </button>
                <button className="hbtn" title={lang==="ru"?"Видеозвонок":"Video call"} onClick={async () => {
                  if (isDM(activeRoom)) {
                    startCall(activeRoomId, true);
                    sendCallMemberEvent(clientRef.current, activeRoomId, true).catch(()=>{});
                    sendCallNotify(clientRef.current, activeRoomId).catch(()=>{});
                  } else {
                    const rName = getRoomName(activeRoom, myUserId);
                    clientRef.current?.sendEvent(activeRoomId, CALL_MSG.GROUP_CALL, { status:"started", roomName:rName, video:true }).catch(()=>{});
                    setJitsiCall({ roomId: activeRoomId, roomName: rName, video: true });
                  }
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>
                </button>
                </>)}
                <button className={`hbtn ${showRoomSettings ? "on" : ""}`} title={lang === "ru" ? "Настройки комнаты" : "Room settings"} onClick={() => setShowRoomSettings(p => !p)}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
                </button>
                <button className={`hbtn ${showSettings ? "on" : ""}`} title={lang === "ru" ? "Главное меню" : "Main menu"} onClick={() => { setShowSettings(p => !p); setActiveView("chat"); }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
                </button>
              </div>
            </div>
            <div className="msgs" ref={msgsRef} onScroll={e => { if (e.target.scrollTop < 80) loadMoreHistory(); }} style={{position:"relative", zIndex:1,
              "--chat-font": font==="courier"?"'Courier New',Courier,monospace":font==="fira"?"'Fira Code','Fira Mono',monospace":font==="jetbrains"?"'JetBrains Mono','Fira Code',monospace":font==="space"?"'Space Mono',monospace":font==="ubuntu"?"'Ubuntu Mono',monospace":"'Share Tech Mono',monospace",
              "--chat-size": fontSize==="sm"?"12px":fontSize==="lg"?"16px":fontSize==="xl"?"18px":"14px"
            }}>
              <div className="day-sep" style={{position:"relative",zIndex:1}}>{t.sessionStart} // {fmtDate(Date.now())}</div>
              
              {messages.map((m, i) => {
                // System message (terminal command output)
                if (m.system) return (
                  <div key={m.id} className="sys-msg">
                    <span style={{color:"var(--gd)",fontSize:9,letterSpacing:"0.1em",marginRight:8}}>{new Date(m.ts).toLocaleTimeString("ru",{hour:"2-digit",minute:"2-digit"})}</span>
                    {m.body}
                  </div>
                );
                const showAv = !m.own && (i === 0 || messages[i - 1]?.sender !== m.sender || messages[i - 1]?.own || messages[i-1]?.system);
                const myName = shortName(myUserId);
                const mentionsMe = !m.own && ((m.body||"").toLowerCase().includes(myName.toLowerCase()+":") || (m.body||"").includes("@"+myUserId));
                return (
                  <div key={m.id} id={`msg-${m.id}`} className={`msg-row ${m.own ? "own" : ""}`}
                    onContextMenu={e => { e.preventDefault(); setMsgCtx({msg:m, x:e.clientX, y:e.clientY}); }}>
                    <div className={`msg-av ${showAv && !m.own ? "" : "ghost"}`}>
                      {(() => {
                        const roomObj = clientRef.current?.getRoom(activeRoomId);
                        const mxc = roomObj?.getMember(m.sender)?.getMxcAvatarUrl?.() || clientRef.current?.getUser(m.sender)?.avatarUrl;
                        const url = mxcToHttp(clientRef.current, mxc);
                        return url ? <img className="av-img" src={url} alt="" onError={e=>e.target.style.display="none"} /> : initials(m.senderName);
                      })()}
                    </div>
                    <div className="msg-wrap">
                      {showAv && !m.own && <div className="msg-who" style={{cursor:"pointer",opacity:mutedUsers.includes(m.sender)?0.45:1}}
                        onClick={e => setUserMenu({userId:m.sender, displayName:m.senderName, x:e.clientX, y:e.clientY})}
                        onContextMenu={e => {e.preventDefault(); setUserMenu({userId:m.sender, displayName:m.senderName, x:e.clientX, y:e.clientY});}}
                      >{shortName(m.senderName)}{mutedUsers.includes(m.sender)&&<span style={{marginLeft:4,fontSize:9}}>🔕</span>}</div>}
                      <div className={`msg-bubble ${m.own ? "own" : "other"}`} style={{
                          padding: m.msgtype==="m.image"||m.msgtype==="m.file"?"4px":undefined,
                          borderLeft: mentionsMe ? "3px solid var(--g)" : undefined,
                          background: mentionsMe ? "rgba(0,255,65,0.07)" : undefined,
                          boxShadow: mentionsMe ? "inset 0 0 12px rgba(0,255,65,0.08), 0 0 8px var(--glow)" : undefined,
                        }}>
                        {m.msgtype === "m.call"
                          ? <div style={{display:"flex",alignItems:"center",gap:8,padding:"2px 0",opacity:m.callMissed?0.6:1}}>
                              <span style={{fontSize:16}}>{m.callType==="video"?"📹":"📞"}</span>
                              <div style={{display:"flex",flexDirection:"column",gap:1}}>
                                <span style={{fontSize:11,fontWeight:"bold",color:m.callMissed?"#ff4444":"inherit"}}>
                                  {m.callDirection==="outgoing"
                                    ? (lang==="ru"?"Исходящий":"Outgoing")
                                    : m.callMissed
                                      ? (lang==="ru"?"Пропущенный":"Missed")
                                      : (lang==="ru"?"Входящий":"Incoming")
                                  }
                                  {" "}{m.callType==="video"?(lang==="ru"?"видеозвонок":"video call"):(lang==="ru"?"звонок":"call")}
                                </span>
                                {m.callDuration && <span style={{fontSize:9,color:"var(--gd)",opacity:0.8}}>{lang==="ru"?"длительность":"duration"}: {m.callDuration}</span>}
                              </div>
                            </div>
                          : m.msgtype === "m.emote"
                          ? <span style={{color:"var(--cy)",fontStyle:"italic"}}>* {m.senderName} {m.body}</span>
                          : m.fileInfo?.format === "m.poll"
                          ? (() => {
                              const poll = m.fileInfo.pollData || {};
                              const question = poll.question || m.body;
                              const options = poll.options || [];
                              const totalVotes = options.reduce((s, o) => s + (m.reactions[o.emoji]?.count || 0), 0);
                              return (
                                <div className="poll-widget">
                                  <div className="poll-question">{question}</div>
                                  <div className="poll-meta">
                                    {poll.anonymous ? (lang==="ru"?"Анонимное голосование":"Anonymous poll") : (lang==="ru"?"Публичное голосование":"Public poll")}
                                    {poll.multiVote ? " · " + (lang==="ru"?"несколько вариантов":"multiple choice") : ""}
                                  </div>
                                  {options.map((o, idx) => {
                                    const votes = m.reactions[o.emoji]?.count || 0;
                                    const pct = totalVotes > 0 ? Math.round(votes / totalVotes * 100) : 0;
                                    const myVote = m.reactions[o.emoji]?.senders?.includes(myUserId);
                                    const isMulti = poll.multiVote;
                                    const voters = poll.anonymous ? "" : (m.reactions[o.emoji]?.senders?.map(s=>s.replace(/^@/,"").split(":")[0]).join(", ")||"");
                                    return (
                                      <div key={idx} className={`poll-option${myVote?" voted":""}`}
                                        title={voters ? (lang==="ru"?"Проголосовали: ":"Voted: ")+voters : (lang==="ru"?"Нажми для голосования":"Click to vote")}
                                        onClick={async () => {
                                          const c = clientRef.current;
                                          if (myVote) {
                                            // unvote
                                            setMessages(prev => prev.map(msg => {
                                              if (msg.id!==m.id) return msg;
                                              const rx={...msg.reactions};
                                              const newS=(rx[o.emoji]?.senders||[]).filter(s=>s!==myUserId);
                                              if(newS.length===0){const{[o.emoji]:_,...rest}=rx;return{...msg,reactions:rest};}
                                              rx[o.emoji]={...rx[o.emoji],count:newS.length,senders:newS};
                                              return{...msg,reactions:rx};
                                            }));
                                            const evId=m.reactions[o.emoji]?.eventIds?.[myUserId];
                                            if(evId) try{await c.redactEvent(activeRoomId,evId);}catch(e){}
                                          } else {
                                            if (!isMulti) {
                                              // single choice: remove all other votes first
                                              for (const opt of options) {
                                                if(opt.emoji===o.emoji) continue;
                                                const prevId=m.reactions[opt.emoji]?.eventIds?.[myUserId];
                                                if(prevId){
                                                  setMessages(prev=>prev.map(msg=>{
                                                    if(msg.id!==m.id)return msg;
                                                    const rx={...msg.reactions};
                                                    const newS=(rx[opt.emoji]?.senders||[]).filter(s=>s!==myUserId);
                                                    if(newS.length===0){const{[opt.emoji]:_,...rest}=rx;return{...msg,reactions:rest};}
                                                    rx[opt.emoji]={...rx[opt.emoji],count:newS.length,senders:newS};
                                                    return{...msg,reactions:rx};
                                                  }));
                                                  try{await c.redactEvent(activeRoomId,prevId);}catch(e){}
                                                }
                                              }
                                            }
                                            // optimistic add
                                            setMessages(prev=>prev.map(msg=>{
                                              if(msg.id!==m.id)return msg;
                                              const rx={...msg.reactions};
                                              rx[o.emoji]=rx[o.emoji]
                                                ?{...rx[o.emoji],count:rx[o.emoji].count+1,senders:[...rx[o.emoji].senders,myUserId]}
                                                :{count:1,senders:[myUserId],eventIds:{}};
                                              return{...msg,reactions:rx};
                                            }));
                                            try{await c.sendEvent(activeRoomId,"m.reaction",{"m.relates_to":{rel_type:"m.annotation",event_id:m.id,key:o.emoji}});}catch(e){}
                                          }
                                        }}>
                                        <div className="poll-bar" style={{width:pct+"%"}} />
                                        <div className="poll-radio"><div className="poll-radio-dot"/></div>
                                        <span className="poll-option-label">{o.text}</span>
                                        <div className="poll-option-right">
                                          {totalVotes > 0 && <span className="poll-option-pct">{pct}%</span>}
                                          {!poll.anonymous && <span className="poll-option-count">{votes} {lang==="ru"?"гол.":"votes"}</span>}
                                        </div>
                                      </div>
                                    );
                                  })}
                                  <div className="poll-footer">
                                    <span>📊 {lang==="ru"?"ГОЛОСОВАНИЕ":"POLL"}</span>
                                    <span>{totalVotes} {lang==="ru"?"голос.":"votes"}</span>
                                  </div>
                                </div>
                              );
                            })()
                          : m.redacted ? <span style={{color:"var(--gd)",fontStyle:"italic",fontSize:11}}>[ {lang==="ru"?"сообщение удалено":"message deleted"} ]</span>
                          : m.fileInfo?.format === "m.sticker.gif" && m.fileInfo?.["m.sticker_url"]
                          ? <img src={m.fileInfo["m.sticker_url"]} style={{maxWidth:160,maxHeight:160,display:"block",borderRadius:0}} alt="sticker" />
                          : m.fileInfo?.format === "m.sticker"
                          ? <span className="msg-sticker">{m.body}</span>
                          : m.msgtype === "m.image" && m.url
                          ? <img className="msg-img" src={(() => { try { if (!m.url?.startsWith("mxc://")) return m.url; const p=m.url.slice(6).split("/"); return `${clientRef.current.getHomeserverUrl()}/_matrix/client/v1/media/download/${p[0]}/${p[1]}?access_token=${clientRef.current.getAccessToken()}`; } catch(e){return m.url;} })()} alt={m.body}
                              onClick={() => window.open((() => { try { if (!m.url?.startsWith("mxc://")) return m.url; const p=m.url.slice(6).split("/"); return `${clientRef.current.getHomeserverUrl()}/_matrix/client/v1/media/download/${p[0]}/${p[1]}?access_token=${clientRef.current.getAccessToken()}`; } catch(e){return m.url;} })(),"_blank")} />
                          : m.msgtype === "m.file" && m.url
                          ? <div className="msg-file" onClick={() => window.open((() => { try { if (!m.url?.startsWith("mxc://")) return m.url; const p=m.url.slice(6).split("/"); return `${clientRef.current.getHomeserverUrl()}/_matrix/client/v1/media/download/${p[0]}/${p[1]}?access_token=${clientRef.current.getAccessToken()}`; } catch(e){return m.url;} })(),"_blank")}>
                              <span className="msg-file-icon">📄</span>
                              <div className="msg-file-info">
                                <div className="msg-file-name">{m.body}</div>
                                <div className="msg-file-size">{m.fileInfo?.size?(m.fileInfo.size/1024).toFixed(1)+"KB":""}</div>
                              </div>
                              <span style={{fontSize:11,color:"var(--gd)"}}>↓</span>
                            </div>
                          : (() => {
                            const body = m.body || "";
                            // If this is a reply, find original message by ID
                            if (m.replyTo) {
                              const orig = messages.find(x => x.id === m.replyTo);
                              const quoteSender = orig ? shortName(orig.senderName) : "?";
                              // Get only the actual reply text - everything after the last blank line following quotes
                              const parts = body.split("\n\n");
                              const replyText = parts[parts.length - 1]?.trim() || body.split("\n").filter(l => !l.startsWith(">") && l.trim()).pop() || body;
                              const quoteBody = orig
                                ? (orig.body || "").split("\n").filter(l => !l.startsWith("> ") && l.trim()).join(" ").trim() || orig.body
                                : body.split("\n").find(l => l.startsWith("> "))?.replace(/^> (<[^>]+>\s*)?/,"") || "";
                              return (
                                <div style={{display:"flex",flexDirection:"column",gap:6}}>
                                  <div style={{borderLeft:"3px solid var(--am)",background:"rgba(0,0,0,0.3)",padding:"6px 10px",maxWidth:360,cursor:"pointer"}}
                                    onClick={()=>{
                                      const el = document.getElementById("msg-"+m.replyTo);
                                      if(el) el.scrollIntoView({behavior:"smooth",block:"center"});
                                    }}>
                                    <div style={{fontSize:10,color:"var(--am)",fontWeight:"bold",marginBottom:3,letterSpacing:"0.05em"}}>↩ {quoteSender}</div>
                                    <div style={{fontSize:11,color:"rgba(255,255,255,0.5)",lineHeight:1.4,overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>
                                      {quoteBody.slice(0,150)}{quoteBody.length>150?"…":""}
                                    </div>
                                  </div>
                                  <span>{replyText}</span>
                                </div>
                              );
                            }
                            // Highlight "name:" mentions with amber color
                            const mentionRe = /^([a-zA-Za-яА-ЯёЁ0-9_-]+)(:\s)/;
                            const match = body.match(mentionRe);
                            if (!match) return body;
                            const name = match[1];
                            const rest = body.slice(match[0].length);
                            const isMe = name.toLowerCase() === shortName(myUserId).toLowerCase();
                            return <>
                              <span style={{
                                color: isMe ? "#00ffff" : "var(--am)",
                                fontWeight: "bold",
                                letterSpacing: "0.05em",
                                textShadow: isMe ? "0 0 8px #00ffff" : "0 0 6px var(--am)",
                                marginRight: 2,
                              }}>@{name}</span>
                              <span style={{color:"var(--gd)",marginRight:6}}>›</span>
                              {rest}
                            </>;
                          })()}
                        <span className="msg-time">{m.edited && <span style={{fontSize:9,marginRight:5,fontStyle:"italic",color:"var(--am)",opacity:1}}>{lang==="ru"?"изм.":"edited"}</span>}{m.encrypted && <span title="E2EE" style={{fontSize:9,marginRight:4,color:"var(--g)",opacity:0.7}}>🔒</span>}{fmtTime(m.ts)}</span>
                      </div>
                      {!m.redacted && m.fileInfo?.format !== "m.poll" && m.reactions && Object.keys(m.reactions).length > 0 && (
                        <div className="msg-reactions">
                          {Object.entries(m.reactions).map(([emoji, rxData]) => {
                            const {count, senders} = rxData;
                            const eventIds = rxData.eventIds || {};
                            const iMine = senders.includes(myUserId);
                            const canAdd = !m.own && !iMine;
                            // canRemove: not own msg AND I already reacted with this emoji
                            const canRemove = !m.own && iMine;
                            // find my reaction event ID by scanning all reaction events
                            const myEvId = eventIds[myUserId];
                            // opacity: only dim if: not own msg, maxed out (2 types), and didn't react this one
                            const dimmed = false;
                            return (
                              <button key={emoji}
                                className={`msg-reaction ${iMine?"own":""}`}
                                title={senders.map(s=>s.replace(/^@/,"").split(":")[0]).join(", ")}
                                onClick={async()=>{
                                  if (m.own) return;
                                  if (canRemove) {
                                    // Optimistic update: remove immediately from local state
                                    setMessages(prev => prev.map(msg => {
                                      if (msg.id !== m.id) return msg;
                                      const rx = {...msg.reactions};
                                      if (rx[emoji]) {
                                        const newSenders = rx[emoji].senders.filter(s => s !== myUserId);
                                        if (newSenders.length === 0) { const {[emoji]:_, ...rest} = rx; return {...msg, reactions: rest}; }
                                        rx[emoji] = {...rx[emoji], count: newSenders.length, senders: newSenders};
                                      }
                                      return {...msg, reactions: rx};
                                    }));
                                    // Then sync with server
                                    const room = clientRef.current.getRoom(activeRoomId);
                                    const rxEvent = room?.getLiveTimeline().getEvents().find(e =>
                                      e.getType()==="m.reaction" && !e.isRedacted?.() &&
                                      e.getSender()===myUserId &&
                                      e.getContent()?.["m.relates_to"]?.event_id===m.id &&
                                      e.getContent()?.["m.relates_to"]?.key===emoji
                                    );
                                    if (rxEvent) try { await clientRef.current.redactEvent(activeRoomId, rxEvent.getId()); } catch(e) { console.error(e); }
                                  } else if (canAdd) {
                                    // Optimistic update: add immediately to local state
                                    setMessages(prev => prev.map(msg => {
                                      if (msg.id !== m.id) return msg;
                                      const rx = {...msg.reactions};
                                      if (rx[emoji]) {
                                        rx[emoji] = {...rx[emoji], count: rx[emoji].count+1, senders: [...rx[emoji].senders, myUserId]};
                                      } else {
                                        rx[emoji] = {count:1, senders:[myUserId], eventIds:{}};
                                      }
                                      return {...msg, reactions: rx};
                                    }));
                                    try { await clientRef.current.sendEvent(activeRoomId,"m.reaction",{"m.relates_to":{rel_type:"m.annotation",event_id:m.id,key:emoji}}); } catch(e) {}
                                  }
                                }}
                                style={{cursor: m.own?"default":(canAdd||canRemove)?"pointer":"default", opacity: dimmed?0.4:1}}>
                                {emoji}<span className="msg-reaction-count">{count}</span>
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
              {typing && <div className="typing"><div className="typing-dots"><div className="typing-dot" /><div className="typing-dot" /><div className="typing-dot" /></div><span>TYPING...</span></div>}
              <div ref={endRef} />
            </div>
            <div className="input-area" style={{position:"relative"}}>
              <input type="file" id="file-upload" style={{display:"none"}} accept="image/*,application/pdf,.doc,.docx,.zip,.txt" onChange={async e => {
                const file = e.target.files[0]; if (!file || !activeRoomId || !clientRef.current) return;
                e.target.value = "";
                try {
                  const uploaded = await clientRef.current.uploadContent(file, { name: file.name, type: file.type });
                  const isImage = file.type.startsWith("image/");
                  const mxc = uploaded.content_uri || (typeof uploaded === "string" ? uploaded : null);
                  if (!mxc) throw new Error("No content_uri in upload response");
                  await clientRef.current.sendMessage(activeRoomId, isImage
                    ? { msgtype: "m.image", body: file.name, url: mxc, info: { mimetype: file.type, size: file.size } }
                    : { msgtype: "m.file", body: file.name, url: mxc, info: { mimetype: file.type, size: file.size } }
                  );
                } catch(err) { showNotif("FILE_ERROR", err.message); }
              }} />
              {/* Reply bar */}
              {replyTo && (
                <div className="quote-bar">
                  <span style={{color:"var(--gd)",fontSize:10,letterSpacing:"0.1em"}}>↩ {lang==="ru"?"ОТВЕТ":"REPLY"}</span>
                  <span style={{flex:1,color:"var(--g)",fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                    <b>{replyTo.senderName}</b>: {(() => {
                      const b = replyTo.body || "";
                      if (b.includes("\n\n")) return b.split("\n\n").pop()?.trim() || b;
                      const clean = b.split("\n").filter(l => !l.startsWith(">") && l.trim()).join(" ").trim();
                      return clean || b;
                    })()}
                  </span>
                  <span style={{cursor:"pointer",color:"var(--gd)",fontSize:14,padding:"0 4px"}} onClick={() => setReplyTo(null)}>✕</span>
                </div>
              )}
              {/* Edit bar */}
              {editingMsg && (
                <div className="quote-bar" style={{borderLeftColor:"var(--am)"}}>
                  <span style={{color:"var(--am)",fontSize:10,letterSpacing:"0.1em"}}>✎ {lang==="ru"?"РЕДАКТИРОВАНИЕ":"EDITING"}</span>
                  <span style={{flex:1,color:"var(--gd)",fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{(b => { if(!b) return ""; if(b.includes("\n\n")) return b.split("\n\n").pop()?.trim()||b; return b.split("\n").filter(l=>!l.startsWith(">")&&l.trim()).join(" ").trim()||b; })(editingMsg.body)}</span>
                  <span style={{cursor:"pointer",color:"var(--gd)",fontSize:14,padding:"0 4px"}} onClick={() => { setEditingMsg(null); setInput(""); }}>✕</span>
                </div>
              )}
              {showEmoji && (
                <EmojiPicker
                  onEmoji={e => setInput(p => p + e)}
                  onSticker={async (s, type) => {
                    try {
                      if (type === "gif") {
                        await clientRef.current.sendMessage(activeRoomId, {
                          msgtype: "m.text", body: "🎬", url: s, format: "m.sticker.gif",
                          "m.sticker_url": s
                        });
                      } else {
                        await clientRef.current.sendMessage(activeRoomId, { msgtype: "m.text", body: s, format: "m.sticker" });
                      }
                    } catch(e) { showNotif("ERROR", e.message); }
                  }}
                  onClose={() => setShowEmoji(false)}
                />
              )}
              {cmdHints.length > 0 && (
                <div style={{position:"absolute",bottom:"100%",left:0,right:0,background:"var(--pan)",
                  border:"1px solid var(--borb)",borderBottom:"none",zIndex:50,maxHeight:200,overflowY:"auto"}}>
                  {cmdHints.map(h => (
                    <div key={h.cmd} onClick={() => { setInput(h.cmd + (h.args?" ":"")); setCmdHints([]); }}
                      style={{padding:"7px 14px",cursor:"pointer",fontSize:11,display:"flex",gap:12,
                        alignItems:"center",borderBottom:"1px solid var(--bor)"}}
                      onMouseOver={e=>e.currentTarget.style.background="var(--glow)"}
                      onMouseOut={e=>e.currentTarget.style.background="none"}>
                      <span style={{color:"var(--g)",fontFamily:"var(--mono)",minWidth:100}}>{h.cmd} <span style={{color:"var(--cy)",fontSize:10}}>{h.args}</span></span>
                      <span style={{color:"var(--gd)",fontSize:10}}>{h.desc}</span>
                    </div>
                  ))}
                  <div style={{padding:"4px 14px",fontSize:9,color:"var(--gd)",opacity:0.5}}>TAB — выбрать · ESC — закрыть</div>
                </div>
              )}
              <div className="input-row">
                <span className="input-prefix">{shortName(myUserId)}@{getRoomName(activeRoom, myUserId)}:~$</span>
                <textarea className="input-field" value={input}
                  onChange={e => {
                    const v = e.target.value;
                    setInput(v);
                    if (v.startsWith("/") && !v.includes(" ")) {
                      const matches = COMMANDS.filter(c => c.cmd.startsWith(v.toLowerCase()));
                      setCmdHints(matches);
                    } else { setCmdHints([]); }
                  }}
                  onKeyDown={e => {
                    if (e.key === "Tab" && cmdHints.length > 0) {
                      e.preventDefault();
                      setInput(cmdHints[0].cmd + (cmdHints[0].args ? " " : ""));
                      setCmdHints([]);
                    } else if (e.key === "Escape") {
                      setCmdHints([]);
                    } else if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault(); sendMessage();
                    }
                  }}
                  placeholder={t.typeMsg} rows={1} />
                <button className="file-btn" title="Emoji" onClick={() => setShowEmoji(p => !p)}
                  style={{fontSize:17, borderColor: showEmoji ? "var(--g)" : undefined, color: showEmoji ? "var(--g)" : undefined}}>😊</button>
                <button className="file-btn" title={lang==="ru"?"Голосование":"Poll"}
                  onClick={() => { setPollQuestion(""); setPollOptions(["",""]); setShowPollModal(true); }}
                  style={{fontSize:15, borderColor: showPollModal ? "var(--g)" : undefined, color: showPollModal ? "var(--g)" : undefined}}>📊</button>
                <button className="file-btn" title={lang==="ru"?"Прикрепить":"Attach"} onClick={() => document.getElementById("file-upload").click()}>📎</button>
              <button className="send-btn" onClick={sendMessage} disabled={!input.trim()}>▶</button>
              </div>
              <div className="input-hint">{t.enterSend}</div>
              {showPollModal && (
                <div style={{position:"absolute",bottom:"calc(100% + 4px)",left:0,right:0,
                  background:"var(--pan)",border:"1px solid var(--borb)",padding:16,zIndex:60,
                  boxShadow:"0 -4px 20px rgba(0,0,0,0.4)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                    <span style={{fontSize:11,color:"var(--g)",fontFamily:"var(--disp)",letterSpacing:"0.1em"}}>📊 {lang==="ru"?"НОВОЕ ГОЛОСОВАНИЕ":"NEW POLL"}</span>
                    <span style={{cursor:"pointer",color:"var(--gd)",fontSize:14}} onClick={()=>setShowPollModal(false)}>✕</span>
                  </div>
                  <input value={pollQuestion} onChange={e=>setPollQuestion(e.target.value)}
                    placeholder={lang==="ru"?"Вопрос...":"Question..."}
                    style={{width:"100%",background:"var(--inp)",border:"1px solid var(--bor)",color:"var(--g)",
                      fontFamily:"var(--mono)",fontSize:12,padding:"6px 8px",outline:"none",
                      boxSizing:"border-box",marginBottom:8}} />
                  {pollOptions.map((opt, i) => (
                    <div key={i} style={{display:"flex",gap:6,marginBottom:6}}>
                      <span style={{fontSize:12,color:"var(--gd)",padding:"6px 0",minWidth:16,textAlign:"center"}}>
                        {["🅐","🅑","🅒","🅓","🅔","🅕","🅖","🅗"][i]}
                      </span>
                      <input value={opt} onChange={e=>setPollOptions(p=>{const n=[...p];n[i]=e.target.value;return n;})}
                        placeholder={lang==="ru"?`Вариант ${i+1}`:`Option ${i+1}`}
                        style={{flex:1,background:"var(--inp)",border:"1px solid var(--bor)",color:"var(--g)",
                          fontFamily:"var(--mono)",fontSize:11,padding:"5px 8px",outline:"none"}} />
                      {pollOptions.length > 2 && (
                        <span style={{cursor:"pointer",color:"var(--gd)",padding:"5px",fontSize:12}}
                          onClick={()=>setPollOptions(p=>p.filter((_,j)=>j!==i))}>✕</span>
                      )}
                    </div>
                  ))}
                  <div style={{display:"flex",flexDirection:"column",gap:6,marginTop:10,padding:"8px 0",borderTop:"1px solid var(--bor)"}}>
                    <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:11,color:"var(--gd)"}}>
                      <input type="checkbox" checked={!!pollAnon} onChange={e=>setPollAnon(e.target.checked)} style={{accentColor:"var(--g)",cursor:"pointer"}} />
                      {lang==="ru"?"Анонимное голосование":"Anonymous voting"}
                    </label>
                    <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:11,color:"var(--gd)"}}>
                      <input type="checkbox" checked={!!pollMulti} onChange={e=>setPollMulti(e.target.checked)} style={{accentColor:"var(--g)",cursor:"pointer"}} />
                      {lang==="ru"?"Несколько вариантов":"Multiple choice"}
                    </label>
                  </div>
                  <div style={{display:"flex",gap:8,marginTop:8}}>
                    {pollOptions.length < 8 && (
                      <button onClick={()=>setPollOptions(p=>[...p,""])}
                        style={{flex:1,padding:"6px",background:"var(--inp)",border:"1px solid var(--bor)",
                          color:"var(--gd)",fontFamily:"var(--mono)",fontSize:10,cursor:"pointer"}}>
                        + {lang==="ru"?"вариант":"option"}
                      </button>
                    )}
                    <button onClick={async () => {
                      const q = pollQuestion.trim();
                      const opts = pollOptions.map(o=>o.trim()).filter(Boolean);
                      if (!q || opts.length < 2) return;
                      const letters = ["🅐","🅑","🅒","🅓","🅔","🅕","🅖","🅗"];
                      const options = opts.map((t,i)=>({text:t, emoji:letters[i]}));
                      const body = "📊 " + q + "\n" + options.map(o=>o.emoji+" "+o.text).join("\n");
                      try {
                        await clientRef.current.sendEvent(activeRoomId, "m.room.message", {
                          msgtype:"m.text", body, format:"m.poll",
                          pollData:{question:q, options, anonymous:!!pollAnon, multiVote:!!pollMulti}
                        });
                        setShowPollModal(false);
                      } catch(e) { alert(e.message); }
                    }} disabled={!pollQuestion.trim() || pollOptions.filter(o=>o.trim()).length < 2}
                      style={{flex:2,padding:"6px",background:"rgba(0,255,65,0.1)",border:"1px solid var(--g)",
                        color:"var(--g)",fontFamily:"var(--disp)",fontSize:10,cursor:"pointer",letterSpacing:"0.08em"}}>
                      [ {lang==="ru"?"СОЗДАТЬ":"CREATE"} ]
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="chat">
            {syncing
              ? <div className="loading"><div className="spinner" /><div className="status-text">{t.syncing}<span className="blink">_</span></div></div>
              : <div className="empty"><div className="status-text">{t.selectChannel}<span className="blink">_</span></div></div>}
          </div>
        ) }

        {showRoomSettings && activeRoom && (
          <RoomSettingsModal
            room={activeRoom} client={client} myUserId={myUserId} lang={lang}
            isServerAdmin={isAdminUser}
            homeserver={HOMESERVER}
            onClose={() => setShowRoomSettings(false)}
            onTopicChange={(t) => setRoomTopic(t)}
            onLeave={() => { setShowRoomSettings(false); setActiveRoomId(null); refreshRooms(); }}
            onDeleteRoom={(roomId) => { setShowRoomSettings(false); setActiveRoomId(null); setRooms(prev => prev.filter(r => r.roomId !== roomId)); }}
          />
        )}
        {msgCtx && (
          <MsgContextMenu
            msg={msgCtx.msg} x={msgCtx.x} y={msgCtx.y}
            onClose={() => setMsgCtx(null)}
            client={client} myUserId={myUserId} activeRoomId={activeRoomId} lang={lang}
            canDelete={msgCtx.msg.own || (activeRoom?.getMember?.(myUserId)?.powerLevel >= 50)}
            onReply={(msg) => { setReplyTo(msg); }}
            onEdit={(msg) => { const b=msg.body||""; const clean=(b => { if(!b) return ""; if(b.includes("\n\n")) return b.split("\n\n").pop()?.trim()||b; return b.split("\n").filter(l=>!l.startsWith(">")&&l.trim()).join(" ").trim()||b; })(b); setEditingMsg(msg); setInput(clean); }}
            onForward={(msg) => setForwardMsg(msg)}
            onOptimisticReaction={(msgId, emoji, userId, action) => {
              setMessages(prev => prev.map(m => {
                if (m.id !== msgId) return m;
                const rx = {...m.reactions};
                if (action === "remove") {
                  if (!rx[emoji]) return m;
                  const newSenders = rx[emoji].senders.filter(s => s !== userId);
                  if (newSenders.length === 0) { const {[emoji]:_, ...rest} = rx; return {...m, reactions: rest}; }
                  rx[emoji] = {...rx[emoji], count: newSenders.length, senders: newSenders};
                } else {
                  rx[emoji] = rx[emoji]
                    ? {...rx[emoji], count: rx[emoji].count+1, senders:[...rx[emoji].senders, userId]}
                    : {count:1, senders:[userId], eventIds:{}};
                }
                return {...m, reactions: rx};
              }));
            }}
          />
        )}
        {forwardMsg && (
          <ForwardModal
            msg={forwardMsg} client={client} myUserId={myUserId} lang={lang}
            onClose={() => setForwardMsg(null)}
            rooms={rooms}
          />
        )}
        {profileModal && (
          <ProfileModal
            userId={profileModal} client={client} myUserId={myUserId} lang={lang}
            onClose={() => setProfileModal(null)}
            onStartDM={async (uid) => { setProfileModal(null); await createDM(uid); }}
            isAdmin={isAdminUser} homeserver={HOMESERVER}
          />
        )}
        {userMenu && (
          <UserContextMenu
            userId={userMenu.userId} displayName={userMenu.displayName}
            x={userMenu.x} y={userMenu.y}
            onClose={() => setUserMenu(null)}
            client={client} myUserId={myUserId} activeRoomId={activeRoomId} lang={lang}
            onStartDM={async (uid) => { setUserMenu(null); await createDM(uid); }}
            onMention={(uid, name) => { setInput(p => (p ? p+" " : "") + name + ": "); setUserMenu(null); }}
            onMuteChange={(newList) => setMutedUsers(newList)}
            onProfile={(uid) => { setUserMenu(null); setProfileModal(uid); }}
          />
        )}
        {activeRoom && !isDM(activeRoom) && showMembers && !showSettings && (
          <>
          <div className="members mobile-open">
            <div className="members-title" style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span>NODES // <span>{members.length}</span></span>
              <button onClick={() => setShowMembers(false)} style={{background:"none",border:"none",color:"var(--gd)",cursor:"pointer",fontSize:16,lineHeight:1,padding:"0 4px"}}>✕</button>
            </div>
            <div className="m-sec">ONLINE</div>
            {members.filter(m => m.presence === "online").sort((a,b) => a.userId===myUserId?-1:b.userId===myUserId?1:shortName(a.name).localeCompare(shortName(b.name))).map(m => (
              <div key={m.userId} className="m-item" style={{cursor:"pointer"}}
                onClick={e => setUserMenu({userId:m.userId, displayName:m.name, x:e.clientX, y:e.clientY})}
                onContextMenu={e => {e.preventDefault(); setUserMenu({userId:m.userId, displayName:m.name, x:e.clientX, y:e.clientY});}}>
                <div className="m-dot" style={{ background: "var(--g)", boxShadow: "0 0 4px var(--g)" }} />
                <div className="m-name" style={{opacity:mutedUsers.includes(m.userId)?0.5:1}}>{shortName(m.name)}{mutedUsers.includes(m.userId)&&<span style={{marginLeft:4,fontSize:9}}>🔕</span>}</div>
                {m.userId === myUserId && <div className="m-role">you</div>}
              </div>
            ))}
            <div className="m-sec">OFFLINE</div>
            {members.filter(m => m.presence !== "online").sort((a,b) => a.userId===myUserId?-1:b.userId===myUserId?1:shortName(a.name).localeCompare(shortName(b.name))).map(m => (
              <div key={m.userId} className="m-item" style={{opacity:0.6,cursor:"pointer"}}
                onClick={e => setUserMenu({userId:m.userId, displayName:m.name, x:e.clientX, y:e.clientY})}
                onContextMenu={e => {e.preventDefault(); setUserMenu({userId:m.userId, displayName:m.name, x:e.clientX, y:e.clientY});}}>
                <div className="m-dot" style={{ background: "var(--dk)" }} />
                <div className="m-name" style={{opacity:mutedUsers.includes(m.userId)?0.4:1}}>{shortName(m.name)}{mutedUsers.includes(m.userId)&&<span style={{marginLeft:4,fontSize:9}}>🔕</span>}</div>
                {m.userId === myUserId && <div className="m-role">you</div>}
              </div>
            ))}
          </div>
          </>
        )}

        {showE2EEInfo && activeRoom && (
          <div className="modal-bg" onClick={() => setShowE2EEInfo(false)}>
            <div className="modal" onClick={e => e.stopPropagation()} style={{maxWidth:340,width:"90%"}}>
              <div style={{fontFamily:"var(--disp)",fontSize:11,fontWeight:700,color:"var(--g)",letterSpacing:"0.15em",marginBottom:16,display:"flex",alignItems:"center",gap:8}}>
                <svg width="14" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                {lang==="ru" ? "// ШИФРОВАНИЕ" : "// ENCRYPTION"}
              </div>
              <E2EEStatus client={client} lang={lang} />
              <div style={{marginTop:12,fontSize:10,color:"var(--gd)",lineHeight:1.6}}>
                {lang==="ru"
                  ? "Все сообщения зашифрованы E2EE. Сервер не может прочитать содержимое."
                  : "All messages are E2EE encrypted. The server cannot read the content."}
              </div>
              <button onClick={() => setShowE2EEInfo(false)} style={{marginTop:16,width:"100%",padding:"7px",background:"var(--glow)",border:"1px solid var(--bor)",color:"var(--g)",fontFamily:"var(--mono)",fontSize:11,cursor:"pointer",letterSpacing:"0.1em"}}>[ {lang==="ru"?"ЗАКРЫТЬ":"CLOSE"} ]</button>
            </div>
          </div>
        )}
        {showSettings && <SettingsPanel myUserId={myUserId} onLogout={doLogout} onClose={() => setShowSettings(false)} activeRoom={activeRoom} client={client} lang={lang} setLang={setLang} theme={theme} setTheme={setTheme} notifs={notifs} setNotifs={setNotifs} font={font} setFont={setFont} fontSize={fontSize} setFontSize={setFontSize} rainMode={rainMode} setRainMode={(v)=>{setRainMode(v);localStorage.setItem("nexus_rain",v);}} />}

        {/* Mobile bottom navigation */}
        <nav className="mobile-nav">
          <button className={`mobile-nav-btn${mobileView==="rooms"?" active":""}`} onClick={() => { setMobileRoomsOpen(true); setMobileView("rooms"); setShowSettings(false); }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 6h18M3 12h18M3 18h18"/></svg>
            ЧАТЫ
          </button>
          <button className={`mobile-nav-btn${mobileView==="chat"?" active":""}`} onClick={() => { setMobileRoomsOpen(false); setMobileView("chat"); setShowSettings(false); }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            {activeRoom ? getRoomName(activeRoom, myUserId).slice(0,10) : "ЧАТ"}
          </button>
          {isAdminUser && (
            <button className={`mobile-nav-btn${activeView==="admin"?" active":""}`} onClick={() => { setActiveView("admin"); setShowSettings(false); setMobileRoomsOpen(false); setMobileView("chat"); }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              ADMIN
            </button>
          )}
          <button className="mobile-nav-btn" onClick={() => setShowSettings(true)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
            МЕНЮ
          </button>
        </nav>

        {activeCall && (
          <NexusCall callState={activeCall} lang={lang} client={client} myUserId={myUserId} pcRef={pcRef} onHangup={() => hangupCall(true)}
              peerMuted={peerMuted}
              onMuteChange={async (state) => {
                try {
                  await clientRef.current.sendEvent(callRoomRef.current, CALL_MSG.MUTE, {
                    call_id: callIdRef.current, version: 1,
                    audio: state.audio, video: state.video
                  });
                } catch(e) {}
              }}
            />
        )}
        {incomingCall && !activeCall && !window.Capacitor?.isNativePlatform() && (
          <IncomingCallNotif
            info={incomingCall} lang={lang}
            onAnswer={async (withVideo) => {
              if (incomingCall.matrixRTC) {
                try {
                  const { url, jwt } = await getMatrixRTCToken(clientRef.current, incomingCall.roomId);
                  await sendCallMemberEvent(clientRef.current, incomingCall.roomId, true);
                  const rm = clientRef.current?.getRoom(incomingCall.roomId);
                  const rName = rm ? getRoomName(rm, myUserId) : incomingCall.peerName;
                  setIncomingCall(null);
                  setJitsiCall({ roomId: incomingCall.roomId, roomName: rName, video: withVideo, lkToken: jwt, lkUrl: url, matrixRTC: true });
                } catch(e) { console.error("[MatrixRTC] Answer failed:", e); }
              } else {
                answerCall(incomingCall, withVideo);
              }
            }}
            onReject={() => {
              if (!incomingCall.matrixRTC) {
                clientRef.current?.sendEvent(incomingCall.roomId, CALL_MSG.HANGUP, { call_id: incomingCall.callId, version: 1, reason: "user_hangup" }).catch(()=>{});
              }
              setIncomingCall(null);
            }}
          />
        )}
        {/* Incoming group call notification */}
        {incomingGroupCall && !jitsiCall && (
          <div className="incoming-call" style={{minWidth:280}}>
            <div className="incoming-call-name">📞 {incomingGroupCall.peerName}</div>
            <div className="incoming-call-sub" style={{marginBottom:8}}>
              {incomingGroupCall.video
                ? (lang==="ru"?"ГРУППОВОЙ ВИДЕОЗВОНОК":"GROUP VIDEO CALL")
                : (lang==="ru"?"ГРУППОВОЙ АУДИОЗВОНОК":"GROUP AUDIO CALL")}
              {" · "}{incomingGroupCall.roomName}
            </div>
            <div className="incoming-call-btns">
              <button className="call-btn answer" onClick={() => {
                setJitsiCall({ roomId: incomingGroupCall.roomId, roomName: incomingGroupCall.roomName, video: false });
                setIncomingGroupCall(null);
              }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="8" y1="22" x2="16" y2="22"/></svg>
              </button>
              {incomingGroupCall.video && (
                <button className="call-btn answer" onClick={() => {
                  setJitsiCall({ roomId: incomingGroupCall.roomId, roomName: incomingGroupCall.roomName, video: true });
                  setIncomingGroupCall(null);
                }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>
                </button>
              )}
              <button className="call-btn end" onClick={() => setIncomingGroupCall(null)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
              </button>
            </div>
          </div>
        )}
        {jitsiCall && (
          <LKErrorBoundary lang={lang} onClose={() => {
            if (jitsiCall?.matrixRTC) sendCallMemberEvent(clientRef.current, jitsiCall.roomId, false).catch(()=>{});
            else clientRef.current?.sendEvent(jitsiCall.roomId, CALL_MSG.GROUP_CALL, { status:'ended' }).catch(()=>{});
            setJitsiCall(null);
          }}>
            <LiveKitCallModal
              roomId={jitsiCall.roomId} roomName={jitsiCall.roomName}
              userId={myUserId} client={client} lang={lang} video={jitsiCall.video}
              lkToken={jitsiCall.lkToken} lkUrl={jitsiCall.lkUrl}
              onClose={() => {
                if (jitsiCall?.matrixRTC) sendCallMemberEvent(clientRef.current, jitsiCall.roomId, false).catch(()=>{});
                else clientRef.current?.sendEvent(jitsiCall.roomId, CALL_MSG.GROUP_CALL, { status:'ended' }).catch(()=>{});
                setJitsiCall(null);
              }}
            />
          </LKErrorBoundary>
        )}
      </div>
    </>
  );
}
